var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempleWideCarousel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 384,
    height: 269.73,
    viewBox: "0 0 384 269.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #79bd9a;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-6 {\n        fill: #f7941e;\n      }\n\n      .cls-7 {\n        fill: #e07c0e;\n      }\n\n      .cls-8 {\n        fill: #ef4136;\n      }\n\n      .cls-9 {\n        fill: #f95e5a;\n      }\n\n      .cls-10 {\n        fill: #e02722;\n      }\n\n      .cls-11 {\n        fill: #a50f21;\n      }\n\n      .cls-12 {\n        fill: #fbb040;\n      }\n\n      .cls-13 {\n        fill: #be1e2d;\n      }\n\n      .cls-14 {\n        fill: #7a0b09;\n      }\n\n      .cls-15 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-17 {\n        fill: #8c2242;\n      }\n\n      .cls-18 {\n        fill: #d95653;\n      }\n\n      .cls-19 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-21 {\n        fill: #754c29;\n      }\n\n      .cls-22 {\n        fill: #61ad84;\n      }\n\n      .cls-23 {\n        fill: #4a996b;\n      }\n\n      .cls-24 {\n        fill: #3c2415;\n      }\n\n      .cls-25 {\n        fill: #c49a6c;\n      }\n\n      .cls-26 {\n        fill: #a0e0bd;\n      }\n\n      .cls-27 {\n        fill: #214e59;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17351",
    "data-name": "Rectangle 17351",
    className: "cls-1",
    width: 384,
    height: 269.73
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11737",
    "data-name": "Path 11737",
    className: "cls-1",
    d: "M655.155,2172.5c1.194,4.511,8.128,9.316,32.565,8.972,45.392-.64,107.2.9,109.4,9.511s49.639,6.878,86.592,8.6,100.6-15.17,56.022-22.586c-44.507-7.405-100.842-11.134-157.672-11.134-43.721,0-87.731,2.205-126.91,6.641",
    transform: "translate(-655.155 -2165.855)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.194,
    y1: 1.649,
    x2: -0.194,
    y2: 1.649,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183b4a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11880",
    "data-name": "Path 11880",
    className: "cls-1",
    d: "M2202.134,1981.935c-.942,2.375-3.973,11.3-4.136,12.2s-2.292,9.5,7,9.133c0,0,6.84-.819,4.506-11.18,0,0-3.891-12-4.219-12.7s.042-1.064-.737-1.064a9.59,9.59,0,0,0-2.416,3.6",
    transform: "translate(-2197.674 -1978.331)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -13.166,
    y1: 3.032,
    x2: -13.16,
    y2: 3.032,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11884",
    "data-name": "Path 11884",
    className: "cls-1",
    d: "M2941.577,1981.935c-.942,2.375-3.973,11.3-4.137,12.2s-2.292,9.5,7,9.133c0,0,6.84-.819,4.506-11.18,0,0-3.892-12-4.219-12.7s.041-1.064-.737-1.064a9.589,9.589,0,0,0-2.417,3.6",
    transform: "translate(-2937.117 -1978.331)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -17.637,
    y1: 3.032,
    x2: -17.631,
    y2: 3.032,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7393",
    "data-name": "Group 7393",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7380",
    "data-name": "Group 7380",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11736",
    "data-name": "Path 11736",
    className: "cls-3",
    d: "M391.643,2176.989c-93.3-15.523-238.511-14.889-331.516,2.371-10.606,1.968-34.756,13.438,39.787,16.873s120.407,5.581,86.039,11.592-.235,13.61,45.4,15.661c101.842,4.577,120.647-11.833,105.015-14.036-39.037-5.5-37.7-11.593-.747-9.875s100.6-15.17,56.022-22.586",
    transform: "translate(-43.145 -1954.559)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382",
    transform: "translate(63.916 211.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17352",
    "data-name": "Rectangle 17352",
    className: "cls-5",
    width: 329.161,
    height: 35.438,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7383",
    "data-name": "Group 7383",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11738",
    "data-name": "Path 11738",
    className: "cls-6",
    d: "M2360.833,496.4c-26.416,0-28.686,89.79-28.686,89.79h57.371s-2.27-89.79-28.685-89.79",
    transform: "translate(-2104.627 -447.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11739",
    "data-name": "Path 11739",
    className: "cls-7",
    d: "M2389.518,1302.168s-.124-4.891-.649-12.389c-19.734,10.784-42.349,10.435-56.578,8.645-.109,2.383-.144,3.745-.144,3.745h57.371Z",
    transform: "translate(-2104.627 -1163.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11740",
    "data-name": "Path 11740",
    className: "cls-8",
    d: "M2389.394,595.653c-23.573,0-25.6,80.124-25.6,80.124h51.2s-2.026-80.124-25.6-80.124",
    transform: "translate(-2133.188 -537.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11741",
    "data-name": "Path 11741",
    className: "cls-9",
    d: "M2296.445,717.932H2267.76s1.27-50.226,12.962-75.548c-18.253,9.567-19.923,75.571-19.923,75.571h49.023s0-.01,0-.023Z",
    transform: "translate(-2040.24 -579.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11742",
    "data-name": "Path 11742",
    className: "cls-10",
    d: "M2518.159,642.385c11.692,25.322,12.962,75.548,12.962,75.548h-42.062c0,.014,0,.024,0,.024h49.023s-1.669-66-19.922-75.571",
    transform: "translate(-2246.23 -579.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11743",
    "data-name": "Path 11743",
    className: "cls-11",
    d: "M2538.081,1264.154s-.174-6.883-1.024-16.525a66.332,66.332,0,0,1-6.585,4.112c.525,7.5.649,12.389.649,12.389h-42.062c0,.014,0,.023,0,.023h49.023Z",
    transform: "translate(-2246.23 -1125.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11744",
    "data-name": "Path 11744",
    className: "cls-12",
    d: "M2332.147,599.882h16.719c.336-3.866-1.481-8.2-3.616-11.356-4.441-6.576-4.014-19.9-.854-27.246s4.271-14.861,4.42-26.306,4.036-16.57,6-18.961c1.768-2.152,1.529-2.981.4-4.441-21.134,11.65-23.073,88.31-23.073,88.31",
    transform: "translate(-2104.627 -461.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11745",
    "data-name": "Path 11745",
    className: "cls-6",
    d: "M2377.376,681.456a41.468,41.468,0,0,1,.748-7.567c-13,20.016-14.328,72.492-14.328,72.492h13.629c.343-3.87-1.477-8.208-3.614-11.373-4.442-6.576-4.015-19.9-.854-27.245s4.271-14.861,4.42-26.306",
    transform: "translate(-2133.188 -608.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11746",
    "data-name": "Path 11746",
    className: "cls-13",
    d: "M2414.991,1316.493s-.108-4.28-.566-10.86c-17.6,8.526-37,8.805-50.5,7.446-.1,2.173-.132,3.414-.132,3.414h51.2Z",
    transform: "translate(-2133.188 -1178.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11747",
    "data-name": "Path 11747",
    className: "cls-7",
    d: "M2377.328,1382.561a119.745,119.745,0,0,1-13.4-.6c-.1,2.172-.132,3.414-.132,3.414h13.629a12.135,12.135,0,0,0-.1-2.81",
    transform: "translate(-2133.188 -1247.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11748",
    "data-name": "Path 11748",
    className: "cls-6",
    d: "M1650.515,855.7c-26.416,0-28.686,54.746-28.686,54.746H1679.2s-2.27-54.746-28.685-54.746",
    transform: "translate(-1463.606 -772.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11749",
    "data-name": "Path 11749",
    className: "cls-7",
    d: "M1679.2,1346.99s-.124-2.982-.649-7.554c-19.734,6.575-42.349,6.363-56.578,5.271-.109,1.453-.144,2.283-.144,2.283H1679.2Z",
    transform: "translate(-1463.607 -1208.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11750",
    "data-name": "Path 11750",
    className: "cls-8",
    d: "M1679.078,916.214c-23.573,0-25.6,48.854-25.6,48.854h51.2s-2.026-48.854-25.6-48.854",
    transform: "translate(-1492.169 -826.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11751",
    "data-name": "Path 11751",
    className: "cls-9",
    d: "M1586.13,990.77h-28.686s1.27-30.624,12.963-46.063c-18.254,5.834-19.923,46.078-19.923,46.078h49.023s0-.006,0-.014Z",
    transform: "translate(-1399.222 -852.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11752",
    "data-name": "Path 11752",
    className: "cls-10",
    d: "M1807.841,944.707c11.692,15.44,12.962,46.063,12.962,46.063h-42.062c0,.008,0,.014,0,.014h49.023s-1.669-40.244-19.922-46.078",
    transform: "translate(-1605.209 -852.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11753",
    "data-name": "Path 11753",
    className: "cls-11",
    d: "M1827.763,1323.814s-.174-4.2-1.024-10.075c-2.147.928-4.347,1.761-6.584,2.507.525,4.571.649,7.554.649,7.554h-42.062c0,.008,0,.014,0,.014h49.023Z",
    transform: "translate(-1605.209 -1185.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11754",
    "data-name": "Path 11754",
    className: "cls-12",
    d: "M1621.829,918.79h16.719c.336-2.357-1.481-5-3.616-6.924-4.441-4.01-4.014-12.134-.854-16.612s4.271-9.061,4.42-16.039a13.733,13.733,0,0,1,6-11.561c1.768-1.312,1.528-1.817.405-2.708-21.134,7.1-23.074,53.844-23.074,53.844",
    transform: "translate(-1463.606 -780.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11755",
    "data-name": "Path 11755",
    className: "cls-6",
    d: "M1667.061,968.529a15.872,15.872,0,0,1,.747-4.614c-13,12.2-14.328,44.2-14.328,44.2h13.63c.343-2.36-1.477-5-3.615-6.935-4.441-4.01-4.014-12.134-.854-16.612s4.271-9.061,4.42-16.039",
    transform: "translate(-1492.169 -869.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11756",
    "data-name": "Path 11756",
    className: "cls-13",
    d: "M1704.675,1355.726s-.108-2.61-.566-6.622c-17.6,5.2-37,5.369-50.5,4.54-.1,1.325-.132,2.082-.132,2.082h51.2Z",
    transform: "translate(-1492.169 -1217.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11757",
    "data-name": "Path 11757",
    className: "cls-7",
    d: "M1667.012,1396.007c-4.853.036-9.387-.122-13.4-.368-.1,1.324-.132,2.082-.132,2.082h13.63a4.561,4.561,0,0,0-.1-1.713",
    transform: "translate(-1492.169 -1259.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11758",
    "data-name": "Path 11758",
    className: "cls-6",
    d: "M915.929,957.633c-26.416,0-28.685,44.8-28.685,44.8h57.371s-2.27-44.8-28.685-44.8",
    transform: "translate(-800.686 -864.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11759",
    "data-name": "Path 11759",
    className: "cls-7",
    d: "M944.614,1359.705s-.124-2.44-.649-6.182c-19.734,5.381-42.349,5.207-56.578,4.313-.109,1.189-.144,1.869-.144,1.869h57.371Z",
    transform: "translate(-800.685 -1221.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11760",
    "data-name": "Path 11760",
    className: "cls-8",
    d: "M944.488,1007.16c-23.572,0-25.6,39.982-25.6,39.982h51.2s-2.026-39.982-25.6-39.982",
    transform: "translate(-829.245 -908.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11761",
    "data-name": "Path 11761",
    className: "cls-9",
    d: "M851.54,1068.175H822.855s1.27-25.062,12.962-37.7c-18.254,4.774-19.923,37.71-19.923,37.71h49.023s0,0,0-.012Z",
    transform: "translate(-736.297 -929.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11762",
    "data-name": "Path 11762",
    className: "cls-10",
    d: "M1073.253,1030.477c11.692,12.636,12.962,37.7,12.962,37.7h-42.062c0,.007,0,.012,0,.012h49.023s-1.669-32.936-19.922-37.71",
    transform: "translate(-942.286 -929.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11763",
    "data-name": "Path 11763",
    className: "cls-11",
    d: "M1093.175,1340.739a74.128,74.128,0,0,0-1.024-8.246c-2.147.76-4.348,1.442-6.585,2.052.525,3.741.649,6.182.649,6.182h-42.062c0,.007,0,.012,0,.012h49.023Z",
    transform: "translate(-942.286 -1202.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11764",
    "data-name": "Path 11764",
    className: "cls-12",
    d: "M887.243,1009.268h16.718c.336-1.929-1.481-4.089-3.616-5.667-4.441-3.281-4.014-9.93-.854-13.6s4.27-7.416,4.42-13.127,4.036-8.268,6-9.461c1.768-1.074,1.528-1.487.405-2.216-21.134,5.813-23.073,44.066-23.073,44.066",
    transform: "translate(-800.685 -871.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11765",
    "data-name": "Path 11765",
    className: "cls-6",
    d: "M932.471,1049.975a10.863,10.863,0,0,1,.747-3.776c-13,9.988-14.328,36.173-14.328,36.173h13.63c.343-1.931-1.477-4.1-3.615-5.675-4.441-3.281-4.014-9.93-.854-13.6s4.271-7.416,4.42-13.127",
    transform: "translate(-829.245 -944.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11766",
    "data-name": "Path 11766",
    className: "cls-13",
    d: "M970.086,1366.854s-.109-2.136-.566-5.419c-17.6,4.255-37,4.394-50.5,3.716-.1,1.084-.132,1.7-.132,1.7h51.2Z",
    transform: "translate(-829.245 -1228.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11767",
    "data-name": "Path 11767",
    className: "cls-7",
    d: "M932.422,1399.822c-4.853.029-9.387-.1-13.4-.3-.1,1.084-.132,1.7-.132,1.7h13.63a3.069,3.069,0,0,0-.1-1.4",
    transform: "translate(-829.245 -1262.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11768",
    "data-name": "Path 11768",
    className: "cls-13",
    d: "M2335.3,1427.3l-70.34-1.3-.174,55.388h70.377Z",
    transform: "translate(-2043.839 -1286.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11769",
    "data-name": "Path 11769",
    className: "cls-6",
    d: "M2473.958,1600.8s6.149-4.441,0-10.932c0,0,3.074-5.979-2.05-9.224q-7.5-4.748-10.118-9.4V1571l-.065.118-.066-.118v.237q-2.622,4.642-10.118,9.4c-5.124,3.245-2.05,9.224-2.05,9.224-6.149,6.491,0,10.932,0,10.932a10.671,10.671,0,0,0-2.9,11.445l15.072,2.2v.019l.066-.01.065.01v-.019l15.072-2.2a10.672,10.672,0,0,0-2.9-11.445",
    transform: "translate(-2207.362 -1417.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11770",
    "data-name": "Path 11770",
    className: "cls-14",
    d: "M2520.19,1654.665c-3.561,5.635-9.274,7-9.417,15.729v17.337h18.833v-17.337c-.142-8.729-7.651-10.435-9.417-15.729",
    transform: "translate(-2265.827 -1493.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11771",
    "data-name": "Path 11771",
    className: "cls-13",
    d: "M1612.512,1427.3l-70.34-1.3-.175,55.388h70.377Z",
    transform: "translate(-1391.564 -1286.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11772",
    "data-name": "Path 11772",
    className: "cls-6",
    d: "M1751.169,1600.8s6.149-4.441,0-10.932c0,0,3.074-5.979-2.05-9.224q-7.5-4.748-10.118-9.4V1571l-.066.118c-.022-.039-.044-.079-.066-.118v.237q-2.623,4.642-10.118,9.4c-5.125,3.245-2.05,9.224-2.05,9.224-6.149,6.491,0,10.932,0,10.932a10.671,10.671,0,0,0-2.9,11.445l15.072,2.2v.019l.066-.01.066.01v-.019l15.071-2.2a10.671,10.671,0,0,0-2.9-11.445",
    transform: "translate(-1555.086 -1417.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11773",
    "data-name": "Path 11773",
    className: "cls-14",
    d: "M1797.4,1654.665c-3.561,5.635-9.275,7-9.417,15.729v17.337h18.833v-17.337c-.142-8.729-7.652-10.435-9.417-15.729",
    transform: "translate(-1613.551 -1493.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11774",
    "data-name": "Path 11774",
    className: "cls-9",
    d: "M889.723,1427.3l-70.339-1.3-.175,55.388h70.377Z",
    transform: "translate(-739.289 -1286.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11775",
    "data-name": "Path 11775",
    className: "cls-13",
    d: "M820.55,1439.917l34.244,41.471h36l.137-54.086-70.339-1.3Z",
    transform: "translate(-740.499 -1286.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11776",
    "data-name": "Path 11776",
    className: "cls-12",
    d: "M1028.38,1600.8s6.15-4.441,0-10.932c0,0,3.075-5.979-2.05-9.224q-7.5-4.748-10.118-9.4V1571l-.066.118c-.022-.039-.045-.079-.066-.118v.237q-2.623,4.642-10.118,9.4c-5.124,3.245-2.05,9.224-2.05,9.224-6.15,6.491,0,10.932,0,10.932a10.671,10.671,0,0,0-2.9,11.445l15.072,2.2v.019l.066-.01.066.01v-.019l15.071-2.2a10.671,10.671,0,0,0-2.9-11.445",
    transform: "translate(-902.812 -1417.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11777",
    "data-name": "Path 11777",
    className: "cls-8",
    d: "M1074.612,1654.665c-3.56,5.635-9.274,7-9.417,15.729v17.337h18.833v-17.337c-.142-8.729-7.651-10.435-9.417-15.729",
    transform: "translate(-961.276 -1493.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11778",
    "data-name": "Path 11778",
    className: "cls-6",
    d: "M1039.164,1600.8s6.15-4.441,0-10.932c0,0,3.075-5.979-2.05-9.224q-7.5-4.748-10.118-9.4V1571l-.066.118c-.022-.039-.044-.079-.066-.118v.237q-2.623,4.642-10.118,9.4c-5.124,3.245-2.05,9.224-2.05,9.224a10.465,10.465,0,0,0-2.338,3.568l15.532,18.809h14.177a10.671,10.671,0,0,0-2.9-11.445",
    transform: "translate(-913.596 -1417.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11779",
    "data-name": "Path 11779",
    className: "cls-14",
    d: "M1074.612,1654.665c-3.56,5.635-9.274,7-9.417,15.729v4.784l10.366,12.553h8.468v-17.337c-.142-8.729-7.651-10.435-9.417-15.729",
    transform: "translate(-961.276 -1493.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11780",
    "data-name": "Path 11780",
    className: "cls-6",
    d: "M2515.016,787.806c-3.271,17.722-12.017,23.462-12.017,45.383,0,6.007,5.38,10.878,12.017,10.878s12.017-4.87,12.017-10.878c0-21.921-8.746-27.661-12.017-45.383",
    transform: "translate(-2258.811 -710.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11781",
    "data-name": "Path 11781",
    className: "cls-8",
    d: "M2568.3,922.74c-1.26-3.684-3.393-4.217-4.9-6.4s3.732-2.472,3.829-3.877-4.957-3.369-5.428-5.185c-.544-2.1,3.9-2.714,3.683-6.009-.176-2.682-4.531-11.535-4.531-11.535s-4.355,8.853-4.531,11.535c-.216,3.3,4.227,3.911,3.683,6.009-.47,1.817-5.525,3.78-5.428,5.185s5.331,1.7,3.829,3.877-3.635,2.714-4.895,6.4,1.066,11.97,6.882,12.939a2.934,2.934,0,0,0,.92,0c5.816-.97,8.142-9.256,6.882-12.939",
    transform: "translate(-2304.193 -802.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11782",
    "data-name": "Path 11782",
    className: "cls-9",
    d: "M2648.447,1079.527c-.689-.994-3.008-2.184-4.328-3.379.888,1.16,3.139,2.345,4.328,3.379",
    transform: "translate(-2386.163 -971.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11783",
    "data-name": "Path 11783",
    className: "cls-9",
    d: "M2664.438,1171.348c-.663-.759-1.369-1.326-2.031-1.978.636.733,1.343,1.3,2.031,1.978",
    transform: "translate(-2402.668 -1055.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11784",
    "data-name": "Path 11784",
    className: "cls-9",
    d: "M2562.433,1057.979a.556.556,0,0,1-.03-.145c-.1-1.405,4.957-3.369,5.428-5.185.189-.731-.227-1.282-.84-1.829a1.393,1.393,0,0,1,.277,1.232c-.471,1.816-5.525,3.78-5.428,5.185.019.285.25.524.593.742",
    transform: "translate(-2311.911 -948.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11785",
    "data-name": "Path 11785",
    className: "cls-9",
    d: "M2548.411,1152.954c1.26-3.684,3.393-4.217,4.9-6.4a1.1,1.1,0,0,0-.384-1.72,1.063,1.063,0,0,1-.18,1.122c-1.5,2.181-3.635,2.714-4.895,6.4-.942,2.752.119,8.073,3.142,10.993-2.588-3-3.459-7.822-2.579-10.4",
    transform: "translate(-2298.984 -1033.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11786",
    "data-name": "Path 11786",
    className: "cls-9",
    d: "M2581,898.059a3.2,3.2,0,0,1-.769-2.31c.157-2.4,3.651-9.72,4.393-11.251-.263-.551-.425-.88-.425-.88s-4.356,8.852-4.531,11.535a3.52,3.52,0,0,0,1.332,2.907",
    transform: "translate(-2327.992 -797.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11787",
    "data-name": "Path 11787",
    className: "cls-6",
    d: "M854.112,1418.57c0,.939-1.964,1.708-4.365,1.708H602.005c-2.4,0-4.365-.769-4.365-1.708v-.089c0-.939,1.964-1.708,4.365-1.708H849.747c2.4,0,4.365.769,4.365,1.708Z",
    transform: "translate(-539.335 -1278.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11788",
    "data-name": "Path 11788",
    className: "cls-14",
    d: "M849.747,1426.9H602.005a7.109,7.109,0,0,1-3.843-.9,1.052,1.052,0,0,0-.523.808v.089c0,.939,1.964,1.708,4.365,1.708H849.747c2.4,0,4.365-.769,4.365-1.708v-.089a1.053,1.053,0,0,0-.524-.808,7.1,7.1,0,0,1-3.841.9",
    transform: "translate(-539.335 -1286.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11789",
    "data-name": "Path 11789",
    className: "cls-6",
    d: "M2594.737,1219.324a3.9,3.9,0,1,1-3.9-3.9,3.9,3.9,0,0,1,3.9,3.9",
    transform: "translate(-2334.557 -1096.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11790",
    "data-name": "Path 11790",
    className: "cls-12",
    d: "M2588,1219.721a3.9,3.9,0,0,1,4.726-3.813,3.9,3.9,0,1,0-2.71,7.229,3.9,3.9,0,0,1-2.016-3.415",
    transform: "translate(-2334.557 -1096.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11791",
    "data-name": "Path 11791",
    className: "cls-12",
    d: "M2587.946,637.735h-3.771v-3.527h3.771a.363.363,0,1,0,0-.7h-4.122a.416.416,0,0,0-.351.457v3.772h-3.527v-3.772a.363.363,0,1,0-.7,0v4.122a.416.416,0,0,0,.457.351h3.771v3.527H2579.7a.363.363,0,1,0,0,.7h4.123a.415.415,0,0,0,.35-.457v-3.772h3.527v3.772a.363.363,0,1,0,.7,0v-4.122a.416.416,0,0,0-.457-.351",
    transform: "translate(-2327.618 -571.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11792",
    "data-name": "Path 11792",
    className: "cls-12",
    d: "M2640.2,697.142a.721.721,0,1,1-.721-.721.721.721,0,0,1,.721.721",
    transform: "translate(-2381.33 -628.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11793",
    "data-name": "Path 11793",
    className: "cls-12",
    d: "M2597.754,697.142a.721.721,0,1,1-.721-.721.721.721,0,0,1,.721.721",
    transform: "translate(-2343.02 -628.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11794",
    "data-name": "Path 11794",
    className: "cls-12",
    d: "M2640.2,652.4a.721.721,0,1,1-.721-.721.721.721,0,0,1,.721.721",
    transform: "translate(-2381.33 -588.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11795",
    "data-name": "Path 11795",
    className: "cls-12",
    d: "M2597.754,652.4a.721.721,0,1,1-.721-.721.721.721,0,0,1,.721.721",
    transform: "translate(-2343.02 -588.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11796",
    "data-name": "Path 11796",
    className: "cls-12",
    d: "M906.094,2003.649H662.223l15.446-9.907H889.012Z",
    transform: "translate(-597.618 -1799.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11797",
    "data-name": "Path 11797",
    className: "cls-6",
    d: "M1199.617,2003.649h184.691l-17.082-9.907H1192.134Z",
    transform: "translate(-1075.832 -1799.236)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17353",
    "data-name": "Rectangle 17353",
    className: "cls-13",
    width: 243.871,
    height: 17.656,
    transform: "translate(64.605 204.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11798",
    "data-name": "Path 11798",
    className: "cls-6",
    d: "M2211.914,1175.476c1.544-.478,3.235-1.985,2.536-3.971s-5.992-8.528-5.992-8.528-5.294,6.543-5.992,8.528.992,3.492,2.537,3.971,1.029,2.243-.662,2.959,4.117.312,4.117.312,5.808.4,4.117-.312-2.205-2.482-.661-2.959",
    transform: "translate(-1987.451 -1049.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11799",
    "data-name": "Path 11799",
    className: "cls-12",
    d: "M2209.019,1183.033c2.562-2.9-2.392-5.039-2.562-8.541a15.806,15.806,0,0,1,1.6-6.415c-1.242,1.561-5.012,6.377-5.594,8.031-.7,1.985.992,3.492,2.537,3.971s1.029,2.243-.662,2.959,4.117.312,4.117.312l.252.017c.1-.107.205-.216.309-.333",
    transform: "translate(-1987.451 -1054.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11800",
    "data-name": "Path 11800",
    className: "cls-13",
    d: "M2177.75,1317.853c-8.82,0-9.473,1.361-9.473,3.041v6.657h18.948v-6.657c0-1.68-.43-3.041-9.475-3.041",
    transform: "translate(-1956.744 -1189.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11801",
    "data-name": "Path 11801",
    className: "cls-8",
    d: "M2173.537,1323.493c-.333-2.818,2.212-2.392,4.775-5.3a3.873,3.873,0,0,0,.268-.34q-.4,0-.829,0c-8.82,0-9.473,1.361-9.473,3.041v6.657h7.11c-.553-1.4-1.7-2.822-1.851-4.058",
    transform: "translate(-1956.744 -1189.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11802",
    "data-name": "Path 11802",
    className: "cls-6",
    d: "M2191.361,1565.934c-3.417-9.774-1.765-22.557-1.765-22.557h-10.369s1.651,12.783-1.765,22.557-1.14,13.158,0,15.163c1,1.761,5.8,1.782,6.949,1.761,1.151.021,5.949,0,6.949-1.761,1.139-2.005,3.417-5.389,0-15.163",
    transform: "translate(-1963.404 -1392.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11803",
    "data-name": "Path 11803",
    className: "cls-12",
    d: "M2180.628,1568.865c-2.734-4.954,6.15-16.74,2.43-20.591a10.8,10.8,0,0,1-3-4.9h-.833s1.651,12.783-1.765,22.557-1.14,13.158,0,15.164c.867,1.526,4.583,1.745,6.309,1.763.184-.48.394-.974.64-1.489,2.929-6.113-1.05-7.552-3.783-12.506",
    transform: "translate(-1963.404 -1392.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11804",
    "data-name": "Path 11804",
    className: "cls-13",
    d: "M2177.75,1969.8c-8.82,0-9.473,1.5-9.473,3.347v7.325h18.948v-7.325c0-1.848-.43-3.347-9.475-3.347",
    transform: "translate(-1956.744 -1777.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11805",
    "data-name": "Path 11805",
    className: "cls-8",
    d: "M2176.459,1969.922c-7.594.142-8.184,1.581-8.184,3.335v7.325h9.474c-.92-3.647-2.2-6.6-1.291-10.66",
    transform: "translate(-1956.743 -1777.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11806",
    "data-name": "Path 11806",
    className: "cls-14",
    d: "M2177.751,1463.495c8.82,0,9.474-1.5,9.474-3.346v-7.326h-18.948v7.326c0,1.848.43,3.346,9.474,3.346",
    transform: "translate(-1956.744 -1311.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11807",
    "data-name": "Path 11807",
    className: "cls-8",
    d: "M2168.277,1460.149c0,1.552.3,2.858,5.764,3.236-1.288-2.514-.927-4.668.781-6.132,1.376-1.18,1.168-3.052.744-4.43h-7.289Z",
    transform: "translate(-1956.744 -1311.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11808",
    "data-name": "Path 11808",
    className: "cls-8",
    d: "M2189.83,1550.406c0,1.229-4.1,2.227-9.158,2.227s-9.158-1-9.158-2.227,4.1-2.226,9.158-2.226,9.158,1,9.158,2.226",
    transform: "translate(-1959.665 -1397.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11809",
    "data-name": "Path 11809",
    className: "cls-9",
    d: "M2179.318,1554.843a11.884,11.884,0,0,1-2.795-4.187c-2.972.368-5.01,1.118-5.01,1.985,0,1.118,3.388,2.043,7.8,2.2",
    transform: "translate(-1959.665 -1399.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11810",
    "data-name": "Path 11810",
    className: "cls-8",
    d: "M2189.83,1935.059c0,1.23-4.1,2.227-9.158,2.227s-9.158-1-9.158-2.227,4.1-2.226,9.158-2.226,9.158,1,9.158,2.226",
    transform: "translate(-1959.665 -1744.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11811",
    "data-name": "Path 11811",
    className: "cls-9",
    d: "M2171.514,1935.059c0,1.11,3.342,2.031,7.714,2.2a16.053,16.053,0,0,1,1.444-4.425c-5.058,0-9.158,1-9.158,2.226",
    transform: "translate(-1959.665 -1744.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11812",
    "data-name": "Path 11812",
    className: "cls-6",
    d: "M1488.524,1175.476c1.544-.478,3.235-1.985,2.536-3.971s-5.992-8.528-5.992-8.528-5.293,6.543-5.992,8.528.993,3.492,2.537,3.971,1.029,2.243-.661,2.959,4.117.312,4.117.312,5.808.4,4.117-.312-2.206-2.482-.662-2.959",
    transform: "translate(-1334.634 -1049.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11813",
    "data-name": "Path 11813",
    className: "cls-12",
    d: "M1485.63,1183.033c2.562-2.9-2.391-5.039-2.562-8.541a15.814,15.814,0,0,1,1.6-6.415c-1.242,1.561-5.012,6.377-5.594,8.031-.7,1.985.993,3.492,2.537,3.971s1.029,2.243-.662,2.959,4.117.312,4.117.312l.251.017c.1-.107.206-.216.309-.333",
    transform: "translate(-1334.635 -1054.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11814",
    "data-name": "Path 11814",
    className: "cls-13",
    d: "M1454.361,1317.853c-8.82,0-9.474,1.361-9.474,3.041v6.657h18.948v-6.657c0-1.68-.43-3.041-9.474-3.041",
    transform: "translate(-1303.927 -1189.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11815",
    "data-name": "Path 11815",
    className: "cls-8",
    d: "M1450.147,1323.493c-.333-2.818,2.213-2.392,4.775-5.3a3.8,3.8,0,0,0,.268-.34q-.4,0-.828,0c-8.82,0-9.474,1.361-9.474,3.041v6.657H1452c-.553-1.4-1.7-2.822-1.85-4.058",
    transform: "translate(-1303.927 -1189.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11816",
    "data-name": "Path 11816",
    className: "cls-6",
    d: "M1467.972,1565.934c-3.416-9.774-1.765-22.557-1.765-22.557h-10.369s1.651,12.783-1.765,22.557-1.139,13.158,0,15.163c1,1.761,5.8,1.782,6.949,1.761,1.151.021,5.949,0,6.949-1.761,1.139-2.005,3.417-5.389,0-15.163",
    transform: "translate(-1310.589 -1392.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11817",
    "data-name": "Path 11817",
    className: "cls-12",
    d: "M1457.239,1568.865c-2.734-4.954,6.15-16.74,2.43-20.591a10.809,10.809,0,0,1-3-4.9h-.832s1.651,12.783-1.765,22.557-1.139,13.158,0,15.164c.867,1.526,4.583,1.745,6.309,1.763.183-.48.394-.974.64-1.489,2.929-6.113-1.049-7.552-3.783-12.506",
    transform: "translate(-1310.588 -1392.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11818",
    "data-name": "Path 11818",
    className: "cls-13",
    d: "M1454.361,1969.8c-8.82,0-9.474,1.5-9.474,3.347v7.325h18.948v-7.325c0-1.848-.43-3.347-9.474-3.347",
    transform: "translate(-1303.927 -1777.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11819",
    "data-name": "Path 11819",
    className: "cls-8",
    d: "M1453.072,1969.922c-7.594.142-8.184,1.581-8.184,3.335v7.325h9.474c-.92-3.647-2.2-6.6-1.29-10.66",
    transform: "translate(-1303.927 -1777.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11820",
    "data-name": "Path 11820",
    className: "cls-14",
    d: "M1454.362,1463.495c8.82,0,9.474-1.5,9.474-3.346v-7.326h-18.948v7.326c0,1.848.43,3.346,9.474,3.346",
    transform: "translate(-1303.927 -1311.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11821",
    "data-name": "Path 11821",
    className: "cls-8",
    d: "M1444.888,1460.149c0,1.552.3,2.858,5.763,3.236-1.288-2.514-.926-4.668.781-6.132,1.376-1.18,1.168-3.052.744-4.43h-7.289Z",
    transform: "translate(-1303.927 -1311.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11822",
    "data-name": "Path 11822",
    className: "cls-8",
    d: "M1466.441,1550.406c0,1.229-4.1,2.227-9.158,2.227s-9.158-1-9.158-2.227,4.1-2.226,9.158-2.226,9.158,1,9.158,2.226",
    transform: "translate(-1306.849 -1397.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11823",
    "data-name": "Path 11823",
    className: "cls-9",
    d: "M1455.929,1554.843a11.89,11.89,0,0,1-2.795-4.187c-2.972.368-5.009,1.118-5.009,1.985,0,1.118,3.388,2.043,7.8,2.2",
    transform: "translate(-1306.849 -1399.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11824",
    "data-name": "Path 11824",
    className: "cls-8",
    d: "M1466.441,1935.059c0,1.23-4.1,2.227-9.158,2.227s-9.158-1-9.158-2.227,4.1-2.226,9.158-2.226,9.158,1,9.158,2.226",
    transform: "translate(-1306.849 -1744.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11825",
    "data-name": "Path 11825",
    className: "cls-9",
    d: "M1448.125,1935.059c0,1.11,3.343,2.031,7.714,2.2a16.035,16.035,0,0,1,1.443-4.425c-5.058,0-9.158,1-9.158,2.226",
    transform: "translate(-1306.849 -1744.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11826",
    "data-name": "Path 11826",
    className: "cls-6",
    d: "M765.137,1175.476c1.544-.478,3.235-1.985,2.537-3.971s-5.992-8.528-5.992-8.528-5.294,6.543-5.992,8.528.993,3.492,2.537,3.971,1.029,2.243-.662,2.959,4.117.312,4.117.312,5.808.4,4.117-.312-2.205-2.482-.661-2.959",
    transform: "translate(-681.819 -1049.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11827",
    "data-name": "Path 11827",
    className: "cls-12",
    d: "M762.241,1183.033c2.562-2.9-2.391-5.039-2.562-8.541a15.815,15.815,0,0,1,1.6-6.415c-1.242,1.561-5.012,6.377-5.594,8.031-.7,1.985.993,3.492,2.537,3.971s1.029,2.243-.662,2.959,4.117.312,4.117.312l.251.017c.1-.107.206-.216.309-.333",
    transform: "translate(-681.819 -1054.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11828",
    "data-name": "Path 11828",
    className: "cls-13",
    d: "M730.971,1317.853c-8.82,0-9.474,1.361-9.474,3.041v6.657h18.948v-6.657c0-1.68-.43-3.041-9.474-3.041",
    transform: "translate(-651.109 -1189.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11829",
    "data-name": "Path 11829",
    className: "cls-8",
    d: "M726.756,1323.493c-.333-2.818,2.213-2.392,4.775-5.3a3.78,3.78,0,0,0,.268-.34q-.4,0-.828,0c-8.82,0-9.474,1.361-9.474,3.041v6.657h7.11c-.553-1.4-1.7-2.822-1.851-4.058",
    transform: "translate(-651.108 -1189.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11830",
    "data-name": "Path 11830",
    className: "cls-6",
    d: "M744.583,1565.934c-3.417-9.774-1.765-22.557-1.765-22.557H732.45s1.652,12.783-1.765,22.557-1.139,13.158,0,15.163c1,1.761,5.8,1.782,6.949,1.761,1.151.021,5.949,0,6.95-1.761,1.139-2.005,3.416-5.389,0-15.163",
    transform: "translate(-657.772 -1392.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11831",
    "data-name": "Path 11831",
    className: "cls-12",
    d: "M733.851,1568.865c-2.734-4.954,6.15-16.74,2.43-20.591a10.81,10.81,0,0,1-3-4.9h-.832s1.651,12.783-1.765,22.557-1.139,13.158,0,15.164c.867,1.526,4.583,1.745,6.309,1.763.183-.48.394-.974.64-1.489,2.929-6.113-1.049-7.552-3.783-12.506",
    transform: "translate(-657.772 -1392.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11832",
    "data-name": "Path 11832",
    className: "cls-13",
    d: "M730.971,1969.8c-8.82,0-9.474,1.5-9.474,3.347v7.325h18.948v-7.325c0-1.848-.43-3.347-9.474-3.347",
    transform: "translate(-651.109 -1777.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11833",
    "data-name": "Path 11833",
    className: "cls-8",
    d: "M729.68,1969.922c-7.594.142-8.184,1.581-8.184,3.335v7.325h9.474c-.919-3.647-2.2-6.6-1.29-10.66",
    transform: "translate(-651.108 -1777.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11834",
    "data-name": "Path 11834",
    className: "cls-14",
    d: "M730.971,1463.495c8.82,0,9.474-1.5,9.474-3.346v-7.326H721.5v7.326c0,1.848.431,3.346,9.474,3.346",
    transform: "translate(-651.109 -1311.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11835",
    "data-name": "Path 11835",
    className: "cls-8",
    d: "M721.5,1460.149c0,1.552.3,2.858,5.764,3.236-1.288-2.514-.926-4.668.782-6.132,1.376-1.18,1.168-3.052.744-4.43H721.5Z",
    transform: "translate(-651.108 -1311.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11836",
    "data-name": "Path 11836",
    className: "cls-8",
    d: "M743.052,1550.406c0,1.229-4.1,2.227-9.158,2.227s-9.158-1-9.158-2.227,4.1-2.226,9.158-2.226,9.158,1,9.158,2.226",
    transform: "translate(-654.032 -1397.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11837",
    "data-name": "Path 11837",
    className: "cls-9",
    d: "M732.54,1554.843a11.884,11.884,0,0,1-2.795-4.187c-2.972.368-5.01,1.118-5.01,1.985,0,1.118,3.388,2.043,7.8,2.2",
    transform: "translate(-654.032 -1399.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11838",
    "data-name": "Path 11838",
    className: "cls-8",
    d: "M743.052,1935.059c0,1.23-4.1,2.227-9.158,2.227s-9.158-1-9.158-2.227,4.1-2.226,9.158-2.226,9.158,1,9.158,2.226",
    transform: "translate(-654.032 -1744.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11839",
    "data-name": "Path 11839",
    className: "cls-9",
    d: "M724.736,1935.059c0,1.11,3.343,2.031,7.714,2.2a16.039,16.039,0,0,1,1.443-4.425c-5.058,0-9.158,1-9.158,2.226",
    transform: "translate(-654.032 -1744.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11840",
    "data-name": "Path 11840",
    className: "cls-6",
    d: "M2933.5,1175.476c1.544-.478,3.235-1.985,2.537-3.971s-5.992-8.528-5.992-8.528-5.294,6.543-5.992,8.528.993,3.492,2.536,3.971,1.029,2.243-.662,2.959,4.117.312,4.117.312,5.808.4,4.116-.312-2.205-2.482-.661-2.959",
    transform: "translate(-2638.643 -1049.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11841",
    "data-name": "Path 11841",
    className: "cls-12",
    d: "M2930.606,1183.033c2.563-2.9-2.391-5.039-2.562-8.541a15.81,15.81,0,0,1,1.6-6.415c-1.242,1.561-5.012,6.377-5.594,8.031-.7,1.985.993,3.492,2.536,3.971s1.029,2.243-.662,2.959,4.117.312,4.117.312l.251.017c.1-.107.206-.216.309-.333",
    transform: "translate(-2638.643 -1054.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11842",
    "data-name": "Path 11842",
    className: "cls-13",
    d: "M2899.338,1317.853c-8.82,0-9.473,1.361-9.473,3.041v6.657h18.947v-6.657c0-1.68-.43-3.041-9.474-3.041",
    transform: "translate(-2607.935 -1189.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11843",
    "data-name": "Path 11843",
    className: "cls-8",
    d: "M2895.124,1323.493c-.333-2.818,2.213-2.392,4.775-5.3a3.86,3.86,0,0,0,.267-.34q-.4,0-.828,0c-8.82,0-9.473,1.361-9.473,3.041v6.657h7.11c-.553-1.4-1.7-2.822-1.851-4.058",
    transform: "translate(-2607.935 -1189.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11844",
    "data-name": "Path 11844",
    className: "cls-6",
    d: "M2912.95,1565.934c-3.416-9.774-1.765-22.557-1.765-22.557h-10.369s1.652,12.783-1.765,22.557-1.139,13.158,0,15.163c1,1.761,5.8,1.782,6.949,1.761,1.151.021,5.949,0,6.949-1.761,1.139-2.005,3.417-5.389,0-15.163",
    transform: "translate(-2614.596 -1392.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11845",
    "data-name": "Path 11845",
    className: "cls-12",
    d: "M2902.217,1568.865c-2.734-4.954,6.15-16.74,2.43-20.591a10.8,10.8,0,0,1-3-4.9h-.832s1.651,12.783-1.765,22.557-1.139,13.158,0,15.164c.867,1.526,4.583,1.745,6.309,1.763.184-.48.394-.974.64-1.489,2.929-6.113-1.049-7.552-3.783-12.506",
    transform: "translate(-2614.597 -1392.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11846",
    "data-name": "Path 11846",
    className: "cls-13",
    d: "M2899.338,1969.8c-8.82,0-9.473,1.5-9.473,3.347v7.325h18.947v-7.325c0-1.848-.43-3.347-9.474-3.347",
    transform: "translate(-2607.935 -1777.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11847",
    "data-name": "Path 11847",
    className: "cls-10",
    d: "M2898.048,1969.922c-7.595.142-8.184,1.581-8.184,3.335v7.325h9.474c-.92-3.647-2.2-6.6-1.29-10.66",
    transform: "translate(-2607.934 -1777.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11848",
    "data-name": "Path 11848",
    className: "cls-14",
    d: "M2899.339,1463.495c8.82,0,9.473-1.5,9.473-3.346v-7.326h-18.947v7.326c0,1.848.43,3.346,9.474,3.346",
    transform: "translate(-2607.935 -1311.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11849",
    "data-name": "Path 11849",
    className: "cls-8",
    d: "M2889.865,1460.149c0,1.552.3,2.858,5.763,3.236-1.288-2.514-.926-4.668.782-6.132,1.376-1.18,1.168-3.052.744-4.43h-7.289Z",
    transform: "translate(-2607.935 -1311.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11850",
    "data-name": "Path 11850",
    className: "cls-8",
    d: "M2911.419,1550.406c0,1.229-4.1,2.227-9.158,2.227s-9.158-1-9.158-2.227,4.1-2.226,9.158-2.226,9.158,1,9.158,2.226",
    transform: "translate(-2610.857 -1397.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11851",
    "data-name": "Path 11851",
    className: "cls-9",
    d: "M2900.907,1554.843a11.887,11.887,0,0,1-2.795-4.187c-2.972.368-5.009,1.118-5.009,1.985,0,1.118,3.388,2.043,7.8,2.2",
    transform: "translate(-2610.857 -1399.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11852",
    "data-name": "Path 11852",
    className: "cls-8",
    d: "M2911.419,1935.059c0,1.23-4.1,2.227-9.158,2.227s-9.158-1-9.158-2.227,4.1-2.226,9.158-2.226,9.158,1,9.158,2.226",
    transform: "translate(-2610.857 -1744.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11853",
    "data-name": "Path 11853",
    className: "cls-9",
    d: "M2893.1,1935.059c0,1.11,3.343,2.031,7.714,2.2a16.044,16.044,0,0,1,1.443-4.425c-5.058,0-9.158,1-9.158,2.226",
    transform: "translate(-2610.857 -1744.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11854",
    "data-name": "Path 11854",
    className: "cls-8",
    d: "M2631.484,1.6s10.066-3.587,17.753,0S2665.892,0,2665.892,0a16.152,16.152,0,0,1-9.993,6.89s3.417,2.989,9.4.683a16.739,16.739,0,0,1-17.269,2.351c-8.354-3.632-16.553.809-16.553.809Z",
    transform: "translate(-2374.75 -0.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17354",
    "data-name": "Rectangle 17354",
    className: "cls-13",
    width: 1.003,
    height: 29.381,
    transform: "translate(255.719 0.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11855",
    "data-name": "Path 11855",
    className: "cls-8",
    d: "M2561.58,296.733c1.865-.578,3.909-2.4,3.064-4.8s-7.239-10.3-7.239-10.3-6.4,7.905-7.239,10.3,1.2,4.219,3.064,4.8,1.244,2.71-.8,3.575,4.974.377,4.974.377,7.017.488,4.974-.377-2.664-3-.8-3.575",
    transform: "translate(-2301.2 -254.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11856",
    "data-name": "Path 11856",
    className: "cls-6",
    d: "M2556.918,287.872c-1.509,1.9-6.05,7.7-6.752,9.695-.844,2.4,1.2,4.219,3.064,4.8s1.244,2.71-.8,3.575c-.742.314-.289.45.588.5.6-.271,1.226-.494,1.69-.68,1.529-.611,2.913-1.952.961-4s-2.233-2.306-1.122-6.832a53.6,53.6,0,0,1,2.369-7.048",
    transform: "translate(-2301.2 -259.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11857",
    "data-name": "Path 11857",
    className: "cls-13",
    d: "M2523.631,473.248c0,1.516-5.566,2.746-12.43,2.746s-12.43-1.23-12.43-2.746,5.565-2.746,12.43-2.746,12.43,1.23,12.43,2.746",
    transform: "translate(-2254.995 -424.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11858",
    "data-name": "Path 11858",
    className: "cls-8",
    d: "M2508.505,471.174c-5.568.272-9.734,1.369-9.734,2.681,0,1.137,3.128,2.112,7.587,2.53a6.793,6.793,0,0,0-1.173-1.782c-1.451-1.806,1.792-2.818,3.321-3.429",
    transform: "translate(-2254.995 -425.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11859",
    "data-name": "Path 11859",
    className: "cls-9",
    d: "M2968.338,1.033A8.962,8.962,0,0,0,2969.046,0s-.61.352-1.648.809q.473.1.94.219",
    transform: "translate(-2677.904 -0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11860",
    "data-name": "Path 11860",
    className: "cls-9",
    d: "M2648.005,1.1c-7.487-2.711-16.521.507-16.521.507l-.012,9.139s.239-.13.677-.326a32.522,32.522,0,0,1,15.856-9.32",
    transform: "translate(-2374.75 -0.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11861",
    "data-name": "Path 11861",
    className: "cls-8",
    d: "M1851.262,654.7c1.865-.577,3.908-2.4,3.064-4.8s-7.239-10.3-7.239-10.3-6.4,7.905-7.239,10.3,1.2,4.219,3.064,4.8,1.243,2.71-.8,3.575,4.974.377,4.974.377,7.017.489,4.974-.377-2.664-3-.8-3.575",
    transform: "translate(-1660.179 -577.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11862",
    "data-name": "Path 11862",
    className: "cls-6",
    d: "M1846.6,645.842c-1.509,1.9-6.05,7.7-6.752,9.695-.844,2.4,1.2,4.219,3.064,4.8s1.244,2.71-.8,3.575c-.742.314-.289.45.588.5.6-.271,1.226-.494,1.691-.68,1.528-.611,2.913-1.952.961-4s-2.233-2.306-1.122-6.832a53.582,53.582,0,0,1,2.37-7.048",
    transform: "translate(-1660.179 -582.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11863",
    "data-name": "Path 11863",
    className: "cls-13",
    d: "M1813.312,831.215c0,1.516-5.565,2.746-12.43,2.746s-12.43-1.229-12.43-2.746,5.565-2.746,12.43-2.746,12.43,1.229,12.43,2.746",
    transform: "translate(-1613.974 -747.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11864",
    "data-name": "Path 11864",
    className: "cls-8",
    d: "M1798.186,829.14c-5.568.272-9.734,1.369-9.734,2.681,0,1.137,3.128,2.112,7.586,2.53a6.77,6.77,0,0,0-1.173-1.782c-1.451-1.806,1.793-2.818,3.321-3.429",
    transform: "translate(-1613.974 -748.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11865",
    "data-name": "Path 11865",
    className: "cls-8",
    d: "M1116.672,744.533c1.865-.578,3.909-2.4,3.065-4.8s-7.239-10.3-7.239-10.3-6.4,7.905-7.239,10.3,1.2,4.219,3.065,4.8,1.244,2.71-.8,3.576,4.974.377,4.974.377,7.017.488,4.974-.377-2.665-3-.8-3.576",
    transform: "translate(-997.254 -658.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11866",
    "data-name": "Path 11866",
    className: "cls-6",
    d: "M1112.01,735.672c-1.509,1.9-6.05,7.7-6.752,9.695-.844,2.4,1.2,4.219,3.065,4.8s1.244,2.71-.8,3.576c-.742.314-.289.45.588.5.6-.271,1.226-.494,1.691-.68,1.528-.611,2.913-1.952.961-4s-2.233-2.306-1.122-6.833a53.608,53.608,0,0,1,2.37-7.048",
    transform: "translate(-997.254 -663.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11867",
    "data-name": "Path 11867",
    className: "cls-13",
    d: "M1078.723,921.045c0,1.516-5.565,2.746-12.43,2.746s-12.43-1.23-12.43-2.746,5.565-2.746,12.43-2.746,12.43,1.23,12.43,2.746",
    transform: "translate(-951.05 -828.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11868",
    "data-name": "Path 11868",
    className: "cls-8",
    d: "M1063.6,918.972c-5.568.272-9.734,1.369-9.734,2.681,0,1.137,3.128,2.113,7.586,2.53a6.781,6.781,0,0,0-1.173-1.782c-1.451-1.806,1.793-2.818,3.321-3.429",
    transform: "translate(-951.05 -829.319)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17355",
    "data-name": "Rectangle 17355",
    className: "cls-8",
    width: 22.76,
    height: 1.716,
    transform: "translate(244.826 204.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11869",
    "data-name": "Path 11869",
    className: "cls-12",
    d: "M2513.114,2114.6H2485.7l2.325-1.716h22.759Z",
    transform: "translate(-2243.204 -1906.757)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17356",
    "data-name": "Rectangle 17356",
    className: "cls-8",
    width: 27.404,
    height: 1.716,
    transform: "translate(242.504 207.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11870",
    "data-name": "Path 11870",
    className: "cls-12",
    d: "M2491.21,2149.78h-32.719l2.775-1.716h27.168Z",
    transform: "translate(-2218.646 -1938.503)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17357",
    "data-name": "Rectangle 17357",
    className: "cls-8",
    width: 32.638,
    height: 1.716,
    transform: "translate(239.886 211.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11871",
    "data-name": "Path 11871",
    className: "cls-12",
    d: "M2466.394,2184.958h-38.735l3.286-1.716h32.164Z",
    transform: "translate(-2190.82 -1970.249)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17358",
    "data-name": "Rectangle 17358",
    className: "cls-8",
    width: 38.727,
    height: 1.716,
    transform: "translate(236.842 214.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11872",
    "data-name": "Path 11872",
    className: "cls-12",
    d: "M2435.442,2220.136H2389.2l3.922-1.716h38.394Z",
    transform: "translate(-2156.117 -2001.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17359",
    "data-name": "Rectangle 17359",
    className: "cls-8",
    width: 46.239,
    height: 1.716,
    transform: "translate(233.086 218.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11873",
    "data-name": "Path 11873",
    className: "cls-12",
    d: "M2398.07,2255.311h-55.3l4.691-1.716h45.916Z",
    transform: "translate(-2114.215 -2033.739)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17360",
    "data-name": "Rectangle 17360",
    className: "cls-8",
    width: 55.298,
    height: 1.716,
    transform: "translate(228.557 221.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11874",
    "data-name": "Path 11874",
    className: "cls-6",
    d: "M2610.209,925.481c-.491,2.944-1.807,3.9-1.807,7.54a1.807,1.807,0,0,0,3.615,0c0-3.642-1.315-4.6-1.807-7.54",
    transform: "translate(-2353.931 -835.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11875",
    "data-name": "Path 11875",
    className: "cls-12",
    d: "M2609.15,933.769c0-3.118.964-4.266,1.55-6.378a11.643,11.643,0,0,1-.49-1.91c-.492,2.944-1.807,3.9-1.807,7.54a1.807,1.807,0,0,0,.96,1.6,1.8,1.8,0,0,1-.212-.848",
    transform: "translate(-2353.931 -835.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11876",
    "data-name": "Path 11876",
    className: "cls-6",
    d: "M1865.543,1022.4c-1.479,8.862-5.439,11.732-5.439,22.7a5.44,5.44,0,0,0,10.879,0c0-10.963-3.96-13.833-5.44-22.7",
    transform: "translate(-1678.636 -922.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11877",
    "data-name": "Path 11877",
    className: "cls-12",
    d: "M1862.356,1047.348c0-9.384,3.558-22.729,3.187-24.947-1.479,8.862-5.439,11.732-5.439,22.7a5.439,5.439,0,0,0,2.888,4.8,5.417,5.417,0,0,1-.637-2.552",
    transform: "translate(-1678.636 -922.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11878",
    "data-name": "Path 11878",
    className: "cls-6",
    d: "M1139.521,1071.508c-1.228,7.353-4.513,9.734-4.513,18.831a4.514,4.514,0,0,0,9.027,0c0-9.1-3.286-11.478-4.514-18.831",
    transform: "translate(-1024.279 -966.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11879",
    "data-name": "Path 11879",
    className: "cls-12",
    d: "M1136.876,1092.207c0-7.786,2.952-18.859,2.645-20.7-1.228,7.353-4.513,9.734-4.513,18.831a4.512,4.512,0,0,0,2.4,3.986,4.494,4.494,0,0,1-.528-2.117",
    transform: "translate(-1024.279 -966.974)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7386",
    "data-name": "Group 7386",
    transform: "translate(214.401 193.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7385",
    "data-name": "Group 7385",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17362",
    "data-name": "Rectangle 17362",
    className: "cls-16",
    width: 16.135,
    height: 25.309,
    transform: "translate(-1.969)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7388",
    "data-name": "Group 7388",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7387",
    "data-name": "Group 7387",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11881",
    "data-name": "Path 11881",
    className: "cls-3",
    d: "M2203.648,1988.258a10.5,10.5,0,0,0-1.516,2.636c-.942,2.375-3.973,11.3-4.136,12.2-.123.676-1.354,5.7,1.978,8a3.6,3.6,0,0,1-.729-2.387c.04-2.4,4.157-.7,5.63-2.231s-1.9-4.362-2.641-6.512,1.291-2.088,2.7-2.887-.062-2.641-1.044-5.1a7.076,7.076,0,0,1-.245-3.721",
    transform: "translate(-1983.272 -1794.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11882",
    "data-name": "Path 11882",
    className: "cls-17",
    d: "M2211.257,2220.1h-6.208l2.263,7.5h6.354l2.262-7.5Z",
    transform: "translate(-1989.928 -2003.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11883",
    "data-name": "Path 11883",
    className: "cls-18",
    d: "M2205.049,2220.1l1.958,6.483a6.993,6.993,0,0,0,5.464-6.483h-7.422Z",
    transform: "translate(-1989.928 -2003.509)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390",
    transform: "translate(286.54 193.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7389",
    "data-name": "Group 7389",
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17364",
    "data-name": "Rectangle 17364",
    className: "cls-20",
    width: 16.135,
    height: 25.309,
    transform: "translate(-1.969)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7392",
    "data-name": "Group 7392",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7391",
    "data-name": "Group 7391",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11885",
    "data-name": "Path 11885",
    className: "cls-3",
    d: "M2943.092,1988.258a10.478,10.478,0,0,0-1.515,2.636c-.942,2.375-3.973,11.3-4.137,12.2-.123.676-1.354,5.7,1.978,8a3.6,3.6,0,0,1-.729-2.387c.04-2.4,4.158-.7,5.631-2.231s-1.9-4.362-2.641-6.512,1.291-2.088,2.7-2.887-.062-2.641-1.044-5.1a7.076,7.076,0,0,1-.245-3.721",
    transform: "translate(-2650.577 -1794.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11886",
    "data-name": "Path 11886",
    className: "cls-17",
    d: "M2950.7,2220.1h-6.208l2.263,7.5h6.354l2.262-7.5Z",
    transform: "translate(-2657.233 -2003.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11887",
    "data-name": "Path 11887",
    className: "cls-18",
    d: "M2944.492,2220.1l1.958,6.483a6.992,6.992,0,0,0,5.463-6.483h-7.422Z",
    transform: "translate(-2657.232 -2003.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11888",
    "data-name": "Path 11888",
    className: "cls-3",
    d: "M3172.422,1708.953c1.717,2.031-1.051,1.248-2.231,7.275s1.969,6.068.083,8.846-12.128-2.751-11.468-7.712c.537-4.031,6.1-10.728,10.678-10.117a4.587,4.587,0,0,1,2.938,1.708",
    transform: "translate(-2850.611 -1540.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11889",
    "data-name": "Path 11889",
    className: "cls-21",
    d: "M3252.827,1774.476l-5.522-.231,6.4-.662Z",
    transform: "translate(-2930.503 -1600.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11890",
    "data-name": "Path 11890",
    className: "cls-3",
    d: "M3428.789,1217.3c1.928,16.791-15.5,11.188-20.534,13.925s-1.273,3.87-7.051,6.507-7.383,1.414-12.235,8.467-10.713,8.417-13.3,4.16c0,0-3.63-2.124.189-6.159s4.72-6.06,3.348-10.913,2.455-4.217,8.291-8.235,7.1-3.092,8.539-10.095,5.249-10.029,14.441-14.609a12.874,12.874,0,0,1,7.388-1.57c5.52.736,9.554,6.584,10.925,18.523",
    transform: "translate(-3044.937 -1081.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11891",
    "data-name": "Path 11891",
    className: "cls-22",
    d: "M3425.967,1466.576c-4.839,4.067-14.234,1.978-17.713,3.869-5.034,2.737-1.272,3.869-7.051,6.507s-7.383,1.414-12.235,8.467-10.713,8.417-13.3,4.16c0,0-3.63-2.124.189-6.159s4.72-6.06,3.348-10.913,2.455-4.217,8.291-8.235c.253-.174.5-.336.731-.493,2.655.909,4.765,2.641,5.076,4.47.8,4.676,8.29,2.838,16.032-.859,4.148-1.981,9.6-1.843,13.762-1.288,1.053.14,2.024.307,2.871.473",
    transform: "translate(-3044.937 -1320.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11892",
    "data-name": "Path 11892",
    className: "cls-3",
    d: "M3268.835,1044c6.788,3.05,1.944,7.2,6.094,4.472s12.178.486,12.791,9.15-4.4,6.482-10.788,8.029-6.407,3.564-8.7,15.122-16.418,9.551-16.931,9.608c0,0-12.227-2.007-12.8-10.035s1.33-5.25-1.2-14.674.619-9.384,8.6-18.164c5-5.5,10.073-6.683,14.833-6.049a29.562,29.562,0,0,1,8.1,2.541",
    transform: "translate(-2920.701 -939.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11893",
    "data-name": "Path 11893",
    className: "cls-23",
    d: "M3278.953,1244.576c-6.391,1.547-6.407,3.564-8.7,15.122s-16.418,9.551-16.931,9.608c0,0-12.227-2.007-12.8-10.035s1.331-5.249-1.2-14.674c-.285-1.063-.493-2-.636-2.848,3.111-4.228,7.208,3.709,7.833,9.861.682,6.711,14.608,2.734,18.035.669s1.692-7.97,9.042-11.089c4.878-2.069,11.783-1.648,16.055-1.428-.834,4.873-5.265,3.5-10.7,4.813",
    transform: "translate(-2922.723 -1118.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11894",
    "data-name": "Path 11894",
    className: "cls-23",
    d: "M3492.114,1672.127c2.745,2.133,3.713,7.184-2.157,11.45a10.232,10.232,0,0,1-11.533.357s3.283,6.622-.387,7.647a13.348,13.348,0,0,1-13.956-5.14c-6.019-7.87,3.4-11.285,6.463-12.518s-.347-3.075,1.9-4.795c.979-.749,4.308-.682,7.984-.192,4.774.636,10.133,1.986,11.684,3.19",
    transform: "translate(-3124.355 -1505.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11895",
    "data-name": "Path 11895",
    className: "cls-3",
    d: "M3490.517,1937.944a7.836,7.836,0,0,1-2.825-.047c-1.271-.206-2.293-.379-4.65,1.206-3.743,2.517-7.832-.9-7.832-.9-1.833-1.394-.7-6.125,1.466-6.268s1.323-1.4,8.467-1.026q.5.027.958.088c6.322.843,7.616,6.415,4.416,6.947",
    transform: "translate(-3135.348 -1742.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11896",
    "data-name": "Path 11896",
    className: "cls-21",
    d: "M3396.323,1343.619c-5.067,2.985-5.026,7.408-5.026,7.408a19.319,19.319,0,0,1,9.813-2.605,5.257,5.257,0,0,0,5.646-5.432c2.7,5.283-2.571,8.871-6.787,8.309a15.164,15.164,0,0,0-8.16,1.563s-.4,2.977-4.454,7.863-12.466,6.417-16.517,8.4-5.265,8.26-7.546,10.228-3.3-.818-1.133-7.6,17.26-8.3,22.89-11.717,3.5-7.358,5.736-14.634,7.7-5.664,13.153-4.937,7.7-.993,7.7-.993c-1.314,3.232-10.251,1.158-15.319,4.143",
    transform: "translate(-3033.074 -1208.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11897",
    "data-name": "Path 11897",
    className: "cls-21",
    d: "M3435.884,1752.761a35.081,35.081,0,0,0-8.06.819c-3.53.918-.165,1.24-1.7,3.307-.732.984-1.614.518-2.258.083-.708-.479-1.128-.918-.743.653.736,3,1.786,1.752-3.248,4.489s-9.978,3.846-10.324,15.916-3.407-4.745-2.2-8.118,4.074-10.69,7.893-10.938,4.969-2.241,4.456-4.076c-.256-.917.161-.736.827-.521a2.032,2.032,0,0,0,2.314-.323c1.085-1.158,4.232-3.894,8.339-3.347a9.994,9.994,0,0,1,4.706,2.056",
    transform: "translate(-3074.68 -1579.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11898",
    "data-name": "Path 11898",
    className: "cls-21",
    d: "M3262.584,1772.484c1.968,2.281.828,12.732-.041,6.936s-4.605-8.06-4.605-8.06c-1.562,3.2-6.39,5.333-6.39,5.333a24.86,24.86,0,0,0,3.96-6.035,2.009,2.009,0,0,1,2.281-1.392c1.608.215,3.563,1.789,4.8,3.217",
    transform: "translate(-2934.333 -1596.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11899",
    "data-name": "Path 11899",
    className: "cls-21",
    d: "M3441.287,1984.9c-.472,4.429-9.676-.54-9.46,3.528s-.512,5.737-3.059,5.9-3.729-5.167-3.729-5.167,4.911,2.926,4.811-.116,2.075-5.151,6.3-3.7,3.629-5.448,3.934-6.8a11.762,11.762,0,0,1,1.2,6.352",
    transform: "translate(-3090.899 -1785.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11900",
    "data-name": "Path 11900",
    className: "cls-21",
    d: "M3330.96,1129.722c-3.19,6.9-2.263,18.882-2.263,18.882s.19,1.414,5.9-4.514,5.6-17.428,5.6-17.428c3.011,15.294-6.446,21.859-8.694,23.579s-1.422,3.092-1.422,3.092c3.5-4.457,10.26-.274,8.275-.538s-7.812.853-9.125,7.872.786,15.881.837,28.761,6.23,37.557,6.784,40.029,9.136,8.159,6.052,7.622-7.945-1.942-7.945-1.942,8.317,3.885,2.894,2.91-16.857-1.363-16.857-1.363,1.586-4.332,2.851-9.086-.8-13.864-.8-13.864l2.356,2.207a76.116,76.116,0,0,0-2.341-15.583c-2.283-9.391,1.486-14.947,1.4-20.007s-1.126-14.286-.093-21.09,2.437-11.665.816-14.657-1.159-10.252-1.159-10.252,2.895,6.7,2.959,2.414,6.844-13.476,6.844-13.476,0-.007.007-.006-.08.38-2.883,6.439",
    transform: "translate(-2997.012 -1013.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11901",
    "data-name": "Path 11901",
    className: "cls-21",
    d: "M3543.911,1989.538l-.666,1.448a8.911,8.911,0,0,1-3.26-5.694s2.684,4.258,3.926,4.246",
    transform: "translate(-3194.63 -1791.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11902",
    "data-name": "Path 11902",
    className: "cls-24",
    d: "M3342.12,2116.272a4.465,4.465,0,0,0,1.415-1.781,17.9,17.9,0,0,0,.919-2.1,15.93,15.93,0,0,0,.623-2.214,16.622,16.622,0,0,0,.363-4.579c-.009-.384-.062-.765-.091-1.148-.057-.379-.094-.762-.179-1.137a13.382,13.382,0,0,0-1.517-4.31,11.376,11.376,0,0,1,.8,2.129,18,18,0,0,1,.49,2.22,19.278,19.278,0,0,1-.706,8.964,18.1,18.1,0,0,1-.834,2.115,4.6,4.6,0,0,1-1.286,1.845",
    transform: "translate(-3016.069 -1894.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11903",
    "data-name": "Path 11903",
    className: "cls-24",
    d: "M3352.06,1920.479a.607.607,0,0,0,.417-.393,4.142,4.142,0,0,0,.179-.567l.307-1.146c.2-.766.388-1.535.56-2.309a31.027,31.027,0,0,0,.675-4.707,18.513,18.513,0,0,0-.322-4.753c-.155-.78-.347-1.549-.532-2.318l-.558-2.306-2.29-9.211c-.389-1.533-.773-3.067-1.119-4.609s-.658-3.093-.9-4.656c.176,1.573.451,3.133.758,4.687s.677,3.093,1.039,4.633l2.224,9.228.571,2.3c.19.768.385,1.533.542,2.3a17.754,17.754,0,0,1,.324,2.332,22.65,22.65,0,0,1,.035,2.357,31.114,31.114,0,0,1-.59,4.689c-.149.776-.317,1.548-.494,2.319l-.275,1.154a4.118,4.118,0,0,1-.156.569.6.6,0,0,1-.4.4",
    transform: "translate(-3021.807 -1699.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11904",
    "data-name": "Path 11904",
    className: "cls-24",
    d: "M3369.543,1643.779a37.074,37.074,0,0,0,.86-7.685c.054-2.583-.063-5.163-.112-7.738-.033-1.288-.057-2.575-.041-3.861s.063-2.574.115-3.861c.112-2.574.3-5.146.452-7.72-.141,1.282-.263,2.565-.385,3.849s-.213,2.571-.3,3.859c-.166,2.575-.2,5.162-.142,7.741s.187,5.154.18,7.729c0,1.287-.042,2.574-.144,3.857a35.95,35.95,0,0,1-.488,3.831",
    transform: "translate(-3040.816 -1455.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11905",
    "data-name": "Path 11905",
    className: "cls-24",
    d: "M3352.427,1625.191c.3-1.98.563-3.964.825-5.948.137-.992.252-1.985.377-2.978l.185-1.49c.062-.5.122-1,.137-1.508.018-1.024-.166-2.012-.184-3s.02-1.99.068-2.988.12-2,.141-3a18.325,18.325,0,0,0-.182-3,34.509,34.509,0,0,1-.187,5.986,29.453,29.453,0,0,0-.11,3.011c.011,1.011.185,2.008.158,2.989-.01.491-.064.985-.122,1.482l-.17,1.491c-.113.994-.235,1.987-.336,2.983-.213,1.99-.423,3.981-.6,5.975",
    transform: "translate(-3025.37 -1445.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11906",
    "data-name": "Path 11906",
    className: "cls-24",
    d: "M3357.491,1301.8c.246-1.274.474-2.552.612-3.847.063-.647.1-1.3.1-1.95s-.036-1.3-.071-1.949-.071-1.293-.078-1.937a18.735,18.735,0,0,1,.088-1.929c.121-1.284.331-2.566.51-3.851l.528-3.855.26-1.93a8.685,8.685,0,0,0,.055-1.966,25.085,25.085,0,0,0-2.179-7.464,28.69,28.69,0,0,1,1.239,3.681c.167.625.313,1.255.434,1.89a16.988,16.988,0,0,1,.278,1.911,19.415,19.415,0,0,1-.354,3.84l-.554,3.852c-.169,1.285-.371,2.567-.485,3.867a19.088,19.088,0,0,0-.075,1.957c.008.653.058,1.3.107,1.949s.1,1.292.111,1.937-.012,1.291-.057,1.936c-.089,1.291-.289,2.574-.469,3.859",
    transform: "translate(-3029.782 -1147.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11907",
    "data-name": "Path 11907",
    className: "cls-24",
    d: "M3379.452,1203.194a8.121,8.121,0,0,0-1.361,2.335,11.3,11.3,0,0,0-.609,2.646c-.123.89-.235,1.782-.344,2.674s-.2,1.786-.294,2.681l.127-.064a1.343,1.343,0,0,1-.61-.779,4.707,4.707,0,0,1-.206-1.038,4.1,4.1,0,0,0,.11,1.068,1.8,1.8,0,0,0,.215.508,1.206,1.206,0,0,0,.407.392l.108.063.021-.127c.139-.888.278-1.776.4-2.667s.242-1.781.351-2.673a13.624,13.624,0,0,1,.513-2.616,9.933,9.933,0,0,1,1.171-2.4",
    transform: "translate(-3046.783 -1085.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11908",
    "data-name": "Path 11908",
    className: "cls-24",
    d: "M3386.51,1290.82c-.7,1.132-1.375,2.273-2.108,3.379a34.351,34.351,0,0,1-2.333,3.213,21.569,21.569,0,0,1-2.785,2.809,10.23,10.23,0,0,0-1.463,1.386,9.157,9.157,0,0,0-1.047,1.727,9.317,9.317,0,0,0-.76,1.871c-.144.666-.223,1.317-.333,1.974-.2,1.313-.413,2.626-.568,3.948s-.291,2.645-.361,3.974a37.709,37.709,0,0,0,0,3.987,52.34,52.34,0,0,1,.585-7.931q.284-1.969.608-3.934c.114-.651.2-1.32.343-1.952a9.156,9.156,0,0,1,.75-1.806,8.9,8.9,0,0,1,1-1.681,10.025,10.025,0,0,1,1.416-1.358,19.985,19.985,0,0,0,2.787-2.871,46.9,46.9,0,0,0,4.266-6.736",
    transform: "translate(-3045.471 -1164.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11909",
    "data-name": "Path 11909",
    className: "cls-24",
    d: "M3387.272,1536.448a18.656,18.656,0,0,0-.25,5.372c.1,1.795.3,3.58.384,5.367.05.893.075,1.786.05,2.678-.011.447-.041.891-.075,1.336s-.087.894-.09,1.35a21.227,21.227,0,0,0,.322,2.685,22.829,22.829,0,0,1,.191,2.679,19.554,19.554,0,0,0-.047-2.695,21.378,21.378,0,0,1-.238-2.663c.018-.442.075-.885.117-1.333s.074-.9.09-1.351c.035-.9.02-1.8-.023-2.7-.106-1.8-.3-3.582-.453-5.368-.076-.892-.137-1.786-.153-2.681a13.459,13.459,0,0,1,.176-2.675",
    transform: "translate(-3056.523 -1386.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11910",
    "data-name": "Path 11910",
    className: "cls-24",
    d: "M3388.47,1846.806q-.292,2.734-.366,5.49a45.662,45.662,0,0,0,.151,5.506c.164,1.831.424,3.65.719,5.461.15.905.314,1.808.476,2.71a13.633,13.633,0,0,0,.284,1.36,2.4,2.4,0,0,0,.743,1.225l.125.1.073-.142a6.363,6.363,0,0,0,.668-2.786,11.6,11.6,0,0,0-.314-2.834c-.415-1.853-1.122-3.615-1.408-5.487a19.676,19.676,0,0,0,.557,2.779c.234.916.49,1.825.68,2.746a11.429,11.429,0,0,1,.255,2.789,6.375,6.375,0,0,1-.669,2.673l.2-.042a2.143,2.143,0,0,1-.648-1.1c-.124-.427-.186-.881-.268-1.332l-.461-2.71c-.305-1.805-.576-3.616-.751-5.437a51.744,51.744,0,0,1-.238-5.479q.019-2.747.194-5.493",
    transform: "translate(-3057.547 -1666.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11911",
    "data-name": "Path 11911",
    className: "cls-24",
    d: "M3419.186,2101.667a6.577,6.577,0,0,0-.454-2.038,19.988,19.988,0,0,1-.669-1.977,9.4,9.4,0,0,1-.208-2.064c-.023-.7-.082-1.4-.172-2.093-.17-1.389-.438-2.761-.6-4.142a18.868,18.868,0,0,1-.165-2.072,10.817,10.817,0,0,1,.131-2.062,4.345,4.345,0,0,1,.1-.506c.039-.162.073-.347.118-.49.024-.07.061-.113.078-.115s.043,0,.09.041a1.423,1.423,0,0,1,.212.412c.121.315.213.654.315.987s.2.668.289,1c.372,1.341.7,2.694.974,4.059a56.234,56.234,0,0,1,1.024,8.282l.212-.054c-.4-.805-.8-1.61-1.123-2.443a10.138,10.138,0,0,1-.674-2.583c-.105-.887-.115-1.8-.283-2.685a25.053,25.053,0,0,0-.656-2.62c.221.872.444,1.745.581,2.632s.132,1.786.217,2.688a10.143,10.143,0,0,0,.643,2.634c.317.848.706,1.664,1.094,2.475l.231.483-.018-.537a53,53,0,0,0-.971-8.328c-.271-1.372-.585-2.737-.972-4.082-.1-.336-.192-.673-.3-1.007s-.2-.669-.327-1.006a1.58,1.58,0,0,0-.277-.506.436.436,0,0,0-.159-.1.325.325,0,0,0-.222,0,.437.437,0,0,0-.241.28c-.059.19-.083.35-.126.527a4.6,4.6,0,0,0-.1.522,11.011,11.011,0,0,0-.124,2.11,18.53,18.53,0,0,0,.178,2.1c.187,1.39.473,2.757.663,4.135.1.689.169,1.38.2,2.075a9.064,9.064,0,0,0,.257,2.086c.365,1.355,1.142,2.574,1.231,3.987",
    transform: "translate(-3083.328 -1880.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11912",
    "data-name": "Path 11912",
    className: "cls-24",
    d: "M3427.837,1585.479a6.775,6.775,0,0,0-1.668.568c-.541.223-1.094.417-1.653.59-1.117.349-2.252.645-3.389.951-.566.163-1.131.333-1.691.521a9.6,9.6,0,0,0-1.646.681,4.658,4.658,0,0,0-1.385,1.13,4.237,4.237,0,0,0-.8,1.578,4.51,4.51,0,0,1,2.286-2.507,11.861,11.861,0,0,1,1.624-.627c.557-.178,1.122-.337,1.688-.492,1.126-.329,2.269-.622,3.382-1.021.555-.2,1.1-.42,1.639-.673a7.6,7.6,0,0,1,1.609-.7",
    transform: "translate(-3082.389 -1430.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11913",
    "data-name": "Path 11913",
    className: "cls-24",
    d: "M3418.294,1622.573c.156-.3.307-.6.48-.884a7.279,7.279,0,0,1,.542-.841c.4-.535.751-1.109,1.167-1.62a4.524,4.524,0,0,1,1.5-1.22,4.429,4.429,0,0,1,.921-.349,4.744,4.744,0,0,1,.985-.162,3.866,3.866,0,0,0-1.015.02,4.531,4.531,0,0,0-.987.285,4.157,4.157,0,0,0-1.639,1.241,18.108,18.108,0,0,0-1.129,1.688,7.544,7.544,0,0,0-.829,1.844",
    transform: "translate(-3084.811 -1459.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11914",
    "data-name": "Path 11914",
    className: "cls-24",
    d: "M3439.942,1815.867a10.137,10.137,0,0,1-1.271,1.569,5.093,5.093,0,0,1-1.625,1.133,4.2,4.2,0,0,1-.945.266c-.326.053-.661.071-1,.094a4.412,4.412,0,0,0-2.021.473,3.979,3.979,0,0,0-1.406,1.534,10.169,10.169,0,0,0-.784,1.9,13.615,13.615,0,0,1-.72,1.883,4.085,4.085,0,0,1-1.241,1.561,3.948,3.948,0,0,0,1.369-1.493,13.569,13.569,0,0,0,.807-1.876,11.829,11.829,0,0,1,.8-1.837,3.717,3.717,0,0,1,1.32-1.412c1.117-.691,2.622-.241,3.908-.881a5.237,5.237,0,0,0,1.637-1.241,9.042,9.042,0,0,0,1.167-1.669",
    transform: "translate(-3094.41 -1638.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11915",
    "data-name": "Path 11915",
    className: "cls-24",
    d: "M3436.886,1868.914a16.351,16.351,0,0,0,2.2-2.675,5.451,5.451,0,0,0,.762-1.582l.486-1.662a2.083,2.083,0,0,1,.815-1.351,2.171,2.171,0,0,1,.773-.243c.139-.021.28-.036.423-.051a1.423,1.423,0,0,1,.4.008.562.562,0,0,1,.321.145.251.251,0,0,1,.016.293,1.42,1.42,0,0,1-.265.3c-.1.1-.206.2-.311.3a2.8,2.8,0,0,1-1.471.82,2.73,2.73,0,0,0,1.566-.71c.113-.092.222-.188.33-.284a1.568,1.568,0,0,0,.314-.333.45.45,0,0,0-.018-.517.759.759,0,0,0-.437-.238,1.653,1.653,0,0,0-.464-.031c-.144.01-.29.025-.436.044a2.435,2.435,0,0,0-.87.262,1.653,1.653,0,0,0-.641.671,4.128,4.128,0,0,0-.324.833l-.46,1.665a5.641,5.641,0,0,1-.29.793,8.468,8.468,0,0,1-.406.746,23.461,23.461,0,0,1-2.011,2.8",
    transform: "translate(-3101.589 -1679.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11916",
    "data-name": "Path 11916",
    className: "cls-24",
    d: "M3540.491,1760.838a3.144,3.144,0,0,0,1-1.408,3.22,3.22,0,0,0,.123-1.751l-.068.123a16.434,16.434,0,0,0,2.825-1.115,7.139,7.139,0,0,0,1.275-.859c.387-.338.73-.711,1.087-1.059a5.352,5.352,0,0,1,2.514-1.479,5.409,5.409,0,0,1,2.95.072,5.025,5.025,0,0,0-2.993-.258,5.277,5.277,0,0,0-1.441.532,6.083,6.083,0,0,0-1.219.938c-.369.35-.713.714-1.09,1.032a7.333,7.333,0,0,1-1.216.838,20.323,20.323,0,0,1-2.76,1.161l-.091.034.023.089a3.153,3.153,0,0,1-.043,1.663,3.243,3.243,0,0,1-.875,1.449",
    transform: "translate(-3195.087 -1581.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11917",
    "data-name": "Path 11917",
    className: "cls-24",
    d: "M3580.847,2006.514a.231.231,0,0,1,.108.251,1.754,1.754,0,0,1-.058.3c-.05.212-.083.426-.112.641s-.044.432-.048.647a1,1,0,0,1-.138.594.5.5,0,0,0,.251-.237,1.261,1.261,0,0,0,.117-.326c.051-.215.083-.427.112-.642s.044-.43.047-.648a1.114,1.114,0,0,0-.027-.347.426.426,0,0,0-.087-.165.184.184,0,0,0-.164-.066",
    transform: "translate(-3231.282 -1810.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11918",
    "data-name": "Path 11918",
    className: "cls-24",
    d: "M3508.531,2046.043a.794.794,0,0,1-.561.652,2.187,2.187,0,0,1-.882.182,8.393,8.393,0,0,1-.925-.047l-.94-.08c-.627-.044-1.255-.088-1.885-.108l-.945-.03c-.316,0-.63-.008-.947,0,.312.057.624.1.936.144l.938.112c.625.074,1.252.126,1.879.177a12.813,12.813,0,0,0,1.9.058,2.327,2.327,0,0,0,.934-.281,1.277,1.277,0,0,0,.371-.322.574.574,0,0,0,.124-.457",
    transform: "translate(-3159.851 -1846.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11919",
    "data-name": "Path 11919",
    className: "cls-24",
    d: "M3468.4,2060.939a.337.337,0,0,1-.136.323,3.035,3.035,0,0,0-.28.277,1.1,1.1,0,0,0-.151.379,1.276,1.276,0,0,1-.158.314,2.283,2.283,0,0,0-.395.706.8.8,0,0,0,.033.451,1.657,1.657,0,0,1,.1.336,1.326,1.326,0,0,1-.033.342,1.24,1.24,0,0,0,0,.425,2.066,2.066,0,0,1,.048.356.618.618,0,0,1-.09.3,1.765,1.765,0,0,1-.465.545.489.489,0,0,1-.652-.055.542.542,0,0,0,.722.182,1.711,1.711,0,0,0,.59-.55.788.788,0,0,0,.153-.414,2.264,2.264,0,0,0-.028-.407.963.963,0,0,1,.007-.339,1.548,1.548,0,0,0,.041-.419,1.814,1.814,0,0,0-.119-.4.544.544,0,0,1-.032-.3,2.475,2.475,0,0,1,.318-.644,1.322,1.322,0,0,0,.148-.386,1.024,1.024,0,0,1,.085-.346,2.76,2.76,0,0,1,.219-.305.351.351,0,0,0,.076-.373",
    transform: "translate(-3128.062 -1859.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11920",
    "data-name": "Path 11920",
    className: "cls-24",
    d: "M3673.275,1351.648c-1.226.076-2.448.122-3.674.3a6.732,6.732,0,0,0-1.792.519,4.527,4.527,0,0,0-.813.484,3.568,3.568,0,0,0-.36.311c-.058.054-.118.106-.172.164l-.155.18a6.043,6.043,0,0,0-.931,1.627,15.579,15.579,0,0,0-.57,1.76c-.164.591-.326,1.18-.532,1.753a7.4,7.4,0,0,1-.785,1.649,6.735,6.735,0,0,0,.92-1.6c.236-.57.425-1.158.614-1.74a9.2,9.2,0,0,1,1.509-3.262l.142-.171c.05-.054.106-.1.159-.155a3.159,3.159,0,0,1,.331-.294,4.221,4.221,0,0,1,.757-.465,7.454,7.454,0,0,1,1.719-.538c.595-.123,1.2-.2,1.81-.272s1.216-.161,1.823-.256",
    transform: "translate(-3306.087 -1219.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11921",
    "data-name": "Path 11921",
    className: "cls-24",
    d: "M3288.425,1783.908c-.2-.17-.414-.324-.62-.487l-.316-.233-.159-.115a.369.369,0,0,0-.254-.089.557.557,0,0,0-.225.1l-.173.112a3.493,3.493,0,0,0-.315.261,4.8,4.8,0,0,0-.529.61c-.311.433-.57.887-.861,1.31a3.525,3.525,0,0,1-1.083,1.083,2.364,2.364,0,0,0,.7-.376,3.655,3.655,0,0,0,.565-.567c.342-.411.613-.861.917-1.275a4.948,4.948,0,0,1,.485-.585,3.221,3.221,0,0,1,.275-.254l.15-.11a.488.488,0,0,1,.122-.078c.02-.024.173.082.278.138l.343.192c.232.122.46.252.7.365",
    transform: "translate(-2963.52 -1609.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11922",
    "data-name": "Path 11922",
    className: "cls-24",
    d: "M3291.2,1774.947a1.422,1.422,0,0,0-.561.354,2.942,2.942,0,0,0-.409.513,11.315,11.315,0,0,0-.595,1.135,2,2,0,0,0,.477-.451c.137-.169.251-.349.368-.525a7.579,7.579,0,0,1,.719-1.027",
    transform: "translate(-2968.708 -1601.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11923",
    "data-name": "Path 11923",
    className: "cls-24",
    d: "M3676.061,1438.809a20.651,20.651,0,0,1-2.834.452c-.475.042-.952.056-1.428.066a10.7,10.7,0,0,0-1.455.074,6.769,6.769,0,0,0-1.405.417c-.448.175-.9.35-1.337.551a9.3,9.3,0,0,0-1.285.69,5.726,5.726,0,0,0-1.108.956l.155.043a4.764,4.764,0,0,1,.083-2.416,4.419,4.419,0,0,0-.26,2.452l.031.169.124-.126a5.505,5.505,0,0,1,1.108-.87,9.487,9.487,0,0,1,1.261-.65c.436-.19.884-.356,1.333-.525a7.09,7.09,0,0,1,1.345-.417,10.534,10.534,0,0,1,1.417-.094,15.226,15.226,0,0,0,4.256-.772",
    transform: "translate(-3307.553 -1298.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11924",
    "data-name": "Path 11924",
    className: "cls-24",
    d: "M3700.937,1364.757a11.072,11.072,0,0,0-1.083.4,3.277,3.277,0,0,0-.523.279,2.472,2.472,0,0,0-.454.4,5.26,5.26,0,0,0-.649.971,11.464,11.464,0,0,0-.515,1.035q.38-.442.708-.908a10.092,10.092,0,0,1,.677-.9,3.1,3.1,0,0,1,.86-.671c.332-.187.662-.389.979-.608",
    transform: "translate(-3336.97 -1231.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11925",
    "data-name": "Path 11925",
    className: "cls-24",
    d: "M3378.413,1405.467a10.62,10.62,0,0,0-.461,2.547,19.33,19.33,0,0,0-.038,2.584,20.138,20.138,0,0,0,.333-2.561c.061-.857.117-1.705.166-2.57",
    transform: "translate(-3048.345 -1268.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11926",
    "data-name": "Path 11926",
    className: "cls-24",
    d: "M3469.62,1255.539a10.641,10.641,0,0,1-.311,1.383,13.333,13.333,0,0,1-.489,1.325c-.172.437-.351.877-.534,1.313s-.36.874-.552,1.305a25.326,25.326,0,0,1-1.25,2.532c-.232.41-.482.811-.745,1.2s-.536.779-.816,1.163c.332-.341.636-.706.934-1.078s.563-.768.822-1.169a17.8,17.8,0,0,0,1.327-2.532c.373-.877.728-1.753,1.028-2.659a12.931,12.931,0,0,0,.416-1.368,8.278,8.278,0,0,0,.17-1.418",
    transform: "translate(-3126.892 -1133.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11927",
    "data-name": "Path 11927",
    className: "cls-24",
    d: "M3547.137,2003.069a.948.948,0,0,0-.079-.465,3.675,3.675,0,0,0-.206-.417,3.958,3.958,0,0,0-.512-.781,7.458,7.458,0,0,0-.657-.647l-.685-.608a7.022,7.022,0,0,0,1.119,1.449,8.788,8.788,0,0,1,.542.711,2.672,2.672,0,0,1,.478.759",
    transform: "translate(-3199.154 -1805.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11928",
    "data-name": "Path 11928",
    className: "cls-25",
    d: "M3574.233,1490.269c-.522.95-1.014,1.913-1.5,2.879-.249.481-.479.968-.762,1.418a6.367,6.367,0,0,1-.992,1.234,10.01,10.01,0,0,1-2.63,1.8c-.479.244-.973.459-1.473.663s-1,.4-1.5.611a21.917,21.917,0,0,0,3.074-1.068,11.4,11.4,0,0,0,1.449-.767,8.278,8.278,0,0,0,1.292-1.025,6.464,6.464,0,0,0,1.021-1.3,14.383,14.383,0,0,0,.727-1.465c.446-.986.887-1.975,1.3-2.977",
    transform: "translate(-3217.54 -1344.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11929",
    "data-name": "Path 11929",
    className: "cls-25",
    d: "M3400.41,1791.263c.144-.6.268-1.206.385-1.813s.195-1.223.25-1.843a11.8,11.8,0,0,0,.015-1.867,14.793,14.793,0,0,0-.278-1.846,33.207,33.207,0,0,1-.621-3.634c-.074-.611-.126-1.224-.164-1.838l-.052-.924a1.98,1.98,0,0,0-.225-.9,2.132,2.132,0,0,1,.147.9l-.014.926q.011.928.082,1.855a28.608,28.608,0,0,0,.558,3.671,14.369,14.369,0,0,1,.3,1.808,14.976,14.976,0,0,1,.028,1.832c-.057,1.225-.247,2.445-.409,3.67",
    transform: "translate(-3068.049 -1603.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11930",
    "data-name": "Path 11930",
    className: "cls-25",
    d: "M3460.639,1589.21a15.84,15.84,0,0,0-1.6.365c-.526.152-1.045.327-1.561.51-1.031.368-2.036.8-3.045,1.209s-2.011.844-3.008,1.294a10.989,10.989,0,0,0-1.453.779,4.559,4.559,0,0,0-1.188,1.132,6.977,6.977,0,0,1,2.731-1.7c1.013-.4,2.024-.812,3.032-1.229l3.012-1.271a29.168,29.168,0,0,1,3.08-1.087",
    transform: "translate(-3112.326 -1434.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11931",
    "data-name": "Path 11931",
    className: "cls-25",
    d: "M3397.823,1422.073q-1.679.589-3.333,1.243a6.659,6.659,0,0,0-1.586.861,3.788,3.788,0,0,0-1.13,1.433,11.256,11.256,0,0,0-.573,1.7c-.157.571-.323,1.139-.47,1.714l-.45,1.72c-.139.576-.289,1.149-.42,1.728.2-.56.373-1.125.56-1.688l.53-1.7c.18-.564.34-1.135.51-1.7a11.2,11.2,0,0,1,.581-1.653,3.5,3.5,0,0,1,1.029-1.346,7.441,7.441,0,0,1,1.51-.865c.536-.246,1.085-.474,1.625-.713s1.082-.483,1.618-.737",
    transform: "translate(-3059.152 -1283.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11932",
    "data-name": "Path 11932",
    className: "cls-25",
    d: "M3389.708,1267.208a.35.35,0,0,1-.4-.065.589.589,0,0,1-.181-.368,8.3,8.3,0,0,1-.036-.871c-.009-.584.009-1.169.043-1.753l.227-3.509q.085-1.757.255-3.5c.108-1.166.25-2.329.393-3.495-.135.571-.242,1.149-.351,1.727s-.188,1.16-.268,1.742c-.161,1.165-.244,2.34-.323,3.511-.054,1.172-.138,2.341-.158,3.519-.006.588,0,1.178.04,1.766a8.089,8.089,0,0,0,.1.881.648.648,0,0,0,.231.387.372.372,0,0,0,.423.03",
    transform: "translate(-3058.293 -1131.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11933",
    "data-name": "Path 11933",
    className: "cls-25",
    d: "M3422.356,1950.857a29.512,29.512,0,0,0,.38,4.242c.22,1.4.5,2.8.738,4.195.119.7.237,1.4.336,2.1.051.35.093.7.135,1.052s.08.709.148,1.064a20.4,20.4,0,0,0,.63,2.048,19.72,19.72,0,0,1,.52,2.047c.57,2.764.681,5.632,1.432,8.395a15.633,15.633,0,0,0,.7,2.023,7.866,7.866,0,0,0,1.063,1.862,6.491,6.491,0,0,0,1.619,1.4,18.011,18.011,0,0,0,1.881,1,20.966,20.966,0,0,1-1.838-1.069,6.391,6.391,0,0,1-1.547-1.421,7.783,7.783,0,0,1-1-1.845,15.413,15.413,0,0,1-.653-2.009c-.7-2.74-.809-5.594-1.363-8.4a19.913,19.913,0,0,0-.541-2.074,20.667,20.667,0,0,1-.635-2.014c-.068-.341-.109-.69-.151-1.043s-.09-.707-.143-1.059c-.1-.7-.232-1.4-.366-2.1-.271-1.4-.569-2.782-.819-4.177q-.192-1.046-.332-2.1t-.191-2.119",
    transform: "translate(-3088.477 -1760.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11934",
    "data-name": "Path 11934",
    className: "cls-25",
    d: "M3407.333,1994.279a3.35,3.35,0,0,0,.063-1.062c-.026-.355-.088-.7-.147-1.044a13.009,13.009,0,0,0-.521-2.038,13.194,13.194,0,0,0,.23,2.091c.126.694.306,1.35.375,2.053",
    transform: "translate(-3074.374 -1795.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11935",
    "data-name": "Path 11935",
    className: "cls-25",
    d: "M3623.874,1766.231a3.047,3.047,0,0,0-1.631-.2,8.728,8.728,0,0,1-1.6.069c-.268-.015-.547-.039-.828-.03a4.917,4.917,0,0,0-.832.1,4.519,4.519,0,0,0-1.533.611,7.092,7.092,0,0,1,1.571-.383,7.252,7.252,0,0,1,1.6,0,4.836,4.836,0,0,0,.838-.014c.276-.032.547-.076.814-.122a3.9,3.9,0,0,1,1.6-.029",
    transform: "translate(-3264.534 -1593.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11936",
    "data-name": "Path 11936",
    className: "cls-25",
    d: "M3582.544,1794.823c0-.041.059.014.053.03l.008.109c0,.073.009.146.009.218a1.909,1.909,0,0,1-.033.417.934.934,0,0,1-.4.624.819.819,0,0,1-.721.019,4.235,4.235,0,0,1-.738-.443,1.932,1.932,0,0,0,.64.651.965.965,0,0,0,.974.025,1.052,1.052,0,0,0,.47-.849,1.484,1.484,0,0,0-.053-.464,2.039,2.039,0,0,0-.072-.216l-.045-.106a.088.088,0,0,0-.055-.04.07.07,0,0,0-.032,0,.015.015,0,0,0-.008.027",
    transform: "translate(-3231.397 -1619.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11937",
    "data-name": "Path 11937",
    className: "cls-25",
    d: "M3490.464,1817.53a7.262,7.262,0,0,1,.334,2.475l.093-.1a5,5,0,0,0-2.379.782c-.721.426-1.382.915-2.062,1.382s-1.345.953-2.009,1.441-1.328.978-1.98,1.484q1.058-.644,2.09-1.324t2.061-1.367l1.021-.7c.338-.235.674-.466,1.024-.675a5.224,5.224,0,0,1,2.243-.831l.1-.008v-.088a6.175,6.175,0,0,0-.531-2.479",
    transform: "translate(-3142.718 -1640.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11938",
    "data-name": "Path 11938",
    className: "cls-25",
    d: "M3401.017,1634.511c.127-.615.274-1.223.368-1.85a8.161,8.161,0,0,0,.052-1.9c-.053-.629-.114-1.249-.209-1.873-.05-.311-.1-.622-.169-.93a9.084,9.084,0,0,0-.261-.909c.092.623.156,1.242.2,1.864l.14,1.87a11.621,11.621,0,0,1,.018,1.853c-.045.619-.136,1.244-.143,1.875",
    transform: "translate(-3069.023 -1468.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11939",
    "data-name": "Path 11939",
    className: "cls-25",
    d: "M3720.723,1428.209a4.044,4.044,0,0,1-.963,1.1,5.188,5.188,0,0,1-1.247.746,9.229,9.229,0,0,1-2.838.642c-.977.095-1.969.116-2.957.24-.493.061-.984.133-1.472.22s-.973.2-1.451.326c.491-.064.979-.135,1.472-.182s.981-.1,1.473-.137c.981-.07,1.969-.083,2.962-.172a8.263,8.263,0,0,0,2.9-.731,5.26,5.26,0,0,0,1.247-.843,3.762,3.762,0,0,0,.868-1.21",
    transform: "translate(-3347.875 -1288.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11940",
    "data-name": "Path 11940",
    className: "cls-26",
    d: "M3466.359,1387.568a1.5,1.5,0,0,0,1.019-.149,5.172,5.172,0,0,0,.873-.571c.543-.417,1.078-.846,1.595-1.3a21.558,21.558,0,0,0,2.858-2.981,14.358,14.358,0,0,0,2.063-3.6,10.03,10.03,0,0,0,.708-4.054,13.624,13.624,0,0,1-1.134,3.874,17.551,17.551,0,0,1-2.1,3.416,30.941,30.941,0,0,1-2.7,3.007q-.724.714-1.468,1.415a5.479,5.479,0,0,1-.765.648,1.52,1.52,0,0,1-.938.292",
    transform: "translate(-3128.187 -1240.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11941",
    "data-name": "Path 11941",
    className: "cls-26",
    d: "M3594.28,1258.669c.429-.426.845-.837,1.279-1.223a16.817,16.817,0,0,1,2.81-2.012c.5-.287,1.027-.549,1.568-.82a5.715,5.715,0,0,0-1.767.4,7.315,7.315,0,0,0-2.941,2.109,5.748,5.748,0,0,0-.949,1.543",
    transform: "translate(-3243.628 -1132.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11942",
    "data-name": "Path 11942",
    className: "cls-26",
    d: "M3502.109,1261.16a.911.911,0,0,0,.447.012,1.525,1.525,0,0,0,.423-.177,4.382,4.382,0,0,0,.7-.559c.436-.4.861-.809,1.261-1.244a23.621,23.621,0,0,0,2.22-2.765,23.889,23.889,0,0,0,1.776-3.069,19.471,19.471,0,0,0,1.259-3.3c-.542,1.047-1.086,2.079-1.668,3.088s-1.2,1.995-1.855,2.951-1.354,1.888-2.08,2.8c-.18.229-.367.452-.554.676s-.375.447-.566.668a4.678,4.678,0,0,1-.59.627,1.082,1.082,0,0,1-.776.3",
    transform: "translate(-3160.449 -1128.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11943",
    "data-name": "Path 11943",
    className: "cls-26",
    d: "M3559.287,1166.782a12.781,12.781,0,0,0,1.246-1.641,18.682,18.682,0,0,0,1.849-3.664,12.663,12.663,0,0,0,.579-1.978c-.363.589-.685,1.189-1,1.789s-.621,1.2-.93,1.806-.606,1.208-.9,1.821-.586,1.226-.845,1.867",
    transform: "translate(-3212.05 -1046.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11944",
    "data-name": "Path 11944",
    className: "cls-26",
    d: "M3461.9,1204.83a11.012,11.012,0,0,0,1.535-1.807,14.1,14.1,0,0,0,2-4.3,10.927,10.927,0,0,0,.392-2.339c-.28.741-.545,1.472-.831,2.193s-.586,1.432-.916,2.129-.674,1.389-1.037,2.073-.757,1.356-1.143,2.047",
    transform: "translate(-3124.165 -1079.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11945",
    "data-name": "Path 11945",
    className: "cls-26",
    d: "M3679.407,1246.437a4.546,4.546,0,0,0-1.666-.193,5.8,5.8,0,0,0-3.145,1.155,4.508,4.508,0,0,0-1.143,1.226c.468-.3.923-.588,1.392-.837a11.773,11.773,0,0,1,2.958-1.088c.519-.114,1.048-.192,1.6-.263",
    transform: "translate(-3315.079 -1124.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11946",
    "data-name": "Path 11946",
    className: "cls-26",
    d: "M3662.851,1200.6a.19.19,0,0,0-.071-.185.616.616,0,0,0-.174-.106,3.263,3.263,0,0,0-.356-.14,3.52,3.52,0,0,0-.754-.151,5.1,5.1,0,0,0-1.522.1,8.175,8.175,0,0,0-1.429.449,3.32,3.32,0,0,0-.7.347.727.727,0,0,0-.253.347.43.43,0,0,0,.048.392.407.407,0,0,1,.1-.318.56.56,0,0,1,.256-.171,6.689,6.689,0,0,1,.684-.156l1.413-.31a11.52,11.52,0,0,1,1.4-.22,6.756,6.756,0,0,1,.71-.024c.121,0,.24.009.363.013a.556.556,0,0,1,.169.023.148.148,0,0,1,.118.11",
    transform: "translate(-3300.745 -1082.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11947",
    "data-name": "Path 11947",
    className: "cls-26",
    d: "M3640.272,1150.123a9.036,9.036,0,0,0-1.846.775c-.593.3-1.165.624-1.739.966a8.621,8.621,0,0,0-1.612,1.229,3.745,3.745,0,0,0-1.042,1.737,6.23,6.23,0,0,1,1.348-1.391,17.857,17.857,0,0,1,1.617-1.07c.557-.346,1.124-.7,1.665-1.076s1.06-.791,1.61-1.171",
    transform: "translate(-3279.503 -1037.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11948",
    "data-name": "Path 11948",
    className: "cls-26",
    d: "M3599.732,1156.349a5.121,5.121,0,0,0-1.229,1.231,13.275,13.275,0,0,0-.909,1.46c-.274.5-.529.992-.806,1.475-.14.241-.281.478-.433.725a2.408,2.408,0,0,0-.331.812,4.438,4.438,0,0,1,.561-.634,6.714,6.714,0,0,0,.584-.642,9.983,9.983,0,0,0,.944-1.45c.275-.5.522-1.006.781-1.5s.532-.98.838-1.475",
    transform: "translate(-3245.202 -1043.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11949",
    "data-name": "Path 11949",
    className: "cls-26",
    d: "M3550.694,1140.334a6.207,6.207,0,0,0,.681-.992c.195-.341.375-.684.544-1.05.083-.181.163-.364.236-.549a3.575,3.575,0,0,0,.16-.6,3.032,3.032,0,0,0-.013-1.224c-.152.383-.284.745-.431,1.095-.081.173-.143.347-.236.516s-.176.347-.258.523a8.56,8.56,0,0,0-.424,1.1,6.239,6.239,0,0,0-.258,1.174",
    transform: "translate(-3204.295 -1025.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11950",
    "data-name": "Path 11950",
    className: "cls-26",
    d: "M3523.142,1091.742a9,9,0,0,0-.78,1.221q-.344.628-.627,1.283c-.191.436-.358.881-.508,1.335a.733.733,0,1,0,.422.188c.229-.42.44-.848.629-1.287s.358-.884.508-1.339a8.863,8.863,0,0,0,.356-1.4",
    transform: "translate(-3177.38 -985.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11951",
    "data-name": "Path 11951",
    className: "cls-26",
    d: "M3479.734,1078.233a15.042,15.042,0,0,0-1.409,2.048,20.333,20.333,0,0,0-1.955,4.564,14.949,14.949,0,0,0-.509,2.434c.334-.762.636-1.524.946-2.282s.62-1.513.945-2.26.651-1.5.983-2.245.677-1.492,1-2.259",
    transform: "translate(-3136.763 -973.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11952",
    "data-name": "Path 11952",
    className: "cls-26",
    d: "M3428.255,1184.641a2.838,2.838,0,0,0-1.451,1.089,11.186,11.186,0,0,0-.933,1.535c-.276.522-.531,1.055-.769,1.6a13.282,13.282,0,0,0-.622,1.674,13.354,13.354,0,0,0,1.031-1.459c.313-.5.61-1.013.884-1.536s.517-1.06.793-1.557a4.363,4.363,0,0,1,1.067-1.343",
    transform: "translate(-3090.394 -1069.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11953",
    "data-name": "Path 11953",
    className: "cls-26",
    d: "M3435.29,1067.491a7.754,7.754,0,0,0-.733,1.118c-.213.385-.408.779-.581,1.181s-.327.813-.461,1.233a.678.678,0,1,0,.423.185,12.846,12.846,0,0,0,.581-1.183,13.163,13.163,0,0,0,.461-1.235,7.591,7.591,0,0,0,.31-1.3",
    transform: "translate(-3098.269 -963.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11954",
    "data-name": "Path 11954",
    className: "cls-26",
    d: "M3379.4,1085.724a11.175,11.175,0,0,0-.974,1.856,15.318,15.318,0,0,0-1.082,4.039,11.112,11.112,0,0,0-.083,2.094c.2-.673.367-1.343.537-2.009s.338-1.329.519-1.989.361-1.321.542-1.984.376-1.324.54-2.007",
    transform: "translate(-3047.769 -979.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11955",
    "data-name": "Path 11955",
    className: "cls-26",
    d: "M3332.282,1154.7a2.22,2.22,0,0,0,.483-1.35,4.758,4.758,0,0,0-.171-1.423,12.028,12.028,0,0,0-.439-1.317.709.709,0,1,0-.444.128c.083.453.2.9.31,1.338a5.726,5.726,0,0,1,.261,2.624",
    transform: "translate(-3006.532 -1037.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11956",
    "data-name": "Path 11956",
    className: "cls-26",
    d: "M3299.783,1178.7a15.748,15.748,0,0,1,.319,2.076c.057.691.089,1.385.114,2.087s.063,1.409.154,2.117a8.353,8.353,0,0,0,.492,2.085c-.025-.716-.031-1.412-.03-2.114s0-1.4-.025-2.114a13,13,0,0,0-.25-2.131,6.1,6.1,0,0,0-.774-2.006",
    transform: "translate(-2977.862 -1063.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11957",
    "data-name": "Path 11957",
    className: "cls-26",
    d: "M3258.114,1215.967a7.749,7.749,0,0,0,.2,2.507c.171.82.4,1.611.533,2.407a16.629,16.629,0,0,1,.255,2.42,24.17,24.17,0,0,1-.063,2.472,8.6,8.6,0,0,0,.525-2.463,10.222,10.222,0,0,0-.135-2.534,18.5,18.5,0,0,0-.67-2.421,17.858,17.858,0,0,1-.645-2.388",
    transform: "translate(-2940.227 -1097.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11958",
    "data-name": "Path 11958",
    className: "cls-26",
    d: "M3271.178,1358.816a6.105,6.105,0,0,0-.423,1.688,10.3,10.3,0,0,0-.047,1.734,14.9,14.9,0,0,0,.2,1.71,4.093,4.093,0,0,0,.532,1.655,10.886,10.886,0,0,1-.071-1.7c-.009-.571-.033-1.137-.065-1.7s-.062-1.122-.084-1.683-.024-1.124-.037-1.707",
    transform: "translate(-2951.608 -1226.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11959",
    "data-name": "Path 11959",
    className: "cls-26",
    d: "M3328.039,1282.53a11.482,11.482,0,0,0-.223,1.987,16.357,16.357,0,0,0,.35,3.97,11.337,11.337,0,0,0,.57,1.917c-.011-.671-.06-1.328-.112-1.984l-.164-1.96-.184-1.958c-.064-.654-.131-1.31-.237-1.973",
    transform: "translate(-3003.151 -1157.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11960",
    "data-name": "Path 11960",
    className: "cls-26",
    d: "M3669.642,1296.863a4.545,4.545,0,0,1-1.4.99,11.277,11.277,0,0,1-1.682.353,16.006,16.006,0,0,1-1.728.2c-.29.012-.58.019-.873.006a1.184,1.184,0,0,1-.814-.216.689.689,0,0,0,.328.335,2.194,2.194,0,0,0,.439.168,5.077,5.077,0,0,0,.908.169,7.14,7.14,0,0,0,1.835-.075c.3-.051.6-.112.892-.188a3.881,3.881,0,0,0,.887-.331,2.3,2.3,0,0,0,.731-.623,4.317,4.317,0,0,0,.473-.786",
    transform: "translate(-3305.779 -1170.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11961",
    "data-name": "Path 11961",
    className: "cls-26",
    d: "M3784.5,1223.53a7.813,7.813,0,0,0-1.79.2,5.018,5.018,0,0,0-1.7.717,3.427,3.427,0,0,0-1.231,1.423,3.081,3.081,0,0,0-.2,1.815,5.108,5.108,0,0,1,.614-1.6,4.007,4.007,0,0,1,1.155-1.149,7.6,7.6,0,0,1,1.5-.767c.537-.213,1.1-.395,1.653-.635",
    transform: "translate(-3410.8 -1104.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11962",
    "data-name": "Path 11962",
    className: "cls-26",
    d: "M3816.941,1274.2a4.969,4.969,0,0,0-1.219.327,7.256,7.256,0,0,0-2.129,1.3,4.918,4.918,0,0,0-.846.937,10.635,10.635,0,0,0,1.114-.56c.355-.2.706-.4,1.05-.615s.685-.429,1.025-.655a10.857,10.857,0,0,0,1.006-.735",
    transform: "translate(-3440.781 -1149.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11963",
    "data-name": "Path 11963",
    className: "cls-26",
    d: "M3848.852,1305.971c-.486.047-.95.121-1.412.191l-1.378.2-1.38.184c-.464.059-.93.115-1.411.2a5.354,5.354,0,0,0,1.426.259,7.4,7.4,0,0,0,2.854-.4,5.415,5.415,0,0,0,1.3-.638",
    transform: "translate(-3468.328 -1178.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11964",
    "data-name": "Path 11964",
    className: "cls-26",
    d: "M3861.049,1358.067a7.534,7.534,0,0,1-2.744,1.316c-.489.131-.99.237-1.5.337s-1.032.195-1.551.349a7.946,7.946,0,0,0,1.6.11,6.817,6.817,0,0,0,1.606-.224,4.934,4.934,0,0,0,1.5-.682,3.223,3.223,0,0,0,1.092-1.206",
    transform: "translate(-3479.142 -1225.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11965",
    "data-name": "Path 11965",
    className: "cls-26",
    d: "M3839.333,1452.517a13.706,13.706,0,0,1-1.122.843,9.088,9.088,0,0,1-2.448,1.128,13.864,13.864,0,0,1-1.37.307,3.435,3.435,0,0,0,1.455.147,4.482,4.482,0,0,0,2.652-1.224,3.46,3.46,0,0,0,.833-1.2",
    transform: "translate(-3460.316 -1310.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11966",
    "data-name": "Path 11966",
    className: "cls-26",
    d: "M3755.358,1499.926l-2.013.153c-.665.042-1.326.081-1.988.091s-1.324.011-1.99,0l-2.018-.061a8.886,8.886,0,0,0,1.977.521,11.707,11.707,0,0,0,4.081-.093,8.932,8.932,0,0,0,1.952-.61",
    transform: "translate(-3381.764 -1353.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11967",
    "data-name": "Path 11967",
    className: "cls-26",
    d: "M3694.348,1486.045a9.545,9.545,0,0,0-1.182.567l-1.114.6c-.369.193-.755.382-1.134.609a3.384,3.384,0,0,0-1.016.865c.416-.169.811-.3,1.215-.447a8.942,8.942,0,0,0,1.21-.5,6.574,6.574,0,0,0,2.021-1.694",
    transform: "translate(-3329.922 -1341.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11968",
    "data-name": "Path 11968",
    className: "cls-26",
    d: "M3646.01,1548.211c-.316.253-.59.524-.863.784s-.546.508-.826.739a7.614,7.614,0,0,1-.885.63,7.2,7.2,0,0,1-1.021.5,2.227,2.227,0,0,0,1.209-.078,3.3,3.3,0,0,0,1.073-.595,4.049,4.049,0,0,0,.8-.9,3.883,3.883,0,0,0,.51-1.079",
    transform: "translate(-3287.067 -1397.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11969",
    "data-name": "Path 11969",
    className: "cls-26",
    d: "M3612.523,1327.426a.356.356,0,0,0-.279.011.9.9,0,0,0-.237.167c-.137.136-.239.277-.361.418s-.213.3-.32.446-.19.313-.283.472a9.343,9.343,0,0,0-.806,2.037,13.411,13.411,0,0,0-.382,2.14,14.605,14.605,0,0,0-.061,2.163c.209-.7.362-1.4.518-2.09s.308-1.383.5-2.06a17.508,17.508,0,0,1,.651-1.994c.135-.323.273-.645.432-.961.081-.155.16-.322.243-.469s.2-.291.39-.282",
    transform: "translate(-3257.614 -1197.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11970",
    "data-name": "Path 11970",
    className: "cls-26",
    d: "M3627.442,1353.476a7.171,7.171,0,0,0-1.527,2.538,19.7,19.7,0,0,0-.778,2.855c-.195.959-.377,1.91-.616,2.842a12.368,12.368,0,0,1-1.021,2.712,7.519,7.519,0,0,0,1.463-2.575,21.667,21.667,0,0,0,.754-2.858c.195-.957.383-1.905.637-2.833a11.3,11.3,0,0,1,1.089-2.681",
    transform: "translate(-3269.997 -1221.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11971",
    "data-name": "Path 11971",
    className: "cls-26",
    d: "M3543.1,1429.344a13.366,13.366,0,0,1-.9,2.122,11.536,11.536,0,0,1-2.882,3.458,13.309,13.309,0,0,1-1.923,1.275,6.346,6.346,0,0,0,2.192-.9,7.807,7.807,0,0,0,3.029-3.638,6.362,6.362,0,0,0,.488-2.318",
    transform: "translate(-3192.292 -1289.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11972",
    "data-name": "Path 11972",
    className: "cls-26",
    d: "M3516.187,1596.224a14.86,14.86,0,0,0-3.594,1.237c-1.147.547-2.255,1.131-3.358,1.776a15.015,15.015,0,0,0-1.582,1.1,8.816,8.816,0,0,0-1.364,1.378,15.041,15.041,0,0,0-1.881,3.313,29.671,29.671,0,0,1,2.234-3.015,12.3,12.3,0,0,1,2.9-2.267c.53-.326,1.078-.629,1.626-.941l1.637-.932a28.489,28.489,0,0,1,3.383-1.647",
    transform: "translate(-3162.524 -1440.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11973",
    "data-name": "Path 11973",
    className: "cls-26",
    d: "M3459.941,1695.629a5.81,5.81,0,0,1-.681.609,3.98,3.98,0,0,1-.716.429,4.149,4.149,0,0,1-.8.265,2.05,2.05,0,0,0-.892.394c.333.007.617.057.941.069a2.119,2.119,0,0,0,1.8-.832,1.656,1.656,0,0,0,.35-.934",
    transform: "translate(-3119.607 -1530.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11974",
    "data-name": "Path 11974",
    className: "cls-26",
    d: "M3430.457,1512.834a7.25,7.25,0,0,1-.759.323c-.244.088-.487.161-.735.229l-.769.2a4.319,4.319,0,0,0-.807.3,2.8,2.8,0,0,0,.86.165,2.876,2.876,0,0,0,.872-.1,2.31,2.31,0,0,0,.809-.4,1.487,1.487,0,0,0,.529-.727",
    transform: "translate(-3093.017 -1365.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11975",
    "data-name": "Path 11975",
    className: "cls-26",
    d: "M3291.24,1467.712a10.447,10.447,0,0,1-2.1-2.005,7.263,7.263,0,0,0-1.113-1.031,3.887,3.887,0,0,1-1.137-.908,1.293,1.293,0,0,0,.317.712c.167.2.354.378.518.547.334.343.642.715.978,1.08a7.046,7.046,0,0,0,1.119,1.028,2.917,2.917,0,0,0,1.42.578",
    transform: "translate(-2966.225 -1320.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11976",
    "data-name": "Path 11976",
    className: "cls-26",
    d: "M3290.708,1321.128a19.827,19.827,0,0,0-.235,3.008,25.892,25.892,0,0,0,.159,3.017,25.512,25.512,0,0,0,.516,2.977,7.29,7.29,0,0,0,.461,1.461,2.207,2.207,0,0,0,1.029,1.118,2.389,2.389,0,0,1-.758-1.223,9.647,9.647,0,0,1-.278-1.443c-.141-.985-.275-1.969-.382-2.956s-.2-1.975-.286-2.967Z",
    transform: "translate(-2969.459 -1192.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11977",
    "data-name": "Path 11977",
    className: "cls-26",
    d: "M3747.914,1180.89a3.4,3.4,0,0,0-1.2.224,10.2,10.2,0,0,0-1.107.5,5.818,5.818,0,0,1-2.123.758l.307.221a3.972,3.972,0,0,1-.08-1.156,9.96,9.96,0,0,0-.01-1.276,6.055,6.055,0,0,0-.251-1.263,5.306,5.306,0,0,0-.523-1.16,10.4,10.4,0,0,1,.233,1.224,8.378,8.378,0,0,1,.072,1.218c-.006.4-.045.8-.087,1.226a4.214,4.214,0,0,0,.074,1.334l.063.242.246-.021a3.672,3.672,0,0,0,1.239-.343,8.6,8.6,0,0,0,1.065-.609,8.143,8.143,0,0,1,2.081-1.115",
    transform: "translate(-3377.775 -1062.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11978",
    "data-name": "Path 11978",
    className: "cls-26",
    d: "M3435.4,1454.381a.83.83,0,0,0-.752.375,3.948,3.948,0,0,1-.494.593,6.361,6.361,0,0,1-1.292.819c-.47.244-.927.535-1.379.8a2.2,2.2,0,0,1-.682.272,1.006,1.006,0,0,1-.732-.13.957.957,0,0,0,.737.421,2,2,0,0,0,.867-.141,13.969,13.969,0,0,0,1.482-.7,4.19,4.19,0,0,0,1.341-1.025c.414-.479.349-1.095.906-1.278",
    transform: "translate(-3095.44 -1312.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11979",
    "data-name": "Path 11979",
    className: "cls-26",
    d: "M3436.676,1657.574a5.79,5.79,0,0,1-1.124,1.313,4.748,4.748,0,0,1-1.428.836c-.523.2-1.093.346-1.659.533a13.571,13.571,0,0,0-1.667.652,13.542,13.542,0,0,0,1.778-.2,9.477,9.477,0,0,0,1.759-.429,3.826,3.826,0,0,0,1.542-1.062,3.312,3.312,0,0,0,.8-1.64",
    transform: "translate(-3096.096 -1495.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11980",
    "data-name": "Path 11980",
    className: "cls-26",
    d: "M3435.406,1549.463a3.284,3.284,0,0,0,.47-1.135,4.431,4.431,0,0,0,.1-1.231,4.38,4.38,0,0,0-.248-1.209,3.26,3.26,0,0,0-.608-1.069l.159,1.178c.048.382.082.759.106,1.137s.037.756.037,1.142Z",
    transform: "translate(-3099.992 -1394.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11981",
    "data-name": "Path 11981",
    className: "cls-26",
    d: "M3662.5,1778.4a6.719,6.719,0,0,1-2.026,2.221,8.191,8.191,0,0,1-2.7,1.225,11.749,11.749,0,0,1-2.982.33,28.954,28.954,0,0,1-3.062-.228,12,12,0,0,0,3.039.689,9.414,9.414,0,0,0,3.15-.219,7.2,7.2,0,0,0,2.834-1.433,5.272,5.272,0,0,0,1.745-2.586",
    transform: "translate(-3295.479 -1604.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11982",
    "data-name": "Path 11982",
    className: "cls-26",
    d: "M3694.182,1747.292a7.375,7.375,0,0,1-1.173,1.607,5.984,5.984,0,0,1-3.361,1.755,7.407,7.407,0,0,1-1.989.044,4.2,4.2,0,0,0,2.034.416,4.77,4.77,0,0,0,3.667-1.916,4.2,4.2,0,0,0,.822-1.906",
    transform: "translate(-3327.897 -1576.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11983",
    "data-name": "Path 11983",
    className: "cls-26",
    d: "M3659.666,1710.725a4.334,4.334,0,0,0-1.5-.153,6.787,6.787,0,0,0-1.485.257,8.749,8.749,0,0,0-1.4.535,7.872,7.872,0,0,0-1.287.76,11.662,11.662,0,0,0,1.449-.327l1.4-.4c.461-.131.921-.26,1.388-.371s.939-.2,1.435-.3",
    transform: "translate(-3297.522 -1543.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11984",
    "data-name": "Path 11984",
    className: "cls-26",
    d: "M3584.091,1688.6a3.121,3.121,0,0,0-2.1-.34,4.769,4.769,0,0,0-2,.862,8.133,8.133,0,0,0-1.536,1.492,3.557,3.557,0,0,0-.56.939,1.5,1.5,0,0,0-.038,1.074,1.678,1.678,0,0,1,.3-.946,4.437,4.437,0,0,1,.643-.758,14.3,14.3,0,0,1,1.538-1.32,5.779,5.779,0,0,1,1.755-.893,4.228,4.228,0,0,1,2-.109",
    transform: "translate(-3228.73 -1523.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11985",
    "data-name": "Path 11985",
    className: "cls-26",
    d: "M3575.6,1685.661a1.562,1.562,0,0,0-.734.331,2.148,2.148,0,0,0-.789,1.371,1.554,1.554,0,0,0,.086.8c.141-.239.246-.455.359-.663s.219-.406.332-.6.229-.392.354-.592.255-.4.392-.644",
    transform: "translate(-3225.378 -1521.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11986",
    "data-name": "Path 11986",
    className: "cls-26",
    d: "M3585.276,1736.029a1.593,1.593,0,0,0-1.07.206,8.6,8.6,0,0,0-.868.563c-.274.194-.543.394-.811.6a7.936,7.936,0,0,0-.786.692,3.623,3.623,0,0,0,1.024-.292,5.136,5.136,0,0,0,.916-.521,8.025,8.025,0,0,0,.788-.663,3.447,3.447,0,0,1,.807-.589",
    transform: "translate(-3232.313 -1566.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11987",
    "data-name": "Path 11987",
    className: "cls-26",
    d: "M3523.132,1743.242a8.535,8.535,0,0,0-1.309.543c-.42.21-.832.439-1.23.688a5.183,5.183,0,0,0-1.108.923,2.123,2.123,0,0,0-.589,1.328,3.625,3.625,0,0,1,.909-.994c.349-.272.728-.512,1.117-.763s.774-.508,1.145-.789a8.755,8.755,0,0,0,1.066-.934",
    transform: "translate(-3175.599 -1573.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11988",
    "data-name": "Path 11988",
    className: "cls-26",
    d: "M3478.768,1748.464a7.579,7.579,0,0,0-1.313,1.071,10.326,10.326,0,0,0-1.964,2.745,5.009,5.009,0,0,0-.327.8,1.5,1.5,0,0,0-.021.868,3.466,3.466,0,0,1,.746-1.43l.952-1.344.962-1.337c.325-.446.654-.892.964-1.37",
    transform: "translate(-3136.065 -1577.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11989",
    "data-name": "Path 11989",
    className: "cls-26",
    d: "M3598.048,1853.34a2.2,2.2,0,0,1-.258.567,1.62,1.62,0,0,1-.331.377,1.644,1.644,0,0,1-.434.251,2.231,2.231,0,0,1-.606.145.866.866,0,0,0,.668.317,1.124,1.124,0,0,0,1.142-.94.868.868,0,0,0-.182-.716",
    transform: "translate(-3245.56 -1672.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11990",
    "data-name": "Path 11990",
    className: "cls-26",
    d: "M3590.685,1950.708a2.278,2.278,0,0,0-.583-1.518,3.118,3.118,0,0,0-1.42-.886,5.876,5.876,0,0,0-1.6-.243c-.528-.018-1.042,0-1.578.016a6.827,6.827,0,0,0,1.524.444,14.152,14.152,0,0,1,1.473.347,3.849,3.849,0,0,1,1.278.65,3.446,3.446,0,0,1,.906,1.189",
    transform: "translate(-3235.709 -1758.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11991",
    "data-name": "Path 11991",
    className: "cls-26",
    d: "M3476.285,1958.132a6.075,6.075,0,0,0-1.556.88,4.138,4.138,0,0,0-1.251,1.365,2,2,0,0,0-.212.986,1.532,1.532,0,0,0,.394.945,2.447,2.447,0,0,0,.769.547c.273.128.544.234.825.341a9.964,9.964,0,0,1-1.229-1.173,1.355,1.355,0,0,1-.014-1.384,5.628,5.628,0,0,1,1.024-1.282c.4-.412.823-.808,1.252-1.225",
    transform: "translate(-3134.417 -1767.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11992",
    "data-name": "Path 11992",
    className: "cls-26",
    d: "M3520.752,1944.879a1.457,1.457,0,0,0-.737.581,1.838,1.838,0,0,0-.11,1.873,1.452,1.452,0,0,0,.666.662,5.062,5.062,0,0,1-.227-.82,3.219,3.219,0,0,1-.049-.76,3.253,3.253,0,0,1,.136-.75,4.854,4.854,0,0,1,.321-.787",
    transform: "translate(-3176.325 -1755.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11993",
    "data-name": "Path 11993",
    className: "cls-26",
    d: "M3552.383,1941.549a2.583,2.583,0,0,0-.425,1,3.476,3.476,0,0,0-.049,1.088,3.438,3.438,0,0,0,.289,1.05,2.589,2.589,0,0,0,.636.877l-.192-1.02c-.059-.327-.106-.65-.143-.974s-.062-.649-.077-.982Z",
    transform: "translate(-3205.372 -1752.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11994",
    "data-name": "Path 11994",
    className: "cls-26",
    d: "M3597.336,1962.737a4.008,4.008,0,0,0,.022.631c.021.194.048.38.082.564s.071.368.12.557a4.025,4.025,0,0,0,.2.6,1.344,1.344,0,0,0,.265-.611,1.878,1.878,0,0,0-.229-1.26,1.356,1.356,0,0,0-.461-.48",
    transform: "translate(-3246.382 -1771.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11995",
    "data-name": "Path 11995",
    className: "cls-26",
    d: "M3260.828,1727.006a2.107,2.107,0,0,0,.537-.769,1.433,1.433,0,0,0,.036-1.029,1.249,1.249,0,0,0-.758-.729,1.915,1.915,0,0,0-.942-.083c.255.192.516.331.724.494a1.18,1.18,0,0,1,.422.526,1.631,1.631,0,0,1,.066.709c-.019.272-.073.561-.086.879",
    transform: "translate(-2941.69 -1556.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11996",
    "data-name": "Path 11996",
    className: "cls-26",
    d: "M3176.063,1766.891c-.291.64-.607,1.243-.907,1.872a8.967,8.967,0,0,0-.73,2,5,5,0,0,0-.1,1.093,4.283,4.283,0,0,0,.181,1.082,3.759,3.759,0,0,0,1.15,1.787,5.846,5.846,0,0,1-.7-1.9,4.967,4.967,0,0,1,.052-1.947,17.3,17.3,0,0,1,.577-1.945,8.643,8.643,0,0,0,.48-2.044",
    transform: "translate(-2864.641 -1594.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11997",
    "data-name": "Path 11997",
    className: "cls-26",
    d: "M3200.091,1861.321c.259.135.479.253.7.379s.445.247.685.358a3.473,3.473,0,0,0,.774.266,1.6,1.6,0,0,0,.853-.033l-.691-.4c-.221-.128-.444-.255-.687-.367a3.278,3.278,0,0,0-.782-.259,1.546,1.546,0,0,0-.854.059",
    transform: "translate(-2887.896 -1679.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11998",
    "data-name": "Path 11998",
    className: "cls-26",
    d: "M3207.46,1738.815a6.965,6.965,0,0,0-.994,1.38,9.372,9.372,0,0,0-.7,1.554,5.958,5.958,0,0,0-.358,1.691,2.866,2.866,0,0,0,.094.882,1.812,1.812,0,0,0,.425.76,3,3,0,0,1-.059-1.592,12.225,12.225,0,0,1,.458-1.55c.178-.518.362-1.033.554-1.551s.4-1.032.578-1.574",
    transform: "translate(-2892.694 -1569.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11999",
    "data-name": "Path 11999",
    className: "cls-26",
    d: "M3208.074,1821.11a.5.5,0,0,0,.111.425,1.158,1.158,0,0,0,.344.281,2.965,2.965,0,0,0,.742.257,4.5,4.5,0,0,0,.762.111,2.752,2.752,0,0,0,.789-.057,2.942,2.942,0,0,0-.689-.4,4.289,4.289,0,0,0-.717-.23c-.237-.06-.508-.082-.726-.118a1.754,1.754,0,0,1-.324-.073.571.571,0,0,1-.291-.2",
    transform: "translate(-2895.088 -1643.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12000",
    "data-name": "Path 12000",
    className: "cls-27",
    d: "M3681.6,1743.167a.946.946,0,0,0-.468-.287,2.042,2.042,0,0,0-.548-.068c-.362.007-.674.051-1,.072l-.974.066c-.329.024-.662.037-1.019.085a2.882,2.882,0,0,0,.985.379,3.838,3.838,0,0,0,1.053.059,5.086,5.086,0,0,0,1.01-.2,2.162,2.162,0,0,1,.958-.105",
    transform: "translate(-3318.815 -1572.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12001",
    "data-name": "Path 12001",
    className: "cls-27",
    d: "M3634.42,1788.986a4.635,4.635,0,0,0-.948-.361,7.555,7.555,0,0,0-.97-.194,9.381,9.381,0,0,0-.974-.074,3.966,3.966,0,0,1-.954-.124,1.581,1.581,0,0,0,.87.582,6.2,6.2,0,0,0,.98.2,7.58,7.58,0,0,0,.986.067,4.624,4.624,0,0,0,1.009-.1",
    transform: "translate(-3276.382 -1613.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12002",
    "data-name": "Path 12002",
    className: "cls-27",
    d: "M3580.368,1841.522a.872.872,0,0,1-.4.168,2.24,2.24,0,0,1-.322.038l-.378.011a1.959,1.959,0,0,0-.5.069,1,1,0,0,0,.371.379.965.965,0,0,0,.533.132.826.826,0,0,0,.548-.242.515.515,0,0,0,.141-.556",
    transform: "translate(-3229.636 -1661.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12003",
    "data-name": "Path 12003",
    className: "cls-27",
    d: "M3503.612,1799.91a.308.308,0,0,0-.262-.148.585.585,0,0,0-.309.082.817.817,0,0,0-.362.467,1.412,1.412,0,0,0-.052.456,2.33,2.33,0,0,1,0,.454.594.594,0,0,0,.445-.32,1.772,1.772,0,0,0,.173-.421,2.719,2.719,0,0,1,.108-.294c.049-.094.069-.209.258-.276",
    transform: "translate(-3160.917 -1624.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12004",
    "data-name": "Path 12004",
    className: "cls-27",
    d: "M3544.24,1763.875a.792.792,0,0,0-.407.1.889.889,0,0,0-.43.57.785.785,0,0,0,.015.419,1.068,1.068,0,0,0,.374-.164.988.988,0,0,0,.239-.23,1.021,1.021,0,0,0,.155-.293,1.088,1.088,0,0,0,.055-.4",
    transform: "translate(-3197.696 -1591.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12005",
    "data-name": "Path 12005",
    className: "cls-27",
    d: "M3456.328,1650.514a2.9,2.9,0,0,0-.741.279,4.512,4.512,0,0,0-.636.41c-.2.149-.377.3-.561.453s-.367.295-.6.453a1.294,1.294,0,0,0,.822-.044,2.6,2.6,0,0,0,.694-.39,4.361,4.361,0,0,0,.563-.513,2.889,2.889,0,0,0,.457-.646",
    transform: "translate(-3116.847 -1489.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12006",
    "data-name": "Path 12006",
    className: "cls-27",
    d: "M3509.861,1547.653a14,14,0,0,0-1.316.534c-.425.193-.845.389-1.261.594s-.829.416-1.241.635a13.484,13.484,0,0,0-1.226.717,6.332,6.332,0,0,0,1.4-.291,9.35,9.35,0,0,0,2.551-1.255,6.324,6.324,0,0,0,1.088-.933",
    transform: "translate(-3162.893 -1396.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12007",
    "data-name": "Path 12007",
    className: "cls-27",
    d: "M3479.547,1543.392a1.318,1.318,0,0,0-.887-.171c-.293.029-.544.07-.811.1l-.795.107c-.271.041-.545.076-.843.148a2.156,2.156,0,0,0,.832.318,2.915,2.915,0,0,0,.886.014,3.194,3.194,0,0,0,.839-.24,3.918,3.918,0,0,1,.779-.28",
    transform: "translate(-3137.078 -1392.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12008",
    "data-name": "Path 12008",
    className: "cls-27",
    d: "M3587.954,1492.272a.211.211,0,0,0-.15-.115.441.441,0,0,0-.2.014.991.991,0,0,0-.338.188c-.18.144-.36.289-.53.444q-.518.458-.987.959c-.317.332-.6.694-.894,1.019a3.53,3.53,0,0,1-1.025.839,2.072,2.072,0,0,0,1.337-.5,8.535,8.535,0,0,0,1.016-.957q.469-.5.89-1.05c.142-.18.275-.37.406-.561a.911.911,0,0,1,.2-.238.223.223,0,0,1,.279-.047",
    transform: "translate(-3234.197 -1346.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12009",
    "data-name": "Path 12009",
    className: "cls-27",
    d: "M3608,1419.228a8.121,8.121,0,0,0-.625,1.062c-.183.361-.353.725-.508,1.1s-.3.746-.426,1.13a8.064,8.064,0,0,0-.318,1.191,5.475,5.475,0,0,0,.738-1,8.653,8.653,0,0,0,.945-2.255,5.577,5.577,0,0,0,.194-1.225",
    transform: "translate(-3254.32 -1280.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12010",
    "data-name": "Path 12010",
    className: "cls-27",
    d: "M3730.542,1403.676a8.935,8.935,0,0,0-1.277.25c-.415.107-.823.226-1.225.36s-.8.282-1.2.444a8.764,8.764,0,0,0-1.172.564,6.087,6.087,0,0,0,1.3-.121,9.557,9.557,0,0,0,1.254-.325,9.727,9.727,0,0,0,1.2-.491,6.237,6.237,0,0,0,1.118-.682",
    transform: "translate(-3362.198 -1266.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12011",
    "data-name": "Path 12011",
    className: "cls-27",
    d: "M3760.025,1471.871a4.346,4.346,0,0,0-1.057-.4,6.4,6.4,0,0,0-2.221-.139,4.3,4.3,0,0,0-1.1.266,8.009,8.009,0,0,0,1.1.2c.362.044.721.075,1.08.1s.72.035,1.084.037a8.152,8.152,0,0,0,1.114-.062",
    transform: "translate(-3389.254 -1327.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12012",
    "data-name": "Path 12012",
    className: "cls-27",
    d: "M3665.075,1495.337a4.482,4.482,0,0,0-.928.657,6.64,6.64,0,0,0-1.381,1.761,4.416,4.416,0,0,0-.416,1.059,7.832,7.832,0,0,0,.8-.792q.366-.411.7-.84c.224-.286.44-.578.648-.881a8.009,8.009,0,0,0,.579-.963",
    transform: "translate(-3305.058 -1349.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12013",
    "data-name": "Path 12013",
    className: "cls-27",
    d: "M3523.768,1377.252a8.825,8.825,0,0,0-.518.859c-.155.285-.3.57-.441.856s-.282.573-.417.868a2.863,2.863,0,0,1-.2.408.6.6,0,0,1-.344.287.575.575,0,0,0,.543-.074,1.748,1.748,0,0,0,.4-.372,4.327,4.327,0,0,0,.553-.854,4.457,4.457,0,0,0,.347-.956,3.211,3.211,0,0,0,.083-1.023",
    transform: "translate(-3178.259 -1242.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12014",
    "data-name": "Path 12014",
    className: "cls-27",
    d: "M3568.016,1316.549a3.344,3.344,0,0,0-.591.625,5.379,5.379,0,0,0-.442.7,5.281,5.281,0,0,0-.329.762,3.3,3.3,0,0,0-.179.84,3.336,3.336,0,0,0,.591-.624,5.143,5.143,0,0,0,.441-.7,5.31,5.31,0,0,0,.329-.762,3.416,3.416,0,0,0,.18-.84",
    transform: "translate(-3218.537 -1188.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12015",
    "data-name": "Path 12015",
    className: "cls-27",
    d: "M3662.731,1291.44a3.071,3.071,0,0,0-1.269.039,2.03,2.03,0,0,0-1.121.75,2.818,2.818,0,0,0-.507,1.208,3.934,3.934,0,0,0-.031,1.257c.187-.381.323-.765.474-1.126a4.553,4.553,0,0,1,.536-.98,2.256,2.256,0,0,1,.812-.677c.333-.171.721-.294,1.107-.47",
    transform: "translate(-3302.726 -1165.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12016",
    "data-name": "Path 12016",
    className: "cls-27",
    d: "M3733.933,1313.557a5.05,5.05,0,0,1-1.017.3,9.97,9.97,0,0,0-1.037.276,8.828,8.828,0,0,0-1,.393,5.475,5.475,0,0,0-.954.558,5.285,5.285,0,0,0,1.094-.114,8.823,8.823,0,0,0,1.049-.278,8.152,8.152,0,0,0,1.008-.4,1.9,1.9,0,0,0,.854-.736",
    transform: "translate(-3366.042 -1185.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12017",
    "data-name": "Path 12017",
    className: "cls-27",
    d: "M3799.95,1260.306a.661.661,0,0,0-.515-.253,1.212,1.212,0,0,0-.588.139,5.64,5.64,0,0,0-.877.616,8.424,8.424,0,0,0-.764.712.547.547,0,1,0,.3.359,8.323,8.323,0,0,0,.845-.614c.267-.214.526-.479.752-.683a1.216,1.216,0,0,1,.373-.242.735.735,0,0,1,.479-.035",
    transform: "translate(-3426.166 -1137.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12018",
    "data-name": "Path 12018",
    className: "cls-27",
    d: "M3816.264,1331.845a1.329,1.329,0,0,0-.9-.485,2.735,2.735,0,0,0-1.015.064,9.335,9.335,0,0,0-.9.282,7.565,7.565,0,0,1-.9.271,1.78,1.78,0,0,0,.991.187,5.51,5.51,0,0,0,.949-.164,8.687,8.687,0,0,1,.869-.176,2.57,2.57,0,0,1,.909.021",
    transform: "translate(-3440.602 -1201.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12019",
    "data-name": "Path 12019",
    className: "cls-27",
    d: "M3827.544,1414.9l-.838,1.062c-.277.342-.565.669-.86.988s-.6.627-.924.929l-1,.913a4.06,4.06,0,0,0,1.279-.547,5.422,5.422,0,0,0,1.887-2.03,4.07,4.07,0,0,0,.453-1.315",
    transform: "translate(-3450.869 -1276.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12020",
    "data-name": "Path 12020",
    className: "cls-27",
    d: "M3509.244,1272.893a12.145,12.145,0,0,0-1.01,1.355c-.309.466-.6.95-.87,1.426s-.549.944-.86,1.385a6.742,6.742,0,0,1-1.1,1.219,3.343,3.343,0,0,0,1.452-.922,6.959,6.959,0,0,0,1.018-1.384c.284-.491.526-.991.76-1.5a12.227,12.227,0,0,0,.608-1.578",
    transform: "translate(-3163.425 -1148.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12021",
    "data-name": "Path 12021",
    className: "cls-27",
    d: "M3535.032,1192.248a.508.508,0,0,0-.607.072,1.308,1.308,0,0,0-.341.54c-.134.344-.271.665-.416.991s-.3.644-.466.964-.343.64-.513.994a3.041,3.041,0,0,0,.9-.734,4.06,4.06,0,0,0,.623-.981,4.107,4.107,0,0,0,.32-1.113,1.568,1.568,0,0,1,.114-.468.449.449,0,0,1,.391-.264",
    transform: "translate(-3188.047 -1075.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12022",
    "data-name": "Path 12022",
    className: "cls-27",
    d: "M3612.232,1228.14a.63.63,0,0,0-.493.085,1.5,1.5,0,0,0-.375.337,5.47,5.47,0,0,0-.488.767,6.2,6.2,0,0,0-.365.818,3.787,3.787,0,0,0-.215.9,3.858,3.858,0,0,0,.626-.679,6.048,6.048,0,0,0,.476-.758,7.033,7.033,0,0,0,.363-.8,1.2,1.2,0,0,1,.47-.663",
    transform: "translate(-3258.083 -1108.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12023",
    "data-name": "Path 12023",
    className: "cls-27",
    d: "M3431.522,1218.572a4.012,4.012,0,0,0-.953,1.043c-.261.393-.506.784-.748,1.183-.487.793-.944,1.6-1.4,2.415s-.876,1.639-1.281,2.477a9.784,9.784,0,0,0-.558,1.3,2.7,2.7,0,0,0-.1,1.414,5.465,5.465,0,0,1,1.066-2.494c.488-.793.945-1.6,1.394-2.415s.876-1.64,1.28-2.478c.206-.416.4-.844.594-1.26a5.562,5.562,0,0,1,.7-1.187",
    transform: "translate(-3092.154 -1099.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12024",
    "data-name": "Path 12024",
    className: "cls-27",
    d: "M3428.691,1305.423a2.311,2.311,0,0,0-1.13.678,12.62,12.62,0,0,0-.891.917,12.221,12.221,0,0,0-.791,1,4.32,4.32,0,0,1-.365.482.716.716,0,0,1-.511.27.7.7,0,0,0,.682-.035,2.486,2.486,0,0,0,.542-.413,12.491,12.491,0,0,0,1.681-1.921,5.536,5.536,0,0,1,.784-.981",
    transform: "translate(-3090.865 -1178.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12025",
    "data-name": "Path 12025",
    className: "cls-27",
    d: "M3376.678,1196.075a3.205,3.205,0,0,0-.392.829,3.71,3.71,0,0,0-.17.895,2.971,2.971,0,0,0,.083.925,1.881,1.881,0,0,0,.436.828c.012-.318.012-.6.027-.882l.046-.835c.017-.279.032-.564.037-.855a4.563,4.563,0,0,0-.066-.9",
    transform: "translate(-3046.743 -1079.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12026",
    "data-name": "Path 12026",
    className: "cls-27",
    d: "M3324.924,1246.569a6.506,6.506,0,0,0-.33,1.126c-.08.377-.145.754-.188,1.133s-.072.762-.082,1.146a6.613,6.613,0,0,0,.058,1.172,5.354,5.354,0,0,0,.4-1.108,8.527,8.527,0,0,0,.213-1.14,8.822,8.822,0,0,0,.059-1.159,5.488,5.488,0,0,0-.129-1.17",
    transform: "translate(-3000.006 -1124.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12027",
    "data-name": "Path 12027",
    className: "cls-27",
    d: "M3317.17,1387.183a9.445,9.445,0,0,0-.21,1.474c-.037.491-.053.982-.046,1.473,0,.246.01.488.026.737a2.852,2.852,0,0,0,.141.784,1.473,1.473,0,0,0,.2.378,1.189,1.189,0,0,0,.318.287.761.761,0,0,0,.778.045.748.748,0,0,1-.6-.273,1.057,1.057,0,0,1-.251-.559,3.667,3.667,0,0,1-.026-.673c.007-.241.008-.49.005-.733-.006-.491-.037-.981-.087-1.47a9.542,9.542,0,0,0-.25-1.468",
    transform: "translate(-2993.321 -1251.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12028",
    "data-name": "Path 12028",
    className: "cls-27",
    d: "M3287.842,1444.521a3.07,3.07,0,0,0,.569.948,4.158,4.158,0,0,0,.827.733,4.1,4.1,0,0,0,.99.49,3.04,3.04,0,0,0,1.093.169c-.3-.219-.6-.4-.894-.589s-.576-.371-.859-.561-.561-.383-.843-.583-.565-.407-.883-.606",
    transform: "translate(-2967.086 -1303.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12029",
    "data-name": "Path 12029",
    className: "cls-27",
    d: "M3417.489,1493.9a6.75,6.75,0,0,0-1.033.321l-.961.384c-.316.126-.629.247-.951.354s-.651.2-1.013.3a2.329,2.329,0,0,0,1.1.162,3.651,3.651,0,0,0,1.082-.262,4.8,4.8,0,0,0,.959-.525,4.387,4.387,0,0,0,.815-.73",
    transform: "translate(-3080.513 -1348.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12030",
    "data-name": "Path 12030",
    className: "cls-27",
    d: "M3440.977,1455.271a4.107,4.107,0,0,0-.843.222,7.2,7.2,0,0,0-1.489.765,4.031,4.031,0,0,0-.671.558,3.038,3.038,0,0,0,.87-.137,4.558,4.558,0,0,0,.794-.321,4.705,4.705,0,0,0,.723-.46,3.082,3.082,0,0,0,.616-.628",
    transform: "translate(-3102.572 -1313.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12031",
    "data-name": "Path 12031",
    className: "cls-27",
    d: "M3483.311,1489.539a13.111,13.111,0,0,0-1.132.926c-.358.316-.714.625-1.077.915a10.214,10.214,0,0,1-1.139.8,8.414,8.414,0,0,1-1.287.615,3.082,3.082,0,0,0,1.484-.2,4.745,4.745,0,0,0,1.311-.75,6.484,6.484,0,0,0,1.042-1.062,7.194,7.194,0,0,0,.8-1.242",
    transform: "translate(-3139.303 -1344.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12032",
    "data-name": "Path 12032",
    className: "cls-27",
    d: "M3248.837,1761.429a.212.212,0,0,1-.091.268.354.354,0,0,1-.223.028l-.327-.044-.355-.038a3.35,3.35,0,0,1-.634-.108,1.406,1.406,0,0,1-.6-.342.856.856,0,0,0,.375.749,1.572,1.572,0,0,0,.8.29,2.885,2.885,0,0,0,.393.009,1.8,1.8,0,0,0,.42-.058.71.71,0,0,0,.233-.115.492.492,0,0,0,.167-.225.419.419,0,0,0,0-.255.225.225,0,0,0-.162-.159",
    transform: "translate(-2929.869 -1589.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12033",
    "data-name": "Path 12033",
    className: "cls-27",
    d: "M3224.384,1800.263a7.721,7.721,0,0,0-1.31-.257,12.983,12.983,0,0,0-1.307-.092,4.837,4.837,0,0,1-1.21-.1,1.108,1.108,0,0,1-.473-.288,6.283,6.283,0,0,1-.424-.5,2.139,2.139,0,0,0,.187.664,1.238,1.238,0,0,0,.522.543,3,3,0,0,0,1.376.265c.44.009.88,0,1.321-.039a7.608,7.608,0,0,0,1.318-.2",
    transform: "translate(-2905.556 -1623.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12034",
    "data-name": "Path 12034",
    className: "cls-27",
    d: "M3238.954,1869.1a1.276,1.276,0,0,1-.45.656,1.8,1.8,0,0,1-.637.328,4,4,0,0,1-.774.115,7.492,7.492,0,0,0-.887.09,2.5,2.5,0,0,0,.848.374,1.977,1.977,0,0,0,.971-.009,1.484,1.484,0,0,0,.83-.595.936.936,0,0,0,.1-.96",
    transform: "translate(-2920.487 -1686.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12035",
    "data-name": "Path 12035",
    className: "cls-27",
    d: "M3219.835,1846.007a1.216,1.216,0,0,0-.3-.391,1.525,1.525,0,0,0-.366-.238,1.49,1.49,0,0,0-.42-.123.279.279,0,1,0-.194.424,1.492,1.492,0,0,0,.367.238,1.508,1.508,0,0,0,.419.121,1.206,1.206,0,0,0,.49-.031",
    transform: "translate(-2904.295 -1665.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12036",
    "data-name": "Path 12036",
    className: "cls-27",
    d: "M3549.163,1876.265a1.8,1.8,0,0,0,.379.619,2.565,2.565,0,0,0,1.187.735,1.793,1.793,0,0,0,.724.06,3.568,3.568,0,0,0-.518-.478,6.387,6.387,0,0,0-.54-.371c-.185-.114-.375-.219-.574-.316a3.549,3.549,0,0,0-.66-.25",
    transform: "translate(-3202.913 -1693.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12037",
    "data-name": "Path 12037",
    className: "cls-27",
    d: "M3623.556,1976.291a.172.172,0,0,0,.163.042.388.388,0,0,0,.162-.086.723.723,0,0,0,.184-.272,2.047,2.047,0,0,0,.132-.488,1.906,1.906,0,0,0,0-.5,1.43,1.43,0,0,0-.163-.524,1.456,1.456,0,0,0-.3.46,1.972,1.972,0,0,0-.135.98,1.2,1.2,0,0,1,.027.2c0,.064.019.134-.076.192",
    transform: "translate(-3270.048 -1781.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12038",
    "data-name": "Path 12038",
    className: "cls-27",
    d: "M3571.779,1964.258c.088-.315.235-.554.313-.891a1.711,1.711,0,0,0-.111-1.033,2.427,2.427,0,0,0-.58-.8,2.773,2.773,0,0,0-.8-.525,7.591,7.591,0,0,0,.443.819,6.78,6.78,0,0,1,.4.742,2.363,2.363,0,0,1,.192.758,2.291,2.291,0,0,0,.149.932",
    transform: "translate(-3222.255 -1769.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12039",
    "data-name": "Path 12039",
    className: "cls-27",
    d: "M3553.489,1977.257a1.331,1.331,0,0,0,.086-.692,1.827,1.827,0,0,0-.216-.655,1.8,1.8,0,0,0-.442-.529,1.324,1.324,0,0,0-.634-.291,6.531,6.531,0,0,0,.279.592l.28.516.292.51c.106.174.209.353.355.55",
    transform: "translate(-3205.729 -1782.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12040",
    "data-name": "Path 12040",
    className: "cls-27",
    d: "M3508.265,1985.163c-.267-.248-.526-.462-.772-.687s-.484-.445-.713-.675-.453-.467-.673-.714-.438-.505-.687-.772a2.625,2.625,0,0,0,.3,1.034,3.49,3.49,0,0,0,.64.871,3.543,3.543,0,0,0,.872.64,2.65,2.65,0,0,0,1.033.3",
    transform: "translate(-3163.437 -1788.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12041",
    "data-name": "Path 12041",
    className: "cls-27",
    d: "M3430.144,1722.513a2.285,2.285,0,0,0,.862.228,3.174,3.174,0,0,0,1.711-.36,2.259,2.259,0,0,0,.7-.558,7.544,7.544,0,0,0-.853.119c-.271.05-.533.1-.8.159l-.792.177a8.213,8.213,0,0,0-.828.235",
    transform: "translate(-3095.505 -1553.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12042",
    "data-name": "Path 12042",
    className: "cls-27",
    d: "M3430.135,1699.474a2.674,2.674,0,0,0,.765-.083,4.328,4.328,0,0,0,.7-.239,4.248,4.248,0,0,0,.652-.356,2.647,2.647,0,0,0,.578-.508,2.789,2.789,0,0,0-.771.084,4.148,4.148,0,0,0-.7.237,4.214,4.214,0,0,0-.646.353,2.844,2.844,0,0,0-.584.51",
    transform: "translate(-3095.497 -1532.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12043",
    "data-name": "Path 12043",
    className: "cls-27",
    d: "M3463.063,1557.33a2.071,2.071,0,0,0,.312-.588,3.095,3.095,0,0,0,.167-1.239.356.356,0,1,0-.462-.062,2.986,2.986,0,0,0-.145.611,3.061,3.061,0,0,0-.019.628,2.076,2.076,0,0,0,.147.65",
    transform: "translate(-3125.073 -1403.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12044",
    "data-name": "Path 12044",
    className: "cls-27",
    d: "M3397.859,1117.238a.311.311,0,0,0-.289-.059.785.785,0,0,0-.275.141,2.577,2.577,0,0,0-.378.417,4.481,4.481,0,0,0-.836,1.976,3.263,3.263,0,0,0,0,1.086c.176-.326.309-.645.446-.959l.4-.935.395-.935c.069-.157.124-.328.193-.458s.156-.275.346-.273",
    transform: "translate(-3064.726 -1008.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12045",
    "data-name": "Path 12045",
    className: "cls-27",
    d: "M3555.957,1110.323a3.046,3.046,0,0,0-.365.666,5.115,5.115,0,0,0-.226.685,4.942,4.942,0,0,0-.128.709,3.076,3.076,0,0,0,.006.76,2.362,2.362,0,0,0,.441-.629,3.428,3.428,0,0,0,.254-.694,3.542,3.542,0,0,0,.105-.733,2.389,2.389,0,0,0-.088-.763",
    transform: "translate(-3208.377 -1002.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12046",
    "data-name": "Path 12046",
    className: "cls-3",
    d: "M.42,1717.919c-3.228,15.055,13.068,11.511,17.392,14.436s.813,3.621,5.82,6.522,6.57,1.933,10.347,8.756,8.972,8.577,11.694,4.945c0,0,3.478-1.606.372-5.6s-3.746-5.911-2.073-10.19-1.854-4.04-6.792-8.2-6.166-3.43-6.852-9.906-3.875-9.556-11.806-14.52a11.732,11.732,0,0,0-6.561-2.075c-5.071.18-9.244,5.128-11.54,15.832",
    transform: "translate(0 -1536.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12047",
    "data-name": "Path 12047",
    className: "cls-22",
    d: "M21.447,1958.568c4.029,4.114,12.732,3.048,15.72,5.07,4.323,2.926.813,3.621,5.82,6.522s6.57,1.934,10.347,8.756,8.972,8.577,11.694,4.945c0,0,3.478-1.606.372-5.6s-3.746-5.911-2.073-10.19-1.854-4.04-6.792-8.2c-.214-.18-.419-.349-.619-.511-2.488.591-4.554,1.974-5,3.606-1.134,4.17-7.767,1.843-14.461-2.192-3.586-2.162-8.539-2.517-12.365-2.381-.967.034-1.862.1-2.645.176",
    transform: "translate(-19.355 -1767.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12048",
    "data-name": "Path 12048",
    className: "cls-3",
    d: "M192.976,1591.333c-6.424,2.167-2.4,6.358-5.92,3.518s-11.085-.633-12.4,7.169,3.416,6.266,9.074,8.231,5.495,3.8,6.558,14.479,14.045,10.107,14.5,10.2c0,0,11.264-.742,12.49-7.971s-.744-4.877,2.383-13.2.266-8.563-6.2-17.229c-4.051-5.429-8.544-6.948-12.916-6.792a26.93,26.93,0,0,0-7.569,1.59",
    transform: "translate(-157.412 -1434.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12049",
    "data-name": "Path 12049",
    className: "cls-23",
    d: "M183.939,1750.955c5.658,1.966,5.495,3.8,6.558,14.479s14.045,10.108,14.5,10.205c0,0,11.264-.742,12.49-7.97s-.744-4.877,2.383-13.2c.352-.938.624-1.77.828-2.526-2.448-4.108-6.863,2.728-7.972,8.251-1.21,6.024-13.487,1.191-16.412-.983s-.832-7.376-7.221-10.852c-4.241-2.306-10.539-2.533-14.432-2.711.326,4.492,4.465,3.637,9.274,5.307",
    transform: "translate(-157.625 -1575.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12050",
    "data-name": "Path 12050",
    className: "cls-21",
    d: "M391.416,1692c1.822-.065,7.008,1.462,7.581,7.942s-2.113,14.331-3.3,26.005c-.146,1.44-.392,3.035-.713,4.729l7.356-.261c.331-5.059-1.142-8.844-.76-12.2.522-4.58,2.281-12.854,1.944-19.115s-1.182-10.792.552-13.362,1.954-9.193,1.954-9.193-3.215,5.817-2.9,1.928-5.018-12.823-5.018-12.823,0-.007-.006-.006.039.351,2.047,6.093c2.285,6.533.387,17.321.387,17.321s-.3,1.265-4.953-4.614-3.544-16.3-3.544-16.3c-4.079,13.6,3.918,20.389,5.8,22.147s1.016,2.929,1.016,2.929c-2.777-4.349-9.279-1.153-7.456-1.218",
    transform: "translate(-352.771 -1503.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12051",
    "data-name": "Path 12051",
    className: "cls-21",
    d: "M71.338,1829.056c4.331,3.153,3.9,7.16,3.9,7.16a17.6,17.6,0,0,0-8.668-3.228,4.789,4.789,0,0,1-4.641-5.423c-2.917,4.552,1.549,8.27,5.421,8.133a13.816,13.816,0,0,1,7.261,2.137s.1,2.734,3.346,7.522,10.737,6.917,14.236,9.074,4.046,7.954,5.941,9.939,3.063-.451,1.7-6.789-14.919-9.049-19.723-12.642-2.529-6.981-3.911-13.775-6.479-5.814-11.491-5.636-6.9-1.579-6.9-1.579c.906,3.047,9.193,1.954,13.525,5.108",
    transform: "translate(-52.173 -1646.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12052",
    "data-name": "Path 12052",
    className: "cls-24",
    d: "M488.641,2128.457c-.1-1.822-.161-3.644-.223-5.466-.037-.911-.054-1.823-.08-2.734l-.036-1.367c-.012-.456-.023-.916.009-1.379.074-.931.328-1.81.432-2.708s.158-1.806.2-2.715.068-1.823.137-2.734a16.693,16.693,0,0,1,.429-2.7,31.453,31.453,0,0,0-.359,5.444,26.577,26.577,0,0,1-.166,2.739c-.1.916-.344,1.8-.406,2.7-.035.447-.029.9-.021,1.354l.024,1.368c.015.912.038,1.822.041,2.734.018,1.823.033,3.647.017,5.471",
    transform: "translate(-440.654 -1901.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12053",
    "data-name": "Path 12053",
    className: "cls-24",
    d: "M506.825,1835.886c-.111-1.177-.2-2.356-.216-3.542,0-.592.022-1.186.081-1.777s.147-1.177.236-1.761.178-1.167.241-1.75a16.958,16.958,0,0,0,.09-1.757c0-1.175-.074-2.356-.123-3.536L507,1818.22l-.065-1.773a7.917,7.917,0,0,1,.124-1.787,22.839,22.839,0,0,1,2.634-6.576,26.066,26.066,0,0,0-1.449,3.228c-.206.552-.395,1.11-.56,1.676a15.549,15.549,0,0,0-.421,1.709,17.69,17.69,0,0,0-.018,3.513l.163,3.542c.041,1.181.11,2.36.1,3.549a17.353,17.353,0,0,1-.1,1.781c-.065.591-.167,1.176-.269,1.758s-.2,1.163-.271,1.746-.1,1.172-.119,1.76c-.033,1.178.034,2.36.085,3.54",
    transform: "translate(-457.185 -1631.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12054",
    "data-name": "Path 12054",
    className: "cls-24",
    d: "M496.433,1741.855a7.385,7.385,0,0,1,1.028,2.238,10.285,10.285,0,0,1,.319,2.453c.033.819.056,1.636.076,2.455s.026,1.638.031,2.457l-.11-.07a1.223,1.223,0,0,0,.622-.652,4.311,4.311,0,0,0,.278-.923,3.712,3.712,0,0,1-.194.959,1.646,1.646,0,0,1-.24.441,1.1,1.1,0,0,1-.4.319l-.1.047-.007-.117c-.049-.817-.1-1.635-.128-2.453s-.062-1.636-.083-2.455a12.425,12.425,0,0,0-.235-2.417,9.046,9.046,0,0,0-.851-2.281",
    transform: "translate(-448.002 -1571.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12055",
    "data-name": "Path 12055",
    className: "cls-24",
    d: "M410.913,1813.745c.531,1.087,1.047,2.183,1.614,3.25a31.3,31.3,0,0,0,1.832,3.12,19.653,19.653,0,0,0,2.277,2.792,9.339,9.339,0,0,1,1.2,1.386,8.379,8.379,0,0,1,.8,1.658,8.483,8.483,0,0,1,.524,1.764c.071.617.086,1.214.128,1.819.069,1.208.143,2.418.167,3.63s.03,2.424-.023,3.635a34.339,34.339,0,0,1-.354,3.615,47.678,47.678,0,0,0,.169-7.243q-.084-1.81-.2-3.621c-.046-.6-.067-1.215-.139-1.8a8.352,8.352,0,0,0-.521-1.7,8.088,8.088,0,0,0-.76-1.612,9.137,9.137,0,0,0-1.164-1.356,18.2,18.2,0,0,1-2.274-2.849,42.735,42.735,0,0,1-3.274-6.484",
    transform: "translate(-370.825 -1636.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12056",
    "data-name": "Path 12056",
    className: "cls-24",
    d: "M462.932,2045.766a17.027,17.027,0,0,1-.247,4.894c-.251,1.618-.591,3.219-.822,4.832-.124.8-.225,1.613-.281,2.424-.029.406-.042.812-.049,1.218s0,.819-.037,1.233a19.338,19.338,0,0,1-.529,2.406,20.9,20.9,0,0,0-.41,2.413,17.858,17.858,0,0,1,.28-2.439,19.467,19.467,0,0,0,.451-2.394c.023-.4.01-.809.012-1.219s.012-.823.037-1.233c.048-.821.142-1.637.26-2.449.255-1.62.591-3.221.884-4.827.147-.8.282-1.608.375-2.417a12.266,12.266,0,0,0,.076-2.442",
    transform: "translate(-415.625 -1846.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12057",
    "data-name": "Path 12057",
    className: "cls-24",
    d: "M343.957,2076.94a6.185,6.185,0,0,1,1.463.662c.471.25.955.475,1.446.681.982.415,1.986.784,2.99,1.161.5.2,1,.4,1.487.623a8.659,8.659,0,0,1,1.433.762,4.239,4.239,0,0,1,1.156,1.146,3.861,3.861,0,0,1,.582,1.5,4.109,4.109,0,0,0-1.852-2.475,10.824,10.824,0,0,0-1.417-.711c-.49-.21-.987-.4-1.487-.6-.992-.4-2-.764-2.976-1.224-.486-.231-.965-.479-1.427-.755a6.917,6.917,0,0,0-1.4-.777",
    transform: "translate(-310.401 -1874.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12058",
    "data-name": "Path 12058",
    className: "cls-24",
    d: "M404.912,2117.018c-.115-.285-.225-.569-.358-.844a6.61,6.61,0,0,0-.417-.81c-.314-.52-.583-1.072-.915-1.572a4.125,4.125,0,0,0-1.256-1.239,4.059,4.059,0,0,0-.8-.4,4.3,4.3,0,0,0-.879-.234,3.49,3.49,0,0,1,.919.108,4.131,4.131,0,0,1,.87.345,3.789,3.789,0,0,1,1.377,1.269,16.507,16.507,0,0,1,.875,1.63,6.875,6.875,0,0,1,.589,1.745",
    transform: "translate(-361.232 -1905.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12059",
    "data-name": "Path 12059",
    className: "cls-24",
    d: "M162.517,1845.269c1.1.177,2.209.326,3.3.6a6.125,6.125,0,0,1,1.579.628,4.11,4.11,0,0,1,.7.51,3.264,3.264,0,0,1,.3.313c.048.055.1.107.142.163l.124.177a5.5,5.5,0,0,1,.7,1.557,14.225,14.225,0,0,1,.362,1.647c.1.55.191,1.1.327,1.636a6.749,6.749,0,0,0,.566,1.565,6.135,6.135,0,0,1-.693-1.529c-.164-.538-.283-1.087-.4-1.632a8.368,8.368,0,0,0-1.082-3.091l-.113-.168c-.041-.053-.087-.1-.131-.154a2.939,2.939,0,0,0-.274-.3,3.833,3.833,0,0,0-.646-.489,6.783,6.783,0,0,0-1.511-.64c-.529-.164-1.073-.283-1.618-.406s-1.088-.253-1.63-.393",
    transform: "translate(-146.662 -1665.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12060",
    "data-name": "Path 12060",
    className: "cls-24",
    d: "M142.568,1923.107a18.8,18.8,0,0,0,2.529.66c.427.08.859.135,1.29.186a9.658,9.658,0,0,1,1.313.2,6.145,6.145,0,0,1,1.238.5c.39.2.782.4,1.164.617a8.48,8.48,0,0,1,1.1.739,5.208,5.208,0,0,1,.92.964l-.144.026a4.474,4.474,0,0,0,.21-1.084,4.429,4.429,0,0,0-.073-1.114,3.937,3.937,0,0,1,.169,1.116,3.893,3.893,0,0,1-.15,1.13l-.043.151-.1-.125a5.033,5.033,0,0,0-.929-.886,8.651,8.651,0,0,0-1.086-.7c-.379-.21-.77-.4-1.163-.593a6.457,6.457,0,0,0-1.183-.5,9.574,9.574,0,0,0-1.277-.21,13.868,13.868,0,0,1-3.791-1.075",
    transform: "translate(-128.659 -1735.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12061",
    "data-name": "Path 12061",
    className: "cls-24",
    d: "M191.292,1860.065a10.114,10.114,0,0,1,.947.461,3.016,3.016,0,0,1,.45.3,2.283,2.283,0,0,1,.376.4,4.829,4.829,0,0,1,.5.938,10.49,10.49,0,0,1,.376.983q-.306-.434-.562-.886a9.24,9.24,0,0,0-.534-.876,2.822,2.822,0,0,0-.721-.684c-.284-.2-.565-.411-.835-.638",
    transform: "translate(-172.63 -1678.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12062",
    "data-name": "Path 12062",
    className: "cls-24",
    d: "M502.018,1927.614a9.67,9.67,0,0,1,.194,2.351,17.636,17.636,0,0,1-.193,2.346,18.329,18.329,0,0,1-.076-2.352c.02-.782.044-1.556.076-2.345",
    transform: "translate(-452.968 -1739.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12063",
    "data-name": "Path 12063",
    className: "cls-24",
    d: "M398.172,1780.227a9.61,9.61,0,0,0,.16,1.281,12.17,12.17,0,0,0,.326,1.245c.118.411.241.826.369,1.238s.25.824.386,1.232a23.009,23.009,0,0,0,.911,2.406c.174.392.366.777.569,1.156s.417.754.637,1.126c-.271-.338-.514-.7-.751-1.06s-.443-.746-.642-1.133a16.214,16.214,0,0,1-.98-2.413c-.261-.828-.505-1.654-.7-2.5a11.749,11.749,0,0,1-.256-1.277,7.481,7.481,0,0,1-.03-1.3",
    transform: "translate(-359.312 -1606.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12064",
    "data-name": "Path 12064",
    className: "cls-25",
    d: "M247.829,1980.446c.39.907.751,1.824,1.109,2.743.183.458.349.92.566,1.353a5.822,5.822,0,0,0,.79,1.207,9.129,9.129,0,0,0,2.226,1.861c.413.263.842.5,1.277.731s.873.455,1.31.686a19.929,19.929,0,0,1-2.693-1.239,10.371,10.371,0,0,1-1.246-.823,7.561,7.561,0,0,1-1.082-1.043,5.9,5.9,0,0,1-.812-1.269,13.1,13.1,0,0,1-.53-1.392c-.317-.934-.629-1.868-.915-2.814",
    transform: "translate(-223.651 -1787.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12065",
    "data-name": "Path 12065",
    className: "cls-25",
    d: "M317,2077.734a14.455,14.455,0,0,1,1.419.471c.464.184.919.389,1.37.6.9.425,1.776.9,2.655,1.365s1.749.942,2.613,1.438a10.031,10.031,0,0,1,1.249.835,4.157,4.157,0,0,1,.977,1.131,6.367,6.367,0,0,0-2.327-1.784c-.883-.45-1.764-.915-2.641-1.382l-2.619-1.418a26.618,26.618,0,0,0-2.7-1.256",
    transform: "translate(-286.075 -1875.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12066",
    "data-name": "Path 12066",
    className: "cls-25",
    d: "M421.355,1934.9c.98.455,1.95.926,2.913,1.421a6.028,6.028,0,0,1,1.362.92,3.447,3.447,0,0,1,.9,1.4,10.256,10.256,0,0,1,.369,1.6c.092.532.193,1.062.275,1.6l.256,1.6c.076.535.16,1.068.229,1.6-.128-.525-.239-1.053-.359-1.58l-.331-1.585c-.114-.528-.208-1.059-.312-1.589a10.223,10.223,0,0,0-.381-1.55,3.191,3.191,0,0,0-.814-1.311,6.746,6.746,0,0,0-1.293-.917c-.464-.271-.942-.525-1.411-.791s-.939-.533-1.4-.811",
    transform: "translate(-380.248 -1746.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12067",
    "data-name": "Path 12067",
    className: "cls-25",
    d: "M491.383,1800.784a.319.319,0,0,0,.365-.024.536.536,0,0,0,.2-.318,7.6,7.6,0,0,0,.11-.787c.06-.529.095-1.061.115-1.593l.1-3.2q.078-1.6.078-3.2c0-1.067-.021-2.134-.048-3.2.072.53.119,1.063.166,1.6s.068,1.069.089,1.6c.043,1.071.014,2.143-.016,3.212-.055,1.068-.081,2.135-.167,3.2-.046.534-.1,1.069-.192,1.6a7.375,7.375,0,0,1-.171.79.591.591,0,0,1-.243.331.339.339,0,0,1-.387-.01",
    transform: "translate(-443.445 -1613.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12068",
    "data-name": "Path 12068",
    className: "cls-25",
    d: "M456.908,2133.738c-.061-.569-.141-1.133-.171-1.709a7.467,7.467,0,0,1,.12-1.727c.1-.565.214-1.122.355-1.68.072-.278.149-.555.235-.829a8.208,8.208,0,0,1,.317-.8c-.138.556-.251,1.112-.349,1.672l-.292,1.683a10.614,10.614,0,0,0-.179,1.678c-.014.565.014,1.14-.036,1.712",
    transform: "translate(-412.169 -1919.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12069",
    "data-name": "Path 12069",
    className: "cls-25",
    d: "M103.161,1909.576a3.678,3.678,0,0,0,.776,1.084,4.739,4.739,0,0,0,1.065.786,8.4,8.4,0,0,0,2.516.832c.877.172,1.776.279,2.66.479.442.1.88.207,1.315.329s.865.264,1.287.424c-.44-.1-.876-.209-1.318-.3s-.881-.181-1.323-.254c-.884-.15-1.778-.249-2.671-.417a7.529,7.529,0,0,1-2.57-.919,4.785,4.785,0,0,1-1.056-.874,3.414,3.414,0,0,1-.68-1.174",
    transform: "translate(-93.097 -1723.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12070",
    "data-name": "Path 12070",
    className: "cls-26",
    d: "M351.826,1896.627a1.369,1.369,0,0,1-.911-.225,4.718,4.718,0,0,1-.741-.594c-.455-.426-.9-.862-1.331-1.318a19.638,19.638,0,0,1-2.329-2.955,13.074,13.074,0,0,1-1.553-3.445,9.13,9.13,0,0,1-.284-3.738,12.4,12.4,0,0,0,.686,3.613,16,16,0,0,0,1.607,3.283,28.125,28.125,0,0,0,2.187,2.965q.593.711,1.206,1.413a5.038,5.038,0,0,0,.636.655,1.382,1.382,0,0,0,.826.347",
    transform: "translate(-310.976 -1700.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12071",
    "data-name": "Path 12071",
    className: "cls-26",
    d: "M276.959,1771.292c-.351-.424-.692-.833-1.052-1.221a15.242,15.242,0,0,0-2.37-2.072c-.432-.305-.883-.589-1.35-.882a5.2,5.2,0,0,1,1.566.52,6.666,6.666,0,0,1,2.481,2.172,5.239,5.239,0,0,1,.724,1.483",
    transform: "translate(-245.633 -1594.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12072",
    "data-name": "Path 12072",
    className: "cls-26",
    d: "M339.906,1779.693a.832.832,0,0,1-.407-.028,1.386,1.386,0,0,1-.368-.2,4,4,0,0,1-.589-.569c-.36-.4-.709-.81-1.033-1.24a21.556,21.556,0,0,1-1.769-2.7,21.791,21.791,0,0,1-1.34-2.939,17.748,17.748,0,0,1-.851-3.107c.4,1,.8,1.981,1.241,2.947s.909,1.914,1.422,2.839,1.061,1.831,1.639,2.72c.143.224.293.442.443.662s.3.438.454.656a4.288,4.288,0,0,0,.48.621.987.987,0,0,0,.678.338",
    transform: "translate(-301.009 -1596.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12073",
    "data-name": "Path 12073",
    className: "cls-26",
    d: "M333.429,1692.677a11.616,11.616,0,0,1-.985-1.6,17.563,17.563,0,0,1-.773-1.705,17.373,17.373,0,0,1-.581-1.78,11.541,11.541,0,0,1-.35-1.845c.277.566.516,1.138.749,1.711s.457,1.146.684,1.719.443,1.149.654,1.73.424,1.163.6,1.767",
    transform: "translate(-298.474 -1521.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12074",
    "data-name": "Path 12074",
    className: "cls-26",
    d: "M416.164,1735.556a10.043,10.043,0,0,1-1.233-1.774,12.865,12.865,0,0,1-1.434-4.073,9.981,9.981,0,0,1-.149-2.156c.189.7.365,1.383.56,2.062s.405,1.35.643,2.011.489,1.318.758,1.971.567,1.3.856,1.958",
    transform: "translate(-373.014 -1559.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12075",
    "data-name": "Path 12075",
    className: "cls-26",
    d: "M198.2,1753.356a4.136,4.136,0,0,1,1.527-.028,5.277,5.277,0,0,1,2.75,1.325,4.1,4.1,0,0,1,.929,1.212c-.4-.317-.786-.614-1.189-.881a10.717,10.717,0,0,0-2.586-1.248c-.46-.149-.934-.267-1.431-.38",
    transform: "translate(-178.861 -1582.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12076",
    "data-name": "Path 12076",
    className: "cls-26",
    d: "M222.549,1714.167a.174.174,0,0,1,.08-.161.56.56,0,0,1,.167-.081,2.95,2.95,0,0,1,.335-.1,3.218,3.218,0,0,1,.7-.071,4.65,4.65,0,0,1,1.371.226,7.424,7.424,0,0,1,1.256.533,3.028,3.028,0,0,1,.6.376.663.663,0,0,1,.2.337.392.392,0,0,1-.079.351.37.37,0,0,0-.061-.3.509.509,0,0,0-.216-.177,6.13,6.13,0,0,0-.606-.2l-1.254-.406a10.492,10.492,0,0,0-1.247-.323,6.139,6.139,0,0,0-.642-.084c-.109-.015-.218-.013-.33-.021a.528.528,0,0,0-.155.007.135.135,0,0,0-.116.089",
    transform: "translate(-200.835 -1546.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12077",
    "data-name": "Path 12077",
    className: "cls-26",
    d: "M239.935,1668.338a8.238,8.238,0,0,1,1.605.866c.511.325,1,.669,1.492,1.03a7.849,7.849,0,0,1,1.354,1.256,3.419,3.419,0,0,1,.792,1.667,5.671,5.671,0,0,0-1.1-1.381,16.121,16.121,0,0,0-1.371-1.113c-.474-.363-.958-.73-1.415-1.122s-.891-.811-1.356-1.2",
    transform: "translate(-216.527 -1505.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12078",
    "data-name": "Path 12078",
    className: "cls-26",
    d: "M297.384,1679.623a4.65,4.65,0,0,1,1.005,1.224,12.068,12.068,0,0,1,.7,1.4c.2.474.392.946.6,1.409.105.231.213.458.329.7a2.189,2.189,0,0,1,.228.766,3.98,3.98,0,0,0-.452-.625,6.08,6.08,0,0,1-.473-.634,9.086,9.086,0,0,1-.728-1.4c-.206-.477-.385-.958-.576-1.43s-.4-.936-.63-1.411",
    transform: "translate(-268.372 -1515.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12079",
    "data-name": "Path 12079",
    className: "cls-26",
    d: "M359.676,1671.138a5.678,5.678,0,0,1-.53-.959c-.147-.327-.279-.653-.4-1-.059-.172-.116-.344-.165-.518a3.223,3.223,0,0,1-.092-.554,2.763,2.763,0,0,1,.119-1.109c.1.361.192.7.294,1.031.058.164.1.327.168.488s.129.33.188.5a7.792,7.792,0,0,1,.287,1.037,5.7,5.7,0,0,1,.13,1.088",
    transform: "translate(-323.505 -1504.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12080",
    "data-name": "Path 12080",
    className: "cls-26",
    d: "M384.573,1628.965a8.231,8.231,0,0,1,.6,1.176q.256.6.456,1.219c.134.412.247.83.343,1.255a8.169,8.169,0,0,1,.2,1.305,8.011,8.011,0,0,1-.6-1.172c-.17-.4-.324-.808-.456-1.222s-.247-.833-.342-1.259a8.117,8.117,0,0,1-.2-1.3",
    transform: "translate(-347.055 -1470.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12081",
    "data-name": "Path 12081",
    className: "cls-26",
    d: "M411.7,1619.237a13.69,13.69,0,0,1,1.1,1.982,18.983,18.983,0,0,1,.817,2.113,18.763,18.763,0,0,1,.553,2.2,13.638,13.638,0,0,1,.247,2.252c-.236-.72-.443-1.438-.657-2.152s-.428-1.426-.657-2.133-.459-1.414-.693-2.122-.483-1.413-.706-2.136",
    transform: "translate(-371.533 -1461.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12082",
    "data-name": "Path 12082",
    className: "cls-26",
    d: "M449.811,1720.34a2.587,2.587,0,0,1,1.22,1.115,10.191,10.191,0,0,1,.711,1.474c.2.5.388,1,.556,1.515a12.149,12.149,0,0,1,.417,1.573,12.248,12.248,0,0,1-.807-1.414c-.24-.483-.464-.972-.666-1.471s-.376-1.007-.582-1.482a3.979,3.979,0,0,0-.849-1.311",
    transform: "translate(-405.928 -1552.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12083",
    "data-name": "Path 12083",
    className: "cls-26",
    d: "M467.948,1614.874a7.006,7.006,0,0,1,.566,1.078c.159.368.3.742.423,1.122a11.921,11.921,0,0,1,.309,1.159,6.908,6.908,0,0,1,.166,1.207,6.884,6.884,0,0,1-.566-1.077,11.875,11.875,0,0,1-.423-1.124c-.123-.381-.224-.768-.309-1.161a6.912,6.912,0,0,1-.166-1.2",
    transform: "translate(-422.296 -1457.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12084",
    "data-name": "Path 12084",
    className: "cls-26",
    d: "M516.4,1636.273a10.2,10.2,0,0,1,.72,1.769,13.963,13.963,0,0,1,.625,3.757,10.108,10.108,0,0,1-.11,1.906c-.122-.628-.214-1.249-.309-1.868s-.19-1.235-.3-1.85-.211-1.229-.317-1.846-.224-1.234-.313-1.868",
    transform: "translate(-466.025 -1476.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12085",
    "data-name": "Path 12085",
    className: "cls-26",
    d: "M557.672,1704.73a2.025,2.025,0,0,1-.318-1.266,4.328,4.328,0,0,1,.28-1.275,10.971,10.971,0,0,1,.514-1.155,7.532,7.532,0,0,1,.658-1.091,7.563,7.563,0,0,1-.266,1.246c-.116.4-.257.8-.4,1.185a5.226,5.226,0,0,0-.469,2.357",
    transform: "translate(-502.975 -1534.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12086",
    "data-name": "Path 12086",
    className: "cls-26",
    d: "M582.62,1729.363a14.319,14.319,0,0,0-.472,1.854c-.113.622-.2,1.248-.287,1.882s-.182,1.272-.327,1.906a7.615,7.615,0,0,1-.63,1.848c.085-.647.152-1.278.214-1.914s.123-1.273.209-1.915a11.794,11.794,0,0,1,.415-1.91,5.556,5.556,0,0,1,.879-1.751",
    transform: "translate(-524.232 -1560.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12087",
    "data-name": "Path 12087",
    className: "cls-26",
    d: "M614.515,1766.8a7.05,7.05,0,0,1-.4,2.255c-.227.729-.5,1.426-.7,2.136a15.119,15.119,0,0,0-.445,2.172,21.982,21.982,0,0,0-.161,2.247,7.837,7.837,0,0,1-.259-2.28,9.317,9.317,0,0,1,.346-2.286,16.852,16.852,0,0,1,.821-2.137,16.207,16.207,0,0,0,.8-2.108",
    transform: "translate(-552.79 -1594.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12088",
    "data-name": "Path 12088",
    className: "cls-26",
    d: "M596.775,1894.8a5.566,5.566,0,0,1,.235,1.567,9.358,9.358,0,0,1-.11,1.577,13.532,13.532,0,0,1-.328,1.533,3.731,3.731,0,0,1-.628,1.454,9.938,9.938,0,0,0,.214-1.532c.059-.517.13-1.028.209-1.535s.155-1.011.225-1.519.121-1.017.184-1.544",
    transform: "translate(-537.805 -1709.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12089",
    "data-name": "Path 12089",
    className: "cls-26",
    d: "M549.5,1820.826a10.466,10.466,0,0,1,.027,1.822,14.943,14.943,0,0,1-.667,3.569,10.376,10.376,0,0,1-.686,1.688c.069-.607.172-1.2.276-1.789l.322-1.762.339-1.759c.116-.587.234-1.176.389-1.768",
    transform: "translate(-494.693 -1643.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12090",
    "data-name": "Path 12090",
    className: "cls-26",
    d: "M198.25,1798.6a4.131,4.131,0,0,0,1.179,1.021,10.294,10.294,0,0,0,1.494.468,14.452,14.452,0,0,0,1.549.332c.261.037.524.068.791.082a1.078,1.078,0,0,0,.757-.124.63.63,0,0,1-.327.275,2.021,2.021,0,0,1-.413.113,4.61,4.61,0,0,1-.838.073,6.515,6.515,0,0,1-1.657-.23c-.269-.073-.531-.154-.792-.249a3.551,3.551,0,0,1-.775-.379,2.1,2.1,0,0,1-.608-.629,3.917,3.917,0,0,1-.36-.754",
    transform: "translate(-178.909 -1623.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12091",
    "data-name": "Path 12091",
    className: "cls-26",
    d: "M113.257,1723.21a7.139,7.139,0,0,1,1.606.335,4.585,4.585,0,0,1,1.478.8,3.119,3.119,0,0,1,.99,1.4,2.8,2.8,0,0,1,.025,1.664,4.638,4.638,0,0,0-.415-1.5,3.66,3.66,0,0,0-.946-1.143,6.94,6.94,0,0,0-1.3-.828c-.467-.24-.962-.455-1.443-.721",
    transform: "translate(-102.208 -1555.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12092",
    "data-name": "Path 12092",
    className: "cls-26",
    d: "M85.96,1766.932a4.509,4.509,0,0,1,1.076.4,6.589,6.589,0,0,1,1.816,1.368,4.492,4.492,0,0,1,.685.924,9.7,9.7,0,0,1-.961-.606c-.3-.213-.6-.427-.9-.65s-.583-.45-.872-.685a9.827,9.827,0,0,1-.847-.756",
    transform: "translate(-77.574 -1594.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12093",
    "data-name": "Path 12093",
    className: "cls-26",
    d: "M42.6,1791.8c.437.085.851.193,1.263.3l1.232.3,1.235.289c.416.094.833.186,1.261.308a4.865,4.865,0,0,1-1.315.109,6.673,6.673,0,0,1-1.306-.181,6.746,6.746,0,0,1-1.246-.432,4.924,4.924,0,0,1-1.123-.693",
    transform: "translate(-38.445 -1616.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12094",
    "data-name": "Path 12094",
    className: "cls-26",
    d: "M25.146,1837.787a6.86,6.86,0,0,0,2.372,1.436c.432.162.876.3,1.331.438s.918.268,1.375.453a7.249,7.249,0,0,1-1.461-.041,6.207,6.207,0,0,1-1.436-.345,4.5,4.5,0,0,1-1.3-.75,2.931,2.931,0,0,1-.883-1.19",
    transform: "translate(-22.693 -1658.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12095",
    "data-name": "Path 12095",
    className: "cls-26",
    d: "M43.683,1926.041a12.456,12.456,0,0,0,.943.864,8.258,8.258,0,0,0,2.121,1.238,12.556,12.556,0,0,0,1.215.4,3.128,3.128,0,0,1-1.333.005,4.079,4.079,0,0,1-2.3-1.343,3.143,3.143,0,0,1-.649-1.163",
    transform: "translate(-39.421 -1738.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12096",
    "data-name": "Path 12096",
    className: "cls-26",
    d: "M89.91,1973.93l1.812.316c.6.1,1.195.19,1.795.257s1.2.127,1.8.175l1.835.123a8.106,8.106,0,0,1-1.838.3,10.677,10.677,0,0,1-3.692-.445,8.155,8.155,0,0,1-1.715-.725",
    transform: "translate(-81.139 -1781.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12097",
    "data-name": "Path 12097",
    className: "cls-26",
    d: "M176.339,1969.629a8.673,8.673,0,0,1,1.021.618l.957.645c.317.207.651.413.974.652a3.071,3.071,0,0,1,.845.874c-.362-.189-.709-.346-1.062-.513a8.157,8.157,0,0,1-1.053-.562,6,6,0,0,1-1.683-1.714",
    transform: "translate(-159.136 -1777.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12098",
    "data-name": "Path 12098",
    className: "cls-26",
    d: "M221.815,2030.951c.264.257.489.528.714.787s.45.509.684.743a6.87,6.87,0,0,0,.747.649,6.546,6.546,0,0,0,.882.543,2.029,2.029,0,0,1-1.09-.177,3.013,3.013,0,0,1-.92-.634,3.686,3.686,0,0,1-.649-.889,3.533,3.533,0,0,1-.367-1.023",
    transform: "translate(-200.175 -1832.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12099",
    "data-name": "Path 12099",
    className: "cls-26",
    d: "M278.752,1834.485a.327.327,0,0,1,.253.035.817.817,0,0,1,.2.172c.112.135.193.273.291.411s.167.288.251.432.145.3.215.453a8.51,8.51,0,0,1,.552,1.918,12.246,12.246,0,0,1,.157,1.975,13.284,13.284,0,0,1-.136,1.967c-.128-.649-.2-1.3-.285-1.941s-.158-1.282-.269-1.911a15.981,15.981,0,0,0-.415-1.865c-.094-.3-.191-.609-.307-.91-.059-.147-.116-.306-.179-.446s-.156-.281-.329-.29",
    transform: "translate(-251.557 -1655.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12100",
    "data-name": "Path 12100",
    className: "cls-26",
    d: "M252.9,1855.731a6.527,6.527,0,0,1,1.161,2.436,17.945,17.945,0,0,1,.454,2.657c.092.887.174,1.765.308,2.632a11.254,11.254,0,0,0,.687,2.549,6.848,6.848,0,0,1-1.1-2.464,19.779,19.779,0,0,1-.432-2.657c-.092-.885-.179-1.762-.327-2.625a10.292,10.292,0,0,0-.751-2.527",
    transform: "translate(-228.23 -1674.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12101",
    "data-name": "Path 12101",
    className: "cls-26",
    d: "M307.7,1930.518a12.123,12.123,0,0,0,.633,2,10.5,10.5,0,0,0,2.308,3.39,12.1,12.1,0,0,0,1.631,1.325,5.776,5.776,0,0,1-1.908-1.008,7.112,7.112,0,0,1-2.426-3.566,5.794,5.794,0,0,1-.238-2.145",
    transform: "translate(-277.66 -1742.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12102",
    "data-name": "Path 12102",
    className: "cls-26",
    d: "M266.653,2079.26a13.549,13.549,0,0,1,3.15,1.439c.992.6,1.945,1.225,2.889,1.907a13.645,13.645,0,0,1,1.338,1.134,8.039,8.039,0,0,1,1.114,1.37,13.717,13.717,0,0,1,1.414,3.17,27.041,27.041,0,0,0-1.76-2.931,11.207,11.207,0,0,0-2.429-2.311c-.451-.343-.922-.665-1.391-1l-1.4-.99a25.927,25.927,0,0,0-2.923-1.792",
    transform: "translate(-240.639 -1876.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12103",
    "data-name": "Path 12103",
    className: "cls-26",
    d: "M381.742,2181.437a5.321,5.321,0,0,0,.564.613,3.647,3.647,0,0,0,.612.452,3.761,3.761,0,0,0,.7.311,1.868,1.868,0,0,1,.774.436c-.3-.023-.565,0-.859-.02a1.954,1.954,0,0,1-.89-.261,1.934,1.934,0,0,1-.669-.652,1.508,1.508,0,0,1-.235-.878",
    transform: "translate(-344.497 -1968.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12104",
    "data-name": "Path 12104",
    className: "cls-26",
    d: "M424.8,2018.307a6.674,6.674,0,0,0,.66.36c.213.1.427.189.646.272l.68.253a3.94,3.94,0,0,1,.705.341,2.559,2.559,0,0,1-.794.074,2.629,2.629,0,0,1-.782-.164,2.106,2.106,0,0,1-.7-.431,1.357,1.357,0,0,1-.416-.706",
    transform: "translate(-383.353 -1821.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12105",
    "data-name": "Path 12105",
    className: "cls-26",
    d: "M541.034,1992.171a9.512,9.512,0,0,0,2.083-1.633,6.624,6.624,0,0,1,1.1-.837,3.535,3.535,0,0,0,1.111-.723,1.182,1.182,0,0,1-.35.618c-.169.169-.354.311-.518.45-.333.281-.645.592-.981.893a6.445,6.445,0,0,1-1.106.833,2.654,2.654,0,0,1-1.338.4",
    transform: "translate(-488.252 -1794.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12106",
    "data-name": "Path 12106",
    className: "cls-26",
    d: "M566.553,1859.112a18.046,18.046,0,0,1-.052,2.749,23.523,23.523,0,0,1-.41,2.721,23.226,23.226,0,0,1-.73,2.654,6.672,6.672,0,0,1-.547,1.284,2.01,2.01,0,0,1-1.032.923,2.177,2.177,0,0,0,.8-1.042,8.732,8.732,0,0,0,.379-1.283c.215-.881.423-1.761.607-2.647s.357-1.773.522-2.665Z",
    transform: "translate(-508.78 -1677.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12107",
    "data-name": "Path 12107",
    className: "cls-26",
    d: "M147.569,1691.834a3.1,3.1,0,0,1,1.067.309,9.411,9.411,0,0,1,.96.548,5.3,5.3,0,0,0,1.858.874l-.3.173a3.6,3.6,0,0,0,.174-1.041,9.1,9.1,0,0,1,.122-1.156,5.507,5.507,0,0,1,.339-1.123,4.82,4.82,0,0,1,.576-1.006,9.585,9.585,0,0,0-.32,1.089,7.709,7.709,0,0,0-.173,1.1c-.03.367-.029.729-.029,1.119a3.829,3.829,0,0,1-.185,1.2l-.078.214-.22-.041a3.358,3.358,0,0,1-1.094-.42,7.853,7.853,0,0,1-.912-.646,7.43,7.43,0,0,0-1.789-1.195",
    transform: "translate(-133.172 -1524.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12108",
    "data-name": "Path 12108",
    className: "cls-26",
    d: "M406.479,1963.089a.754.754,0,0,1,.648.406,3.642,3.642,0,0,0,.4.581,5.783,5.783,0,0,0,1.1.856c.4.263.793.567,1.18.846a2,2,0,0,0,.6.307.916.916,0,0,0,.675-.053.872.872,0,0,1-.706.317,1.819,1.819,0,0,1-.774-.2,12.713,12.713,0,0,1-1.281-.769,3.812,3.812,0,0,1-1.126-1.048c-.333-.47-.22-1.023-.708-1.238",
    transform: "translate(-366.824 -1771.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12109",
    "data-name": "Path 12109",
    className: "cls-26",
    d: "M382.84,2146.709a5.293,5.293,0,0,0,.9,1.29,4.333,4.333,0,0,0,1.222.884c.457.226.96.41,1.456.629a12.521,12.521,0,0,1,1.455.738,12.212,12.212,0,0,1-1.595-.341,8.574,8.574,0,0,1-1.557-.544,3.481,3.481,0,0,1-1.3-1.1,3.014,3.014,0,0,1-.58-1.558",
    transform: "translate(-345.491 -1937.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12110",
    "data-name": "Path 12110",
    className: "cls-26",
    d: "M433.322,2053.588a2.988,2.988,0,0,1-.326-1.071,4.012,4.012,0,0,1,.352-2.2,2.969,2.969,0,0,1,.646-.915l-.248,1.054c-.078.342-.141.681-.2,1.021s-.1.682-.134,1.032Z",
    transform: "translate(-390.727 -1849.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12111",
    "data-name": "Path 12111",
    className: "cls-27",
    d: "M393.677,2141.3a2.619,2.619,0,0,1,.647.318,4.118,4.118,0,0,1,.541.427c.166.152.315.309.469.46s.307.3.5.464a1.185,1.185,0,0,1-.741-.113,2.354,2.354,0,0,1-.6-.415,3.963,3.963,0,0,1-.465-.515,2.643,2.643,0,0,1-.358-.626",
    transform: "translate(-355.271 -1932.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12112",
    "data-name": "Path 12112",
    className: "cls-27",
    d: "M333.171,2041.267a12.658,12.658,0,0,1,1.146.6c.369.212.732.427,1.091.65s.714.45,1.069.686a12.326,12.326,0,0,1,1.049.758,5.768,5.768,0,0,1-1.248-.387,8.485,8.485,0,0,1-2.2-1.364,5.767,5.767,0,0,1-.9-.942",
    transform: "translate(-300.667 -1842.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12113",
    "data-name": "Path 12113",
    className: "cls-27",
    d: "M375.208,2041.942a1.2,1.2,0,0,1,.82-.077c.263.052.487.112.726.166l.711.168c.241.061.487.116.751.208a1.966,1.966,0,0,1-.783.215,2.648,2.648,0,0,1-.8-.066,2.9,2.9,0,0,1-.74-.291,3.581,3.581,0,0,0-.682-.323",
    transform: "translate(-338.603 -1842.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12114",
    "data-name": "Path 12114",
    className: "cls-27",
    d: "M274.85,1985.077a.193.193,0,0,1,.146-.09.4.4,0,0,1,.181.031.907.907,0,0,1,.289.2c.151.147.3.294.442.449q.429.461.81.957c.259.329.485.683.721,1a3.229,3.229,0,0,0,.856.851,1.887,1.887,0,0,1-1.168-.568,7.806,7.806,0,0,1-.837-.957q-.381-.5-.715-1.03c-.112-.176-.217-.36-.319-.544a.831.831,0,0,0-.158-.233.2.2,0,0,0-.249-.067",
    transform: "translate(-248.036 -1791.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12115",
    "data-name": "Path 12115",
    className: "cls-27",
    d: "M281.985,1918.749a7.422,7.422,0,0,1,.473,1.018c.134.343.256.689.364,1.038s.2.7.287,1.062a7.292,7.292,0,0,1,.183,1.108,5,5,0,0,1-.581-.97,7.891,7.891,0,0,1-.658-2.129,5.081,5.081,0,0,1-.068-1.128",
    transform: "translate(-254.468 -1731.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12116",
    "data-name": "Path 12116",
    className: "cls-27",
    d: "M147.194,1891.4a8.2,8.2,0,0,1,1.136.34c.366.134.726.277,1.079.435s.7.326,1.047.509a7.973,7.973,0,0,1,1.013.615,5.524,5.524,0,0,1-1.171-.225,8.649,8.649,0,0,1-1.108-.406,8.814,8.814,0,0,1-1.044-.55,5.655,5.655,0,0,1-.953-.717",
    transform: "translate(-132.834 -1706.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12117",
    "data-name": "Path 12117",
    className: "cls-27",
    d: "M118.141,1952.877a3.957,3.957,0,0,1,.994-.268,5.812,5.812,0,0,1,2.026.07,3.916,3.916,0,0,1,.973.337,7.316,7.316,0,0,1-1.013.085c-.332.008-.66,0-.988-.007s-.656-.031-.987-.062a7.443,7.443,0,0,1-1-.155",
    transform: "translate(-106.615 -1762.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12118",
    "data-name": "Path 12118",
    className: "cls-27",
    d: "M216.491,1982.037a4.066,4.066,0,0,1,.784.677,6.037,6.037,0,0,1,1.1,1.719,4.016,4.016,0,0,1,.284,1,7.213,7.213,0,0,1-.653-.789c-.2-.27-.383-.545-.56-.823s-.348-.563-.51-.856a7.329,7.329,0,0,1-.441-.925",
    transform: "translate(-195.371 -1788.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12119",
    "data-name": "Path 12119",
    className: "cls-27",
    d: "M361.334,1888.077a8.023,8.023,0,0,1,.394.825c.115.272.221.543.325.815s.2.545.3.824a2.572,2.572,0,0,0,.149.388.55.55,0,0,0,.287.291.523.523,0,0,1-.485-.115,1.58,1.58,0,0,1-.329-.373,3.943,3.943,0,0,1-.426-.823,4.041,4.041,0,0,1-.23-.9,2.909,2.909,0,0,1,.015-.935",
    transform: "translate(-326.042 -1703.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12120",
    "data-name": "Path 12120",
    className: "cls-27",
    d: "M330.192,1829.446a3.051,3.051,0,0,1,.48.618,4.879,4.879,0,0,1,.339.676,4.765,4.765,0,0,1,.231.72,3.023,3.023,0,0,1,.088.778,3.016,3.016,0,0,1-.481-.618,4.739,4.739,0,0,1-.338-.676,4.908,4.908,0,0,1-.231-.72,3.116,3.116,0,0,1-.089-.778",
    transform: "translate(-297.978 -1650.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12121",
    "data-name": "Path 12121",
    className: "cls-27",
    d: "M234.541,1797.5a2.8,2.8,0,0,1,1.148.148,1.85,1.85,0,0,1,.951.779,2.574,2.574,0,0,1,.353,1.14,3.593,3.593,0,0,1-.083,1.142c-.136-.362-.225-.722-.331-1.062a4.149,4.149,0,0,0-.4-.936,2.059,2.059,0,0,0-.676-.685c-.287-.185-.629-.33-.964-.524",
    transform: "translate(-211.66 -1622.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12122",
    "data-name": "Path 12122",
    className: "cls-27",
    d: "M159.338,1810.094a4.608,4.608,0,0,0,.9.363,9.011,9.011,0,0,1,.916.342,8.066,8.066,0,0,1,.87.444,5.015,5.015,0,0,1,.816.59,4.825,4.825,0,0,1-.982-.2,8.078,8.078,0,0,1-.927-.344,7.464,7.464,0,0,1-.879-.453,1.722,1.722,0,0,1-.71-.743",
    transform: "translate(-143.793 -1633.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12123",
    "data-name": "Path 12123",
    className: "cls-27",
    d: "M109.047,1756.906a.6.6,0,0,1,.49-.184,1.107,1.107,0,0,1,.521.178,5.115,5.115,0,0,1,.741.636,7.547,7.547,0,0,1,.63.713,4.613,4.613,0,0,1,.521.823,4.608,4.608,0,0,1-.821-.523,7.556,7.556,0,0,1-.711-.631c-.223-.218-.435-.48-.622-.686a1.114,1.114,0,0,0-.316-.253.669.669,0,0,0-.431-.073",
    transform: "translate(-98.409 -1585.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12124",
    "data-name": "Path 12124",
    className: "cls-27",
    d: "M85.084,1820.559a1.208,1.208,0,0,1,.859-.361,2.481,2.481,0,0,1,.914.147,8.45,8.45,0,0,1,.791.335,6.9,6.9,0,0,0,.794.325,1.619,1.619,0,0,1-.915.082,4.992,4.992,0,0,1-.846-.232,7.9,7.9,0,0,0-.772-.236,2.345,2.345,0,0,0-.826-.061",
    transform: "translate(-76.783 -1642.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12125",
    "data-name": "Path 12125",
    className: "cls-27",
    d: "M68.768,1894.045l.666,1.037c.221.335.453.657.693.972s.491.622.755.924l.824.916a3.7,3.7,0,0,1-1.112-.609,4.934,4.934,0,0,1-1.531-2.007,3.715,3.715,0,0,1-.3-1.233",
    transform: "translate(-62.059 -1709.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12126",
    "data-name": "Path 12126",
    className: "cls-27",
    d: "M368.062,1793.17a11.092,11.092,0,0,1,.8,1.318c.239.45.456.914.663,1.37s.415.9.658,1.332a6.16,6.16,0,0,0,.888,1.2,3.045,3.045,0,0,1-1.236-.964,6.356,6.356,0,0,1-.8-1.345c-.214-.47-.39-.945-.557-1.428a11.128,11.128,0,0,1-.412-1.485",
    transform: "translate(-332.155 -1618.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12127",
    "data-name": "Path 12127",
    className: "cls-27",
    d: "M364.281,1719.158a.462.462,0,0,1,.544.119,1.189,1.189,0,0,1,.262.519c.091.324.187.627.289.935s.214.61.337.915.255.611.377.947a2.776,2.776,0,0,1-.747-.745,3.694,3.694,0,0,1-.479-.944,3.749,3.749,0,0,1-.192-1.038,1.412,1.412,0,0,0-.062-.435.408.408,0,0,0-.331-.274",
    transform: "translate(-328.742 -1551.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12128",
    "data-name": "Path 12128",
    className: "cls-27",
    d: "M294.569,1745.154a.574.574,0,0,1,.439.121,1.368,1.368,0,0,1,.31.338,4.991,4.991,0,0,1,.375.738,5.657,5.657,0,0,1,.259.774,3.465,3.465,0,0,1,.116.833,3.5,3.5,0,0,1-.508-.671,5.546,5.546,0,0,1-.365-.729,6.451,6.451,0,0,1-.258-.762,1.1,1.1,0,0,0-.368-.643",
    transform: "translate(-265.831 -1574.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12129",
    "data-name": "Path 12129",
    className: "cls-27",
    d: "M432.814,1749.743a3.654,3.654,0,0,1,.772,1.03c.2.379.39.756.574,1.138.372.762.715,1.536,1.052,2.313s.65,1.564.943,2.359a8.9,8.9,0,0,1,.391,1.229,2.461,2.461,0,0,1-.031,1.291,4.98,4.98,0,0,0-.747-2.355c-.372-.762-.715-1.536-1.051-2.313s-.649-1.564-.942-2.359c-.15-.4-.288-.8-.428-1.2a5.059,5.059,0,0,0-.532-1.138",
    transform: "translate(-390.589 -1579.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12130",
    "data-name": "Path 12130",
    className: "cls-27",
    d: "M439.494,1829.889a2.106,2.106,0,0,1,.965.714,11.4,11.4,0,0,1,.727.91,11.218,11.218,0,0,1,.629.979,3.9,3.9,0,0,0,.288.469.65.65,0,0,0,.44.29.639.639,0,0,1-.615-.092,2.261,2.261,0,0,1-.455-.422,11.358,11.358,0,0,1-1.355-1.89,5.039,5.039,0,0,0-.624-.959",
    transform: "translate(-396.618 -1651.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12131",
    "data-name": "Path 12131",
    className: "cls-27",
    d: "M520,1737.871a2.926,2.926,0,0,1,.283.786,3.385,3.385,0,0,1,.075.826,2.7,2.7,0,0,1-.156.831,1.718,1.718,0,0,1-.468.713c.017-.29.042-.545.053-.8l.032-.761c.009-.255.02-.514.042-.779a4.151,4.151,0,0,1,.139-.813",
    transform: "translate(-469.031 -1568.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12132",
    "data-name": "Path 12132",
    className: "cls-27",
    d: "M562.142,1788.191a6.009,6.009,0,0,1,.2,1.05c.039.349.064.7.071,1.044s0,.7-.027,1.047a6,6,0,0,1-.156,1.057,4.863,4.863,0,0,1-.265-1.04,7.787,7.787,0,0,1-.092-1.052,7.952,7.952,0,0,1,.049-1.056,4.926,4.926,0,0,1,.22-1.05",
    transform: "translate(-507.055 -1613.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12133",
    "data-name": "Path 12133",
    className: "cls-27",
    d: "M547.843,1916.658a8.627,8.627,0,0,1,.06,1.355c-.01.448-.039.895-.089,1.339-.026.223-.053.441-.089.666a2.6,2.6,0,0,1-.2.7,1.331,1.331,0,0,1-.213.325,1.079,1.079,0,0,1-.314.232.693.693,0,0,1-.71-.028.683.683,0,0,0,.566-.2.963.963,0,0,0,.277-.485,3.332,3.332,0,0,0,.083-.608c.015-.219.036-.445.06-.666.049-.444.119-.886.208-1.326a8.687,8.687,0,0,1,.356-1.309",
    transform: "translate(-492.997 -1729.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12134",
    "data-name": "Path 12134",
    className: "cls-27",
    d: "M554.788,1971.443a2.8,2.8,0,0,1-.6.809,3.769,3.769,0,0,1-.815.592,3.726,3.726,0,0,1-.941.357,2.771,2.771,0,0,1-1.006.057c.3-.172.583-.31.863-.456s.555-.286.829-.433.543-.3.816-.455.549-.319.854-.471",
    transform: "translate(-497.63 -1779.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12135",
    "data-name": "Path 12135",
    className: "cls-27",
    d: "M430.775,2001.56a6.157,6.157,0,0,1,.909.382l.838.433c.275.142.548.279.83.405s.573.238.893.356a2.123,2.123,0,0,1-1.014.051,3.344,3.344,0,0,1-.958-.333,4.386,4.386,0,0,1-.824-.56,4.017,4.017,0,0,1-.674-.734",
    transform: "translate(-388.749 -1806.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12136",
    "data-name": "Path 12136",
    className: "cls-27",
    d: "M420.892,1965.24a3.744,3.744,0,0,1,.745.276,6.46,6.46,0,0,1,.665.375,6.3,6.3,0,0,1,.617.45,3.657,3.657,0,0,1,.559.565,2.758,2.758,0,0,1-.776-.2,4.145,4.145,0,0,1-.692-.361,4.279,4.279,0,0,1-.615-.481,2.8,2.8,0,0,1-.5-.624",
    transform: "translate(-379.831 -1773.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12137",
    "data-name": "Path 12137",
    className: "cls-27",
    d: "M365.8,1991.248a11.885,11.885,0,0,1,.945.939c.3.318.592.63.9.925a9.275,9.275,0,0,0,.962.821,7.588,7.588,0,0,0,1.113.672,2.8,2.8,0,0,1-1.328-.31,4.32,4.32,0,0,1-1.122-.8,5.911,5.911,0,0,1-.852-1.055,6.538,6.538,0,0,1-.613-1.2",
    transform: "translate(-330.114 -1796.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12138",
    "data-name": "Path 12138",
    className: "cls-27",
    d: "M404.925,2208.3a2.08,2.08,0,0,1-.8.131,2.9,2.9,0,0,1-1.52-.477,2.071,2.071,0,0,1-.582-.567,6.848,6.848,0,0,1,.762.183c.241.069.475.141.708.214l.7.23a7.461,7.461,0,0,1,.73.286",
    transform: "translate(-362.801 -1992.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12139",
    "data-name": "Path 12139",
    className: "cls-27",
    d: "M411.741,2187.893a2.429,2.429,0,0,1-.686-.142,3.918,3.918,0,0,1-.617-.278,3.859,3.859,0,0,1-.56-.38,2.417,2.417,0,0,1-.479-.512,2.527,2.527,0,0,1,.692.145,3.811,3.811,0,0,1,.611.276,3.882,3.882,0,0,1,.555.377,2.573,2.573,0,0,1,.485.514",
    transform: "translate(-369.458 -1973.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12140",
    "data-name": "Path 12140",
    className: "cls-27",
    d: "M410.844,2057.887a1.89,1.89,0,0,1-.231-.562,2.772,2.772,0,0,1-.079-.567,2.744,2.744,0,0,1,.037-.571.324.324,0,1,1,.424-.015,2.7,2.7,0,0,1,.077.566,2.811,2.811,0,0,1-.038.571,1.9,1.9,0,0,1-.191.576",
    transform: "translate(-370.481 -1855.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12141",
    "data-name": "Path 12141",
    className: "cls-27",
    d: "M499.639,1663.645a.283.283,0,0,1,.267-.028.71.71,0,0,1,.236.152,2.361,2.361,0,0,1,.306.412,4.085,4.085,0,0,1,.583,1.865,2.977,2.977,0,0,1-.1.984c-.131-.311-.223-.612-.32-.909l-.276-.883-.275-.883c-.048-.148-.083-.308-.135-.432s-.117-.263-.29-.278",
    transform: "translate(-450.895 -1501.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12142",
    "data-name": "Path 12142",
    className: "cls-27",
    d: "M364.62,1644.169a2.815,2.815,0,0,1,.273.636,4.694,4.694,0,0,1,.144.64,4.488,4.488,0,0,1,.053.654,2.789,2.789,0,0,1-.073.688,2.15,2.15,0,0,1-.344-.609,3.118,3.118,0,0,1-.169-.652,3.172,3.172,0,0,1-.031-.674,2.179,2.179,0,0,1,.147-.684",
    transform: "translate(-328.911 -1483.767)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempleWideCarousel);
export default __webpack_public_path__ + "static/media/temple-wide-carousel.ec0457f23eb765f10cb69d7c08362c66.svg";
export { ForwardRef as ReactComponent };